var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _path9, _polygon2, _polygon3, _polygon4, _path10, _polygon5, _polygon6, _path11, _path12, _path13, _path14, _path15, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _path16, _path17, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _rect, _polygon19, _rect2, _polygon20, _rect3, _path18, _polygon21, _polygon22, _polygon23, _polygon24, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _rect4, _rect5, _rect6, _rect7, _path25, _path26, _path27, _path28, _path29, _path30, _rect8, _rect9, _path31, _line, _polygon25, _polygon26, _path32, _path33, _path34, _polyline, _polyline2, _polygon27, _polyline3, _polyline4, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _polygon28, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _polygon29, _path127, _polygon30, _path128, _path129, _path130, _path131, _polygon31, _path132, _path133, _polygon32, _path134, _polygon33, _polygon34, _polygon35, _path135, _polygon36, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _polygon37, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _polygon38, _path161, _path162, _path163, _path164, _path165, _polygon39, _path166, _polygon40, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _polygon41, _path179, _path180, _path181, _path182, _path183, _polygon42, _path184, _polygon43, _path185, _path186, _polygon44, _path187, _polygon45, _path188, _polygon46, _path189, _path190, _path191, _polygon47, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _polygon48, _path199, _path200, _path201, _path202, _path203, _polygon49, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _polygon50, _path215, _path216, _path217, _path218, _polygon51, _path219, _polygon52, _path220, _path221, _path222, _path223, _polygon53, _path224, _path225, _path226, _polygon54, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _polygon55, _path239, _path240, _path241, _path242, _polygon56, _path243, _path244, _polygon57, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _polygon58, _path254, _path255, _path256, _path257, _polygon59, _path258, _path259, _polygon60, _path260, _path261, _polygon61, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _polygon62, _path294, _path295, _polygon63, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _polygon64, _path317, _path318, _polygon65, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _polygon66, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _polygon67, _path359, _polygon68, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _rect10, _rect11, _polygon69, _polygon70, _rect12, _rect13, _rect14, _path376, _rect15, _rect16, _rect17, _path377, _path378, _path379, _path380, _path381, _path382, _rect18, _rect19, _rect20, _path383, _rect21, _rect22, _rect23, _path384, _path385, _path386, _path387, _path388, _polyline5, _path389, _path390, _path391, _path392, _path393, _line2, _path394, _line3, _path395, _path396, _path397, _path398, _line4, _path399, _line5, _path400, _line6, _line7, _line8, _line9, _line10, _path401, _line11, _path402, _line12, _line13, _line14, _path403, _line15, _path404, _line16, _line17, _line18, _path405, _line19, _path406, _rect24, _rect25, _rect26, _path407, _path408, _path409, _rect27, _rect28, _rect29, _path410, _path411, _path412, _polygon71, _rect30, _rect31, _polygon72, _path413, _path414, _path415, _path416, _path417, _line20, _path418, _line21, _path419, _polygon73, _polygon74, _polygon75, _polygon76, _rect32, _rect33, _rect34, _polygon77, _polygon78, _rect35, _rect36, _polyline6, _line22, _path420, _line23, _path421, _line24, _line25, _line26, _line27, _line28, _path422, _line29, _path423, _line30, _line31, _line32, _path424, _line33, _path425, _line34, _line35, _line36, _path426, _line37, _path427, _polygon79, _rect37, _rect38, _polygon80, _polygon81, _polygon82, _polygon83, _rect39, _path428, _line38, _path429, _line39, _path430, _line40, _path431, _line41, _path432, _line42, _path433, _line43, _path434, _rect40, _rect41, _rect42, _rect43, _circle7, _circle8, _path435, _circle9, _circle10, _path436, _path437, _path438, _circle11, _circle12, _polygon84, _polygon85, _polygon86, _path439, _rect44, _path440, _path441, _line44, _line45, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _path451, _path452, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _polygon135, _polygon136, _polygon137, _polygon138, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _polyline7, _polyline8, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _rect45, _rect46, _rect47, _path501, _path502, _rect48, _rect49, _rect50, _path503, _path504, _rect51, _rect52, _rect53, _path505, _path506, _rect54, _rect55, _rect56, _path507, _path508, _polygon145, _polygon146, _polygon147, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _path509, _path510, _rect64, _rect65, _rect66, _rect67, _rect68, _path511, _path512, _path513, _path514, _polygon148, _polygon149, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _circle13, _path531, _path532, _path533, _circle14, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _circle15, _path542, _path543, _circle16, _circle17, _circle18, _circle19, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _circle20, _circle21, _circle22, _circle23, _circle24, _path555, _path556, _path557, _path558, _path559, _circle25, _path560, _circle26, _path561, _circle27, _path562, _circle28, _circle29, _path563, _path564, _path565, _circle30, _path566, _path567, _path568, _circle31, _path569, _circle32, _circle33, _circle34, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _circle35, _path579, _circle36, _path580, _circle37, _path581, _path582, _path583, _circle38, _path584, _path585, _path586, _path587, _path588, _polygon150, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _polygon151, _path645, _path646, _path647, _path648, _path649, _path650, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _path651, _path652, _rect80, _rect81, _rect82, _rect83, _path653, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _polygon152, _polygon153, _polygon154, _rect90, _path654, _path655, _path656, _path657, _rect91, _rect92, _rect93, _polygon155, _path658, _path659, _path660, _path661, _path662, _path663, _polygon156, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _polygon157, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _polygon158, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _polygon159, _path991, _path992, _path993, _polygon160, _path994, _path995, _path996, _polygon161, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _polygon162, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _polygon163, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _polygon164, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _polygon165, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _polygon166, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _polygon167, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _polygon168, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _polygon169, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _polygon170, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _polygon171, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _polygon172, _path1289, _path1290, _path1291, _path1292, _polygon173, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _polygon174, _path1302, _path1303, _path1304, _polygon175, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _polygon176, _path1322, _path1323, _path1324, _path1325, _path1326, _polygon177, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _polygon178, _path1345, _path1346, _polygon179, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _polygon180, _path1364, _path1365, _path1366, _polygon181, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _polygon182, _path1380, _path1381, _path1382, _polygon183, _path1383, _path1384, _polygon184, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _polygon185, _path1391, _path1392, _path1393, _path1394, _polygon186, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _polygon187, _path1412, _path1413, _path1414, _polygon188, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _polygon189, _path1432, _path1433, _path1434, _polygon190, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _polygon191, _path1454, _path1455, _polygon192, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _polygon193, _path1496, _path1497, _polygon194, _path1498, _path1499, _path1500, _path1501, _polygon195, _path1502, _path1503, _path1504, _polygon196, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _polygon197, _path1512, _path1513, _path1514, _polygon198, _path1515, _path1516, _path1517, _path1518, _path1519, _polygon199, _path1520, _path1521, _path1522, _path1523, _path1524, _polygon200, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _polygon201, _path1537, _path1538, _path1539, _polygon202, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _polygon203, _path1571, _path1572, _path1573, _polygon204, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _polygon205, _path1586, _path1587, _polygon206, _path1588, _path1589, _path1590, _path1591, _polygon207, _path1592, _path1593, _path1594, _polygon208, _path1595, _path1596, _path1597, _path1598, _path1599, _polygon209, _path1600, _path1601, _path1602, _path1603, _path1604, _polygon210, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _polygon211, _path1612, _path1613, _polygon212, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _polygon213, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _polygon214, _path1640, _polygon215, _path1641, _polygon216, _path1642, _path1643, _path1644, _path1645, _polygon217, _path1646, _polygon218, _path1647, _path1648, _path1649, _path1650, _path1651, _polygon219, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _rect94, _polygon220, _path1661, _path1662, _path1663, _path1664, _rect95, _rect96, _path1665, _path1666, _rect97, _circle39, _rect98, _rect99, _line46, _rect100, _rect101, _line47, _rect102, _rect103, _polygon221, _circle40, _circle41, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _circle42, _circle43, _polyline17, _polyline18, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _polygon222, _circle44, _path1673, _path1674, _circle45, _circle46, _circle47, _circle48, _path1675, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _path1676, _circle67, _path1677, _polygon223, _polygon224, _line48, _path1678, _path1679, _path1680, _circle68, _path1681, _path1682, _circle69, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _line49, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousesAndCars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Houses And Cars 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240,95.3V48.8l-11.1,1.9c-89.6,15.9-77.2-7.8-147.1-9.8C30,39.3,0,75.9,0,75.9v25.3H234.3A58,58,0,0,0,240,95.3Z",
    fill: "#98aab6",
    opacity: 0.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1,122.6c89.6-17.7,77.2,8.7,147.1,11,38.6,1.3,65.1-21,76.1-32.4H0v23.6Z",
    fill: "#98aab6",
    opacity: 0.86
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 114.5,
    r: 3.9,
    fill: "#395c6e"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 114.5,
    r: 2.5,
    fill: "#fffcf3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 194,
    cy: 114.5,
    r: 1.6,
    fill: "#bbc7d0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.6,
    cy: 114.5,
    r: 3.9,
    fill: "#395c6e"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.6,
    cy: 114.5,
    r: 2.5,
    fill: "#fffcf3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.6,
    cy: 114.5,
    r: 1.6,
    fill: "#bbc7d0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.3,105.4l-.2,9.1h10.5l.6-.9v-8.2Z",
    fill: "#bbc7d0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.5,113.3a3.1,3.1,0,0,1,1.5-.5h5.6a2.6,2.6,0,0,1,1.4.7c1.4-.2,2.7.2,4,.1v-8.2H216.5Z",
    fill: "#bbc7d0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1,105.4v6.3a3,3,0,0,1,2.4,2.8h6.3l.2-9.1Z",
    fill: "#bbc7d0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6,105.4a4.9,4.9,0,0,0-2.5.6c.9,1.3,1.4,4.3,1.7,6a.9.9,0,0,1,.6-.3h4.4v-6.3Z",
    fill: "#bbc7d0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.6,110.2a12.8,12.8,0,0,0-.3,4.3h3.6c0-.5.7-.1.8-.8a2.2,2.2,0,0,1,.8-1.5c-.3-1.6-.8-4.8-1.7-6.1A7.1,7.1,0,0,0,185.6,110.2Z",
    fill: "#bbc7d0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "205.3 104.1 216.2 103.8 216.2 99.4 205.4 99.3 205.3 104.1",
    fill: "#395c6e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M191.2,99.2l-2.1,6.3a6.9,6.9,0,0,1,2.5-1.1h4.2v-5Z",
    fill: "#395c6e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.7,105.8l2.1-6.6h-1.3c-.7,1.8-2.6,6.2-2.6,6.2a35.2,35.2,0,0,0-1.3,4.8A9.8,9.8,0,0,1,188.7,105.8Z",
    fill: "#395c6e"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.1 99.3 196.1 104.3 205 104.1 205.1 99.3 196.1 99.3",
    fill: "#395c6e"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.5 103.7 227.5 103.4 228.9 105.4 228.4 99.5 216.5 99.4 216.5 103.7",
    fill: "#395c6e"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.5 103.7 216.5 105.4 228.9 105.4 227.5 103.4 216.5 103.7",
    fill: "#395c6e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6,104.4a6.9,6.9,0,0,0-2.5,1.1v.3c0,.1.1.1.1.2a4.9,4.9,0,0,1,2.5-.6h4.2v-1.1Z",
    fill: "#395c6e"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.1 104.3 196.1 105.4 205 105.4 205 104.1 196.1 104.3",
    fill: "#395c6e"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.3 104.1 205.3 105.4 216.2 105.4 216.2 103.8 205.3 104.1",
    fill: "#395c6e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.8,106.1h-.1a9.8,9.8,0,0,0-3.1,4.4A7.1,7.1,0,0,1,188.8,106.1Z",
    fill: "#395c6e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M188.8,106.1c.9,1.3,1.4,4.5,1.7,6.1l.3-.2c-.3-1.7-.8-4.7-1.7-6Z",
    fill: "#bbc7d0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.2,99.2h-.4l-2.1,6.6.4-.3Z",
    fill: "#395c6e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M189.1,105.5l-.4.3h.4c0-.1-.1-.1-.1-.2Z",
    fill: "#395c6e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.8,105.4v6.3h.3v-6.3Z",
    fill: "#bbc7d0"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.8 99.3 195.8 104.3 196.1 104.3 196.1 99.3 195.8 99.3",
    fill: "#395c6e"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.8 104.3 195.8 105.4 196.1 105.4 196.1 104.3 195.8 104.3",
    fill: "#395c6e"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "205 105.4 204.8 114.5 205.1 114.5 205.3 105.4 205 105.4",
    fill: "#bbc7d0"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.1 99.3 205 104.1 205.3 104.1 205.4 99.3 205.1 99.3",
    fill: "#395c6e"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "205 104.1 205 105.4 205.3 105.4 205.3 104.1 205 104.1",
    fill: "#395c6e"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "228.4 99.1 216.5 99.1 216.5 99.2 228.4 99.3 228.4 99.5 228.4 99.1",
    fill: "#98aab6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190.9,99h25.3l-26.5-.2-.2.3V99Z",
    fill: "#98aab6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M190.9,99h-1.3v.2h1.3Z",
    fill: "#98aab6"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.5 99.2 216.5 99.4 228.4 99.5 228.4 99.3 216.5 99.2",
    fill: "#98aab6"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.2 99.4 216.2 99.2 205.4 99.1 205.4 99.3 216.2 99.4",
    fill: "#98aab6"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.1 99.3 205.1 99.1 196.1 99.1 196.1 99.3 205.1 99.3",
    fill: "#98aab6"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.8 99.3 195.8 99.1 191.2 99 191.2 99.2 195.8 99.3",
    fill: "#98aab6"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.2 99 190.9 98.9 190.9 99 191.2 99 191.2 99",
    fill: "#98aab6"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.2 99 190.9 99 190.8 99.2 191.2 99.2 191.2 99",
    fill: "#98aab6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 195.8,
    y: 99,
    width: 0.3,
    height: 0.05,
    fill: "#98aab6"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.1 99.3 196.1 99.1 195.8 99.1 195.8 99.3 196.1 99.3",
    fill: "#98aab6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 205.2,
    y: 98.9,
    width: 0.1,
    height: 0.33,
    transform: "translate(102.3 302.4) rotate(-88.9)",
    fill: "#98aab6"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "205.4 99.3 205.4 99.1 205.1 99.1 205.1 99.3 205.4 99.3",
    fill: "#98aab6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 216.2,
    y: 99,
    width: 0.3,
    height: 0.03,
    transform: "matrix(1, 0, 0, 1, -0.29, 0.63)",
    fill: "#98aab6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.2,105.4v8.2l.3-.3v-7.9Z",
    fill: "#bbc7d0"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.2 103.8 216.5 103.7 216.5 99.4 216.2 99.4 216.2 103.8",
    fill: "#395c6e"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.2 105.4 216.5 105.4 216.5 103.7 216.2 103.8 216.2 105.4",
    fill: "#395c6e"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.5 99.2 216.5 99.1 216.2 99.1 216.2 99.2 216.5 99.2",
    fill: "#98aab6"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.2 99.4 216.5 99.4 216.5 99.2 216.2 99.2 216.2 99.4",
    fill: "#98aab6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M226,97H209.3c-9.4-.2-17.1,0-17.1,0a2.4,2.4,0,0,0-2.4,1.8l-.2.3,38.8.3v-.5S227.6,97,226,97Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M190.4,103.5l.9-3.1c.1-.2.2-.3.4-.3h3.2a.4.4,0,0,1,.4.4v3.1c0,.2-.2.3-.4.3h-4.1C190.5,103.9,190.3,103.7,190.4,103.5Z",
    fill: "#e2e6ec"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7,100.5v3.1a.3.3,0,0,0,.3.3h7.1c.2,0,.4-.1.4-.3v-3.1a.4.4,0,0,0-.4-.4H197A.3.3,0,0,0,196.7,100.5Z",
    fill: "#e2e6ec"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.8,100.5v3.1c0,.2.2.3.4.3h7.4a.3.3,0,0,0,.3-.3v-3.1c0-.2-.1-.4-.3-.4h-7.4C218,100.2,217.8,100.3,217.8,100.5Z",
    fill: "#e2e6ec"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.4,100.5v3.1a.3.3,0,0,0,.3.3h9.1c.2,0,.4-.1.4-.3v-3.1a.4.4,0,0,0-.4-.4h-9.1A.3.3,0,0,0,206.4,100.5Z",
    fill: "#e2e6ec"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M228.1,100.1a1.1,1.1,0,0,0-.9,1V103a.9.9,0,0,0,.9.9h.7l-.4-3.8Z",
    fill: "#e2e6ec"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 187,
    cy: 108.5,
    rx: 0.7,
    ry: 2,
    fill: "#fff4d0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 107.4,
    width: 4.9,
    height: 0.33,
    fill: "#98aab6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 108.2,
    width: 4.9,
    height: 0.33,
    fill: "#98aab6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 109.1,
    width: 4.9,
    height: 0.33,
    fill: "#98aab6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 220.8,
    y: 109.9,
    width: 4.9,
    height: 0.33,
    fill: "#98aab6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M227.8,109.8A1.1,1.1,0,0,0,229,111v-3.4h-1.1Z",
    fill: "#fff4d0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M228.9,106.3s-1.1-.1-1.1.9h1.1Z",
    fill: "#fff4d0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M225.7,95.4h-3.1c-.8-1.6,2.1-2.4.6-2.4s-2.8,2.3-2.8,2.3c-9.7-.2-29.1-.4-29.8,1.2l36.6.2S227.6,95.4,225.7,95.4Z",
    fill: "#fbe7ab"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M224.6,113.2a8.9,8.9,0,0,1,1.4,1.3h3.7v-1.3Z",
    fill: "#fbde8b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M228.6,113.2c.6,0,.3-.7.9-.7s.8.2.9,1.1-.7.9-.7.9S227.9,113.2,228.6,113.2Z",
    fill: "#fbde8b"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M186.7,113.5a1.3,1.3,0,0,0-1.1-.8,1.1,1.1,0,0,0-1,.8h0s-.5,1.3,0,2h4.2s.7-.3.9-2Z",
    fill: "#fbde8b"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 195.9,
    y: 94.5,
    width: 0.6,
    height: 2.96,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 219.1,
    y: 94.5,
    width: 0.6,
    height: 2.96,
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M189.2,100.1h.5s.5-.1.3.7l-1.4,3c-.1.4-.7.6-.7.6l-.7.3Z",
    fill: "#e2e6ec"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 205.4,
    y1: 99.3,
    x2: 205.4,
    y2: 114.5,
    fill: "none",
    stroke: "#98aab6",
    strokeMiterlimit: 10,
    strokeWidth: 0.45
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.1 111.7 195.8 111.7 195.8 99.2 196.1 99.2 196.1 111.7",
    fill: "#98aab6"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.1 113.1 216.8 113.2 216.8 99.3 217.1 99.3 217.1 113.1",
    fill: "#98aab6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M190.9,111.9h-.3a6.2,6.2,0,0,0-2.5-5.4H188l3.1-7.4h.2l-3,7.3A6,6,0,0,1,190.9,111.9Z",
    fill: "#98aab6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2,77.5c-2.4.3-.5-.5-.7-1.9s-2.9,1-1.7-.9-.3-3.9-1.6-2.5-.7-.4-.7-1.2-.6-1.2-.7-1.2h0c-.2,0-.6.1-.7,1.2s.1,2.1-.8,1.2-2.5,1-1.5,2.5-1.5-.5-1.8.9,1.8,2.2-.6,1.9,1.2,4.6,5.1,3.6v2.7h.6V81.1c3.8,1,7.5-3.8,5.1-3.6",
    fill: "#395c6e"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3,77.5c-2.3.3-.4-.5-.6-1.9s-2.9,1-1.7-.9-.3-3.9-1.6-2.5-.7-.4-.8-1.2-.5-1.2-.6-1.2h-.1c-.1,0-.6.1-.7,1.2s1.4,1.1.6.2-2.6,1-1.6,2.6-.8-.4-1.8.7,2.8,3.5-1.9,3c-2.4-.2,1.3,5.2,5.1,4.3v2h.7v-2c3.8.9,7.5-4.5,5-4.3",
    fill: "#395c6e"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "86.5 41.5 87.1 41.5 87.1 40.5 84.7 40.5 84.5 40.5 82.2 40.5 82.2 41.5 82.8 41.5",
    fill: "#98aab6"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "82.8 41.5 82.8 44.2 84.5 45.5 84.5 46.5 86.5 48.7 86.5 41.5",
    fill: "#fdd058"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "84.7 40.5 84.5 40.5 82.2 40.5 82.2 41.5 82.8 41.5 82.8 44.2 84.5 45.5 84.5 46.5 86.5 48.7 86.5 41.5 87.1 41.5 87.1 40.5 84.7 40.5",
    fill: "none"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "91.1 77.6 91.1 53.4 76.7 39.9 62.3 53.4 62.3 77.6",
    fill: "#fff4d0"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "62.3 77.6 61.7 77.6 61.7 83.8 92 83.8 92 77.6 91.1 77.6",
    fill: "#fdd058"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2,56.4a1.2,1.2,0,0,0-1.3,1.2h0a1.4,1.4,0,0,1,1.3,1,1.4,1.4,0,0,1,1.3-1h0A1.2,1.2,0,0,0,82.2,56.4Z",
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3,57.7h0a1.3,1.3,0,0,0-2.6,0h0a1.4,1.4,0,0,1,1.3,1A1.4,1.4,0,0,1,69.3,57.7Z",
    fill: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,48.7a1.3,1.3,0,0,1,1.3,1,1.5,1.5,0,0,1,1.3-1L85,47.4A1.3,1.3,0,0,0,83.7,48.7Z",
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4,57.7h0A1.4,1.4,0,0,0,85,56.4a1.3,1.3,0,0,0-1.3,1.2h0a1.3,1.3,0,0,1,1.3,1A1.4,1.4,0,0,1,86.4,57.7Z",
    fill: "none"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,54.7a1.4,1.4,0,0,0-1.3-1.3h0v2.2A1.4,1.4,0,0,1,63.7,54.7Z",
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,56.4a1.4,1.4,0,0,0-1.4,1.2h0a1.4,1.4,0,0,1,1.4,1,1.4,1.4,0,0,1,1.3-1h0A1.2,1.2,0,0,0,87.9,56.4Z",
    fill: "none"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,50.4a1.2,1.2,0,0,0-1.3,1.2h0a1.4,1.4,0,0,1,1.3,1,1.4,1.4,0,0,1,1.4-1h0A1.4,1.4,0,0,0,76.5,50.4Z",
    fill: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,56.4a1.2,1.2,0,0,0-1.3,1.2h0a1.4,1.4,0,0,1,1.3,1,1.4,1.4,0,0,1,1.4-1h0A1.4,1.4,0,0,0,76.5,56.4Z",
    fill: "none"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2,56.4a1.4,1.4,0,0,0-1.4,1.2h0a1.4,1.4,0,0,1,1.4,1,1.3,1.3,0,0,1,1.3-1h0A1.3,1.3,0,0,0,65.2,56.4Z",
    fill: "none"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68,50.4a1.2,1.2,0,0,0-1.3,1.2h0a1.4,1.4,0,0,1,1.3,1,1.4,1.4,0,0,1,1.3-1h0A1.2,1.2,0,0,0,68,50.4Z",
    fill: "none"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M75,57.7h0a1.2,1.2,0,0,0-1.3-1.2,1.4,1.4,0,0,0-1.4,1.2h0a1.4,1.4,0,0,1,1.4,1A1.4,1.4,0,0,1,75,57.7Z",
    fill: "none"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,50.4a1.4,1.4,0,0,0-1.4,1.2h0a1.4,1.4,0,0,1,1.4,1,1.4,1.4,0,0,1,1.3-1h0A1.2,1.2,0,0,0,73.7,50.4Z",
    fill: "none"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,50.4A1.4,1.4,0,0,0,78,51.6h0a1.4,1.4,0,0,1,1.4,1,1.3,1.3,0,0,1,1.3-1h0A1.3,1.3,0,0,0,79.4,50.4Z",
    fill: "none"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,56.4a1.3,1.3,0,0,0-1.3,1.2h0a1.3,1.3,0,0,1,1.3,1,1.4,1.4,0,0,1,1.4-1h0A1.4,1.4,0,0,0,70.8,56.4Z",
    fill: "none"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M85,50.4a1.3,1.3,0,0,0-1.3,1.2h0a1.3,1.3,0,0,1,1.3,1,1.4,1.4,0,0,1,1.4-1h0A1.4,1.4,0,0,0,85,50.4Z",
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2,50.4a1.2,1.2,0,0,0-1.3,1.2h0a1.4,1.4,0,0,1,1.3,1,1.4,1.4,0,0,1,1.3-1h0A1.2,1.2,0,0,0,82.2,50.4Z",
    fill: "none"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,47.4a1.5,1.5,0,0,0-1.4,1.3,1.4,1.4,0,0,1,1.4,1,1.4,1.4,0,0,1,1.3-1A1.3,1.3,0,0,0,73.7,47.4Z",
    fill: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,47.4a1.3,1.3,0,0,0-1.3,1.3,1.4,1.4,0,0,1,1.3,1,1.4,1.4,0,0,1,1.4-1A1.5,1.5,0,0,0,76.5,47.4Z",
    fill: "none"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2,47.4a1.3,1.3,0,0,0-1.3,1.3,1.4,1.4,0,0,1,1.3,1,1.4,1.4,0,0,1,1.3-1A1.3,1.3,0,0,0,82.2,47.4Z",
    fill: "none"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,47.4a1.3,1.3,0,0,0-1.3,1.3,1.3,1.3,0,0,1,1.3,1,1.5,1.5,0,0,1,1.4-1A1.3,1.3,0,0,0,70.8,47.4Z",
    fill: "none"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,57.7h0a1.3,1.3,0,0,0-1.3-1.2A1.4,1.4,0,0,0,78,57.6h0a1.4,1.4,0,0,1,1.4,1A1.3,1.3,0,0,1,80.7,57.7Z",
    fill: "none"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,50.4a1.3,1.3,0,0,0-1.3,1.2h0a1.3,1.3,0,0,1,1.3,1,1.4,1.4,0,0,1,1.4-1h0A1.4,1.4,0,0,0,70.8,50.4Z",
    fill: "none"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,47.4A1.3,1.3,0,0,0,78,48.7a1.4,1.4,0,0,1,1.4,1,1.3,1.3,0,0,1,1.3-1A1.3,1.3,0,0,0,79.4,47.4Z",
    fill: "none"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,51.6h0a1.4,1.4,0,0,1,1.4,1,1.4,1.4,0,0,1,1.3-1h0l-1.1-1.1h-.2A1.4,1.4,0,0,0,86.5,51.6Z",
    fill: "none"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2,55.7a1.4,1.4,0,0,1,1.3-1,1.3,1.3,0,1,0-2.6,0A1.4,1.4,0,0,1,82.2,55.7Z",
    fill: "none"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,42.3h0a1.5,1.5,0,0,1,1.4-1,1.3,1.3,0,0,1,1.4,1,1.9,1.9,0,0,1,1-1l-1.4-1.4a1.4,1.4,0,0,0-.9,1.3h-.2a1.6,1.6,0,0,0-.5-1.1l-1.4,1.4A1.6,1.6,0,0,1,75.1,42.3Z",
    fill: "none"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,43.7a1.5,1.5,0,0,1,1.3-1,1.3,1.3,0,0,0-.6-1.1l-1.3,1.3A1.6,1.6,0,0,1,73.7,43.7Z",
    fill: "none"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,51.3a1.4,1.4,0,0,1,2.8,0h0a1.6,1.6,0,0,1,1.4-1.1,1.6,1.6,0,0,1,1.5,1.1,1.4,1.4,0,0,1,1.4-1.1,1.5,1.5,0,0,1,1.4,1.1h0a1.6,1.6,0,0,1,1.4-1.1,1.4,1.4,0,0,1,1.4,1.1,1.6,1.6,0,0,1,1.5-1.1,1.6,1.6,0,0,1,1.4,1.1h0a1.4,1.4,0,0,1,2.8,0A1.6,1.6,0,0,1,85,50.2a1.6,1.6,0,0,1,1.5,1.1h0a1.4,1.4,0,0,1,1.4-1.1h-.1l-1.3-1.3h0a1.4,1.4,0,0,0-1.4,1.4H85a1.4,1.4,0,0,0-1.4-1.4,1.3,1.3,0,0,0-1.3,1.3h-.2a1.9,1.9,0,0,0-.2-.7,1.5,1.5,0,0,0-1.1-.6h0a1.4,1.4,0,0,0-1.1.6,1.1,1.1,0,0,0-.3.8h-.1a1.4,1.4,0,0,0-1.4-1.4,1.3,1.3,0,0,0-1.3,1.3h-.2a1.3,1.3,0,0,0-1.3-1.3h0a1.3,1.3,0,0,0-1.3,1.4h-.2a1.4,1.4,0,0,0-2.7-.1h-.1a1.3,1.3,0,0,0-1.4-1.3h0a1.3,1.3,0,0,0-1.3,1.4h-.2a1.4,1.4,0,0,0-.9-1.3l-1.5,1.4A1.6,1.6,0,0,1,66.6,51.3Z",
    fill: "none"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,40.7a2,2,0,0,1,.9-.9l-.6-.5L76,40A1.5,1.5,0,0,1,76.5,40.7Z",
    fill: "none"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,45.3a1.3,1.3,0,0,1,1.4-1,1.4,1.4,0,0,1,1.4,1h0a1.5,1.5,0,0,1,1.4-1,1.3,1.3,0,0,1,1.4,1,1.5,1.5,0,0,1,1.5-1,1.5,1.5,0,0,1,1.4,1h0a1.4,1.4,0,0,1,1.1-1l-1.4-1.4a.8.8,0,0,0-.8.5,1.1,1.1,0,0,0-.3.8h-.1a1.4,1.4,0,0,0-1.4-1.4,1.3,1.3,0,0,0-1.3,1.4h-.2a1.3,1.3,0,0,0-1.3-1.4h0a1.3,1.3,0,0,0-1.3,1.4h-.2A1.4,1.4,0,0,0,73,43l-1.5,1.4A1.8,1.8,0,0,1,72.3,45.3Z",
    fill: "none"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68,49.7a1.4,1.4,0,0,1,1.3-1,1.2,1.2,0,0,0-.9-1.2l-1.3,1.3A1.4,1.4,0,0,1,68,49.7Z",
    fill: "none"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,46.7a1.5,1.5,0,0,1,1.4-1h0a1.5,1.5,0,0,0-.8-1.1l-1.3,1.3A1.3,1.3,0,0,1,70.8,46.7Z",
    fill: "none"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,48.3h0a1.5,1.5,0,0,1,1.4-1,1.5,1.5,0,0,1,1.5,1,1.5,1.5,0,0,1,2.8,0h0a1.5,1.5,0,0,1,1.4-1,1.3,1.3,0,0,1,1.4,1,1.5,1.5,0,0,1,1.5-1,1.5,1.5,0,0,1,1.4,1h0a1.5,1.5,0,0,1,2.8,0,1.4,1.4,0,0,1,1.3-1l-1.4-1.5a1.4,1.4,0,0,0-1.2,1.4h-.2a1.3,1.3,0,0,0-1.3-1.4h0a1.3,1.3,0,0,0-1.4,1.3h-.1a1.4,1.4,0,0,0-2.7.1h-.2a1.3,1.3,0,0,0-1.3-1.4h0a1.3,1.3,0,0,0-1.3,1.3h-.2a1.3,1.3,0,0,0-1.3-1.3,1.4,1.4,0,0,0-1.4,1.4h-.1a1.7,1.7,0,0,0-.8-1.3l-1.5,1.5A1.2,1.2,0,0,1,69.4,48.3Z",
    fill: "none"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M78,42.7a1.5,1.5,0,0,1,1.4,1,1.6,1.6,0,0,1,1-1L79,41.4A1.5,1.5,0,0,0,78,42.7Z",
    fill: "none"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,57.8a1.3,1.3,0,0,0-1.4,1.3h2.7A1.3,1.3,0,0,0,72.3,57.8Z",
    fill: "none"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,57.8h0a1.3,1.3,0,0,0-1.4,1.3h2.7A1.3,1.3,0,0,0,80.8,57.8Z",
    fill: "none"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.8h0a1.3,1.3,0,0,0-1.3,1.3h2.7A1.3,1.3,0,0,0,69.4,57.8Z",
    fill: "none"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,45.6h0a1.5,1.5,0,0,1,1.3,1,1.6,1.6,0,0,1,1.1-1L82,44.4A1.3,1.3,0,0,0,80.9,45.6Z",
    fill: "none"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,57.8h0a1.3,1.3,0,0,0-1.3,1.3h2.6A1.3,1.3,0,0,0,75.1,57.8Z",
    fill: "none"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,57.8a1.3,1.3,0,0,0-1.3,1.3h2.7A1.3,1.3,0,0,0,77.9,57.8Z",
    fill: "none"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,41.4a1.3,1.3,0,0,0-1.3,1.3,1.5,1.5,0,0,1,1.3,1,1.5,1.5,0,0,1,1.4-1A1.5,1.5,0,0,0,76.5,41.4Z",
    fill: "none"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,57.8a1.5,1.5,0,0,0-1.4,1.3h2.7A1.3,1.3,0,0,0,89.3,57.8Z",
    fill: "none"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4,57.6h0a1.4,1.4,0,0,1,1.3,1l.4-.6V56.4h-.4A1.2,1.2,0,0,0,89.4,57.6Z",
    fill: "none"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M85,55.7a1.4,1.4,0,0,1,1.4-1A1.4,1.4,0,0,0,85,53.4a1.3,1.3,0,0,0-1.3,1.3A1.3,1.3,0,0,1,85,55.7Z",
    fill: "none"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7,58.4a1.3,1.3,0,0,0-2.2,0,1.1,1.1,0,0,0-.3.7h2.7A1.9,1.9,0,0,0,67.7,58.4Z",
    fill: "none"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8,59.1h.3v-.8a1.1,1.1,0,0,0-.3.8Z",
    fill: "none"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7,56.2h-.1a1.3,1.3,0,0,0-1.3-1.4,1.5,1.5,0,0,0-1.4,1.3h-.1a1.3,1.3,0,0,0-1.3-1.3h0a1.4,1.4,0,0,0-1.4,1.4H85a1.4,1.4,0,0,0-1.4-1.4,1.3,1.3,0,0,0-1.3,1.3h-.2a1.9,1.9,0,0,0-.2-.7,1.3,1.3,0,0,0-1.1-.6h0a1.1,1.1,0,0,0-1.1.6,1.1,1.1,0,0,0-.3.8h-.1a1.4,1.4,0,0,0-1.4-1.4,1.3,1.3,0,0,0-1.3,1.3h-.2a1.3,1.3,0,0,0-1.3-1.3h0a1.3,1.3,0,0,0-1.3,1.4h-.2a1.4,1.4,0,0,0-2.7-.1h-.1a1.3,1.3,0,0,0-1.4-1.3h0a1.3,1.3,0,0,0-1.3,1.4h-.2a1.4,1.4,0,0,0-2.7-.1h-.1a1.3,1.3,0,0,0-1.4-1.3h0a1.3,1.3,0,0,0-1.3,1.4h0a1.5,1.5,0,0,1,1.3,1.1h0a1.6,1.6,0,0,1,1.5-1.1,1.6,1.6,0,0,1,1.4,1.1,1.4,1.4,0,0,1,2.8,0h0a1.6,1.6,0,0,1,1.4-1.1,1.6,1.6,0,0,1,1.5,1.1,1.4,1.4,0,0,1,1.4-1.1,1.5,1.5,0,0,1,1.4,1.1h0a1.6,1.6,0,0,1,1.4-1.1,1.4,1.4,0,0,1,1.4,1.1,1.6,1.6,0,0,1,1.5-1.1,1.6,1.6,0,0,1,1.4,1.1h0a1.4,1.4,0,0,1,2.8,0A1.6,1.6,0,0,1,85,56.2a1.6,1.6,0,0,1,1.5,1.1h0a1.4,1.4,0,0,1,1.4-1.1,1.6,1.6,0,0,1,1.4,1.1,1.5,1.5,0,0,1,1.4-1.1h.4v-1a1.4,1.4,0,0,0-.3.9Z",
    fill: "none"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2,52.7a1.3,1.3,0,0,1,1.3-1h0a1.4,1.4,0,0,0-1.1-1.2l-1.3,1.3A1.6,1.6,0,0,1,65.2,52.7Z",
    fill: "none"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4,54.7a1.4,1.4,0,0,1,1.3,1l.4-.6V53.4h-.4A1.3,1.3,0,0,0,89.4,54.7Z",
    fill: "none"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,55.7a1.4,1.4,0,0,1,1.3-1,1.3,1.3,0,0,0-1.3-1.3,1.5,1.5,0,0,0-1.4,1.3A1.4,1.4,0,0,1,87.9,55.7Z",
    fill: "none"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8,53.1h-.2v-.2l-1.1-1.1h-.2a1.4,1.4,0,0,0-1.4,1.4h-.1a1.3,1.3,0,0,0-1.3-1.4h0a1.3,1.3,0,0,0-1.4,1.3H85a1.4,1.4,0,0,0-2.7.1h-.2a1.3,1.3,0,0,0-1.3-1.4h0a1.3,1.3,0,0,0-1.4,1.3h-.1a1.4,1.4,0,0,0-2.7.1h-.2a1.3,1.3,0,0,0-1.3-1.4h0a1.3,1.3,0,0,0-1.3,1.3h-.2a1.3,1.3,0,0,0-1.3-1.3,1.4,1.4,0,0,0-1.4,1.4h-.1a1.4,1.4,0,0,0-1.4-1.4h0a1.3,1.3,0,0,0-1.3,1.3h-.2a1.9,1.9,0,0,0-.2-.7,1.3,1.3,0,0,0-2.2,0,1.1,1.1,0,0,0-.3.8h-.1A1.4,1.4,0,0,0,64,51.8l-1.5,1.5a1.2,1.2,0,0,1,1.2,1h0a1.6,1.6,0,0,1,1.5-1.1,1.6,1.6,0,0,1,1.4,1.1,1.4,1.4,0,0,1,2.8,0h0a1.6,1.6,0,0,1,1.4-1.1,1.6,1.6,0,0,1,1.5,1.1,1.4,1.4,0,0,1,2.8,0h0a1.6,1.6,0,0,1,1.4-1.1,1.4,1.4,0,0,1,1.4,1.1,1.6,1.6,0,0,1,1.5-1.1,1.6,1.6,0,0,1,1.4,1.1h0a1.4,1.4,0,0,1,2.8,0A1.6,1.6,0,0,1,85,53.2a1.6,1.6,0,0,1,1.5,1.1h0a1.4,1.4,0,0,1,1.4-1.1,1.6,1.6,0,0,1,1.4,1.1,1.5,1.5,0,0,1,1.4-1.1h.2v-.2Z",
    fill: "none"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6,57.8a1.3,1.3,0,0,0-1.3,1.3H85A1.3,1.3,0,0,0,83.6,57.8Z",
    fill: "none"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2,55.7a1.3,1.3,0,0,1,1.3-1,1.3,1.3,0,0,0-1.3-1.3,1.4,1.4,0,0,0-1.4,1.3A1.4,1.4,0,0,1,65.2,55.7Z",
    fill: "none"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M68,55.7a1.4,1.4,0,0,1,1.3-1,1.3,1.3,0,1,0-2.6,0A1.4,1.4,0,0,1,68,55.7Z",
    fill: "none"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,55.7a1.4,1.4,0,0,1,1.4-1,1.5,1.5,0,0,0-1.4-1.3,1.3,1.3,0,0,0-1.3,1.3A1.4,1.4,0,0,1,76.5,55.7Z",
    fill: "none"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,55.7a1.3,1.3,0,0,1,1.3-1,1.3,1.3,0,0,0-1.3-1.3A1.3,1.3,0,0,0,78,54.7,1.4,1.4,0,0,1,79.4,55.7Z",
    fill: "none"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,55.7a1.5,1.5,0,0,1,1.4-1,1.3,1.3,0,0,0-1.4-1.3,1.3,1.3,0,0,0-1.3,1.3A1.3,1.3,0,0,1,70.8,55.7Z",
    fill: "none"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,55.7a1.4,1.4,0,0,1,1.3-1,1.3,1.3,0,0,0-1.3-1.3,1.5,1.5,0,0,0-1.4,1.3A1.4,1.4,0,0,1,73.7,55.7Z",
    fill: "none"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,57.8h0a1.3,1.3,0,0,0-1.4,1.3h2.7A1.3,1.3,0,0,0,86.5,57.8Z",
    fill: "none"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.8h0a1.3,1.3,0,0,0-1.3,1.3h2.7A1.3,1.3,0,0,0,63.7,57.8Z",
    fill: "none"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,44.4a1.4,1.4,0,0,0-1.4,1.2h0a1.4,1.4,0,0,1,1.4,1,1.4,1.4,0,0,1,1.3-1h0A1.2,1.2,0,0,0,73.7,44.4Z",
    fill: "none"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,44.4a1.2,1.2,0,0,0-1.3,1.2h0a1.5,1.5,0,0,1,1.3,1,1.5,1.5,0,0,1,1.4-1h0A1.4,1.4,0,0,0,76.5,44.4Z",
    fill: "none"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.7h0a1.3,1.3,0,0,0-1.3-1.2v2.2A1.4,1.4,0,0,1,63.7,57.7Z",
    fill: "none"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,44.4A1.4,1.4,0,0,0,78,45.6h0a1.4,1.4,0,0,1,1.4,1,1.3,1.3,0,0,1,1.3-1h0A1.3,1.3,0,0,0,79.4,44.4Z",
    fill: "none"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.6 59.1 90.6 59.1 90.6 59.1 90.6 59.1",
    fill: "#fbe7ab"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7,58.7a.6.6,0,0,1,.1.4,1.1,1.1,0,0,1,.3-.8v-.2Z",
    fill: "#fbe7ab"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,57.8a1.5,1.5,0,0,0-1.4,1.3h0A1.5,1.5,0,0,1,89.3,57.8Z",
    fill: "#fbe7ab"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4,57.7h0Z",
    fill: "#fbe7ab"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,57.7h0a1.3,1.3,0,0,1,1.3,1.3h0a.8.8,0,0,1,.1-.4A1.4,1.4,0,0,0,86.5,57.7Z",
    fill: "#fbe7ab"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,57.8h-.1a1.4,1.4,0,0,0-1.3,1,.8.8,0,0,0-.1.4h.1A1.5,1.5,0,0,1,89.3,57.8Z",
    fill: "#fbe7ab"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7,58.7a1.4,1.4,0,0,0-1.3-1h-.1a1.3,1.3,0,0,1,1.3,1.3h.2A.6.6,0,0,0,90.7,58.7Z",
    fill: "#fbe7ab"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,57.8Z",
    fill: "#fbe7ab"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,57.6v.2h0Z",
    fill: "#fbe7ab"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2,57.6h0Z",
    fill: "#fbe7ab"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6,53.2h0Z",
    fill: "#fbe7ab"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8,53.1Z",
    fill: "#fbe7ab"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,53.2h0a1.4,1.4,0,0,1,1.4-1.4A1.4,1.4,0,0,0,87.9,53.2Z",
    fill: "#fbe7ab"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,51.7h0a1.3,1.3,0,0,1,1.3,1.4.9.9,0,0,1,.1-.5A1.4,1.4,0,0,0,86.5,51.7Z",
    fill: "#fbe7ab"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2,51.7h0a1.4,1.4,0,0,0-1.3,1,.9.9,0,0,0-.1.5h.1a1.4,1.4,0,0,1,1.4-1.4Z",
    fill: "#fbe7ab"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,51.8h0Z",
    fill: "#fbe7ab"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6,53.2h.2l-.2-.2v.2Z",
    fill: "#fbe7ab"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,51.8Z",
    fill: "#fbe7ab"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2,51.6h0Z",
    fill: "#fbe7ab"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,51.8h0Z",
    fill: "#fbe7ab"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,57.3a.4.4,0,0,0,.1.3h0a1.2,1.2,0,0,1,1.3-1.2h0A1.5,1.5,0,0,0,89.3,57.3Z",
    fill: "#fbe7ab"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6,56.2c0-.2.1-.3.1-.5a1.4,1.4,0,0,0-1.3-1h-.1A1.3,1.3,0,0,1,90.6,56.2Z",
    fill: "#fbe7ab"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,55.7v.4a1.5,1.5,0,0,1,1.4-1.3h-.1A1.4,1.4,0,0,0,87.9,55.7Z",
    fill: "#fbe7ab"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8,56.2h0Z",
    fill: "#fbe7ab"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,54.7h0a1.5,1.5,0,0,1,1.4,1.5h0v-.4A1.4,1.4,0,0,0,86.5,54.7Z",
    fill: "#fbe7ab"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7,55.7c0,.2-.1.3-.1.5h.2a1.4,1.4,0,0,1,.3-.9v-.2Z",
    fill: "#fbe7ab"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4,54.7Z",
    fill: "#fbe7ab"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,54.7h0a1.5,1.5,0,0,1,1.4-1.3,1.3,1.3,0,0,1,1.3,1.3h0c0-.1.1-.3.1-.4a1.6,1.6,0,0,0-1.4-1.1,1.4,1.4,0,0,0-1.4,1.1Z",
    fill: "#fbe7ab"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,54.3c0,.1-.1.3-.1.4h.2a1.3,1.3,0,0,1,1.3-1.3h0A1.5,1.5,0,0,0,89.3,54.3Z",
    fill: "#fbe7ab"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 57.3 86.5 57.3 86.5 57.3 86.5 57.3",
    fill: "#fbe7ab"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,57.6h0a1.4,1.4,0,0,1,1.4-1.2,1.2,1.2,0,0,1,1.3,1.2h.2a.4.4,0,0,1-.1-.3,1.6,1.6,0,0,0-1.4-1.1,1.4,1.4,0,0,0-1.4,1.1h0Z",
    fill: "#fbe7ab"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 54.8 86.5 54.8 86.5 54.8 86.5 54.8",
    fill: "#fbe7ab"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,56.2a1.5,1.5,0,0,0-1.4-1.5h0a1.3,1.3,0,0,1,1.3,1.3h.1Z",
    fill: "#fbe7ab"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,54.8h0v-.4h0Z",
    fill: "#fbe7ab"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,50.2Z",
    fill: "#fbe7ab"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,50.2Z",
    fill: "#fbe7ab"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 51.3 86.5 51.3 86.5 51.3 86.5 51.3",
    fill: "#fbe7ab"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,51.3h0v.3h0a1.4,1.4,0,0,1,1.4-1.2h0A1.4,1.4,0,0,0,86.5,51.3Z",
    fill: "#fbe7ab"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,51.6h0Z",
    fill: "#fbe7ab"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 48.8 86.5 48.8 86.5 48.8 86.5 48.8",
    fill: "#fbe7ab"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9,50.2Z",
    fill: "#fbe7ab"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 48.8 86.5 48.8 86.5 48.8 86.5 48.8",
    fill: "#fbe7ab"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 48.8 86.5 48.8 86.5 48.8 86.5 48.8 86.5 48.8",
    fill: "#fbe7ab"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    points: "85 59.1 85 59.1 85 59.1 85 59.1",
    fill: "#fbe7ab"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4,57.7h0a1.4,1.4,0,0,0-1.4,1,.6.6,0,0,1,.1.4,1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 57.8 86.5 57.8 86.5 57.8 86.5 57.8",
    fill: "#fbe7ab"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,57.6h0Z",
    fill: "#fbe7ab"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4,57.7h0Z",
    fill: "#fbe7ab"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,57.6h0Z",
    fill: "#fbe7ab"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,57.7h-.1a1.3,1.3,0,0,1,1.3,1.3h0c0-.1.1-.2.1-.4A1.4,1.4,0,0,0,80.9,57.7Z",
    fill: "#fbe7ab"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6,57.8h-.1a1.4,1.4,0,0,0-1.3,1c0,.2-.1.3-.1.4h.2A1.3,1.3,0,0,1,83.6,57.8Z",
    fill: "#fbe7ab"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M85,58.7a1.3,1.3,0,0,0-1.3-1h-.1A1.3,1.3,0,0,1,85,59.1h.1A.6.6,0,0,0,85,58.7Z",
    fill: "#fbe7ab"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,57.8Z",
    fill: "#fbe7ab"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,57.6v.2h0Z",
    fill: "#fbe7ab"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5,57.6h0Z",
    fill: "#fbe7ab"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.5 51.8 86.5 51.8 86.5 51.8 86.5 51.8",
    fill: "#fbe7ab"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4,51.7h0a1.4,1.4,0,0,0-1.4,1,.8.8,0,0,1,.1.4,1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M85,53.2h0Z",
    fill: "#fbe7ab"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4,51.7Z",
    fill: "#fbe7ab"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,51.6h0Z",
    fill: "#fbe7ab"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,51.6h0Z",
    fill: "#fbe7ab"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,51.7h-.1a1.3,1.3,0,0,1,1.3,1.4c0-.2.1-.3.1-.5A1.4,1.4,0,0,0,80.9,51.7Z",
    fill: "#fbe7ab"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,51.7h-.1A1.3,1.3,0,0,1,85,53.1h.1a.8.8,0,0,0-.1-.4A1.3,1.3,0,0,0,83.7,51.7Z",
    fill: "#fbe7ab"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5,51.7h0a1.4,1.4,0,0,0-1.3,1c0,.2-.1.3-.1.5h.2a1.3,1.3,0,0,1,1.3-1.4Z",
    fill: "#fbe7ab"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,51.8Z",
    fill: "#fbe7ab"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,51.6v.2h0Z",
    fill: "#fbe7ab"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,51.7Z",
    fill: "#fbe7ab"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,57.6A1.3,1.3,0,0,1,85,56.4a1.4,1.4,0,0,1,1.4,1.2h0a.4.4,0,0,1,.1-.3h0A1.6,1.6,0,0,0,85,56.2a1.6,1.6,0,0,0-1.4,1.1c0,.1.1.2.1.3Z",
    fill: "#fbe7ab"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,57.3a.4.4,0,0,0-.1.3h.1Z",
    fill: "#fbe7ab"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5,54.7h0a1.4,1.4,0,0,0-1.3,1c0,.1.1.3.1.4a1.3,1.3,0,0,1,1.3-1.3Z",
    fill: "#fbe7ab"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,54.7h-.1A1.4,1.4,0,0,1,85,56.2v-.5A1.3,1.3,0,0,0,83.7,54.7Z",
    fill: "#fbe7ab"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1,56.2h0Z",
    fill: "#fbe7ab"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 54.8 80.8 54.8 80.8 54.8 80.8 54.8 80.8 54.8",
    fill: "#fbe7ab"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,54.7h0a1.5,1.5,0,0,1,1.4,1.5h0c0-.1-.1-.3-.1-.4A1.4,1.4,0,0,0,80.9,54.7Z",
    fill: "#fbe7ab"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4,54.7h0a1.4,1.4,0,0,0-1.4,1v.5h.1a1.4,1.4,0,0,1,1.4-1.4h-.1Z",
    fill: "#fbe7ab"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,54.7Z",
    fill: "#fbe7ab"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,54.7h.1a1.3,1.3,0,1,1,2.6,0h0c0-.1.1-.3.1-.4a1.4,1.4,0,0,0-2.8,0Z",
    fill: "#fbe7ab"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5,54.7h.2A1.3,1.3,0,0,1,85,53.4a1.4,1.4,0,0,1,1.4,1.3h.1v-.5A1.6,1.6,0,0,0,85,53.2a1.6,1.6,0,0,0-1.4,1.1C83.6,54.4,83.5,54.6,83.5,54.7Z",
    fill: "#fbe7ab"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 57.3 80.8 57.3 80.8 57.3 80.8 57.3",
    fill: "#fbe7ab"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,57.6h.1a1.3,1.3,0,0,1,2.6,0h.2c0-.1-.1-.2-.1-.3a1.4,1.4,0,0,0-2.8,0h0Z",
    fill: "#fbe7ab"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 54.8 80.8 54.8 80.8 54.8 80.8 54.8",
    fill: "#fbe7ab"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,54.7h-.1a1.3,1.3,0,0,1,1.1.6,1.9,1.9,0,0,1,.2.7h.2A1.5,1.5,0,0,0,80.9,54.7Z",
    fill: "#fbe7ab"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,54.8h0v-.4h0Z",
    fill: "#fbe7ab"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,45.7h-.1a1.3,1.3,0,0,1,1.3,1.4c0-.2.1-.3.1-.5A1.5,1.5,0,0,0,80.9,45.7Z",
    fill: "#fbe7ab"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2,46.7c0,.2-.1.3-.1.5h.2a1.4,1.4,0,0,1,1.2-1.4h-.2A1.6,1.6,0,0,0,82.2,46.7Z",
    fill: "#fbe7ab"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,45.8Z",
    fill: "#fbe7ab"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,45.8h0Z",
    fill: "#fbe7ab"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,51.6A1.3,1.3,0,0,1,85,50.4a1.4,1.4,0,0,1,1.4,1.2h0a.4.4,0,0,1,.1-.3h0A1.6,1.6,0,0,0,85,50.2a1.6,1.6,0,0,0-1.4,1.1c0,.1.1.2.1.3Z",
    fill: "#fbe7ab"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,51.6v-.3a.4.4,0,0,0-.1.3Z",
    fill: "#fbe7ab"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1,50.2h0Z",
    fill: "#fbe7ab"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5,48.7h0a1.4,1.4,0,0,0-1.3,1c0,.2.1.3.1.4a1.3,1.3,0,0,1,1.3-1.3Z",
    fill: "#fbe7ab"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,48.7h-.1A1.4,1.4,0,0,1,85,50.2v-.5A1.3,1.3,0,0,0,83.7,48.7Z",
    fill: "#fbe7ab"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,48.7h0a1.5,1.5,0,0,1,1.4,1.5h0c0-.1-.1-.2-.1-.4A1.4,1.4,0,0,0,80.9,48.7Z",
    fill: "#fbe7ab"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 48.8 80.8 48.8 80.8 48.8 80.8 48.8 80.8 48.8",
    fill: "#fbe7ab"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M85,49.7v.5h.1a1.4,1.4,0,0,1,1.4-1.4h-.2A1.5,1.5,0,0,0,85,49.7Z",
    fill: "#fbe7ab"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7,48.7Z",
    fill: "#fbe7ab"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,48.7h.1a1.3,1.3,0,1,1,2.6,0h0c0-.1.1-.3.1-.4a1.5,1.5,0,0,0-2.8,0Z",
    fill: "#fbe7ab"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6,48.3c0,.1-.1.3-.1.4h.2A1.3,1.3,0,0,1,85,47.4h-.1A1.4,1.4,0,0,0,83.6,48.3Z",
    fill: "#fbe7ab"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,48.8Z",
    fill: "#fbe7ab"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 51.3 80.8 51.3 80.8 51.3 80.8 51.3",
    fill: "#fbe7ab"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,51.6h.1a1.3,1.3,0,0,1,2.6,0h.2c0-.1-.1-.2-.1-.3a1.4,1.4,0,0,0-2.8,0h0Z",
    fill: "#fbe7ab"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 48.8 80.8 48.8 80.8 48.8 80.8 48.8",
    fill: "#fbe7ab"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,48.7h-.1a1.5,1.5,0,0,1,1.1.6,1.9,1.9,0,0,1,.2.7h.2A1.5,1.5,0,0,0,80.9,48.7Z",
    fill: "#fbe7ab"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,48.8h0v-.4h0Z",
    fill: "#fbe7ab"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 45.3 80.8 45.3 80.8 45.3 80.8 45.3",
    fill: "#fbe7ab"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,45.3h0v.3h.1A1.3,1.3,0,0,1,82,44.4h-.1A1.4,1.4,0,0,0,80.8,45.3Z",
    fill: "#fbe7ab"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.3 59.1 79.3 59.1 79.3 59.1 79.3 59.1",
    fill: "#fbe7ab"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,57.7h0a1.3,1.3,0,0,0-1.3,1v.4a1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 57.8 80.8 57.8 80.8 57.8 80.8 57.8",
    fill: "#fbe7ab"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M78,57.6h0Z",
    fill: "#fbe7ab"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,57.7h0Z",
    fill: "#fbe7ab"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,57.6h0Z",
    fill: "#fbe7ab"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 57.8 75.1 57.8 75.1 57.8 75.1 57.8",
    fill: "#fbe7ab"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,57.7h-.1a1.3,1.3,0,0,1,1.3,1.3h.1v-.4A1.4,1.4,0,0,0,75.2,57.7Z",
    fill: "#fbe7ab"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,57.8h0a1.4,1.4,0,0,0-1.4,1v.4h.1A1.3,1.3,0,0,1,77.9,57.8Z",
    fill: "#fbe7ab"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,58.7a1.4,1.4,0,0,0-1.4-1h-.1a1.3,1.3,0,0,1,1.4,1.3h.1Z",
    fill: "#fbe7ab"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,57.8Z",
    fill: "#fbe7ab"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,57.6v.2h0Z",
    fill: "#fbe7ab"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,57.6h0Z",
    fill: "#fbe7ab"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,51.7h0a1.3,1.3,0,0,0-1.3,1v.4a1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 51.8 80.8 51.8 80.8 51.8 80.8 51.8",
    fill: "#fbe7ab"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3,53.2h0Z",
    fill: "#fbe7ab"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M78,51.6h0Z",
    fill: "#fbe7ab"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,51.7Z",
    fill: "#fbe7ab"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,51.6h0Z",
    fill: "#fbe7ab"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,51.7h-.1a1.3,1.3,0,0,1,1.3,1.4c0-.2.1-.3.1-.5A1.4,1.4,0,0,0,75.2,51.7Z",
    fill: "#fbe7ab"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 51.8 75.1 51.8 75.1 51.8 75.1 51.8",
    fill: "#fbe7ab"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,51.7h0a1.4,1.4,0,0,0-1.4,1c0,.2-.1.3-.1.5h.2a1.3,1.3,0,0,1,1.3-1.4Z",
    fill: "#fbe7ab"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M78,51.7h-.1a1.3,1.3,0,0,1,1.4,1.3h.1v-.4A1.4,1.4,0,0,0,78,51.7Z",
    fill: "#fbe7ab"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,51.8Z",
    fill: "#fbe7ab"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M78,51.7Z",
    fill: "#fbe7ab"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,51.7h-.1v.2h.1Z",
    fill: "#fbe7ab"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7,55.4a1.1,1.1,0,0,1,1.1-.6h0A1.1,1.1,0,0,0,79.7,55.4Z",
    fill: "#fbe7ab"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M78,57.6a1.4,1.4,0,0,1,1.4-1.2,1.3,1.3,0,0,1,1.3,1.2h0a.4.4,0,0,1,.1-.3h0a1.6,1.6,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.5,1.1.4.4,0,0,1,.1.3Z",
    fill: "#fbe7ab"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,57.3a.4.4,0,0,0-.1.3h.1Z",
    fill: "#fbe7ab"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,54.7h0a1.4,1.4,0,0,0-1.4,1,.6.6,0,0,1,.1.4,1.3,1.3,0,0,1,1.3-1.3Z",
    fill: "#fbe7ab"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M78,54.7h-.1a1.4,1.4,0,0,1,1.4,1.4.9.9,0,0,1,.1-.5A1.4,1.4,0,0,0,78,54.7Z",
    fill: "#fbe7ab"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,56.2h0Z",
    fill: "#fbe7ab"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 54.8 75.1 54.8 75.1 54.8 75.1 54.8",
    fill: "#fbe7ab"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,54.8h-.1a1.3,1.3,0,0,0-1.3,1,.9.9,0,0,0-.1.5h.1a1.1,1.1,0,0,1,.3-.8A1.1,1.1,0,0,1,80.8,54.8Z",
    fill: "#fbe7ab"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,54.7a1.3,1.3,0,0,1,1.3-1.3,1.5,1.5,0,0,1,1.4,1.3h0v-.4a1.4,1.4,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.4,1.1c0,.1.1.2.1.4Z",
    fill: "#fbe7ab"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M78,54.7Z",
    fill: "#fbe7ab"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,54.7H78a1.3,1.3,0,0,1,1.4-1.3,1.3,1.3,0,0,1,1.3,1.3h.1v-.5a1.6,1.6,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.5,1.1Z",
    fill: "#fbe7ab"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 57.3 75.1 57.3 75.1 57.3 75.1 57.3",
    fill: "#fbe7ab"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,57.6h.1a1.2,1.2,0,0,1,1.3-1.2,1.4,1.4,0,0,1,1.4,1.2H78a.4.4,0,0,0-.1-.3,1.4,1.4,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.4,1.1h0Z",
    fill: "#fbe7ab"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 54.8 75.1 54.8 75.1 54.8 75.1 54.8",
    fill: "#fbe7ab"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,54.7h-.1a1.3,1.3,0,0,1,1.3,1.3h.2a.6.6,0,0,0-.1-.4A1.4,1.4,0,0,0,75.2,54.7Z",
    fill: "#fbe7ab"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,54.8h.1c0-.2-.1-.3-.1-.4h0Z",
    fill: "#fbe7ab"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3,47.2h0Z",
    fill: "#fbe7ab"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,45.7h0a1.3,1.3,0,0,0-1.3,1v.4a1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    points: "80.8 45.8 80.8 45.8 80.8 45.8 80.8 45.8",
    fill: "#fbe7ab"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,45.7Z",
    fill: "#fbe7ab"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M78,45.6h0Z",
    fill: "#fbe7ab"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,45.6h0Z",
    fill: "#fbe7ab"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 45.8 75.1 45.8 75.1 45.8 75.1 45.8",
    fill: "#fbe7ab"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,45.7h-.1a1.3,1.3,0,0,1,1.3,1.4c0-.2.1-.3.1-.5A1.5,1.5,0,0,0,75.2,45.7Z",
    fill: "#fbe7ab"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M78,45.7h-.1a1.3,1.3,0,0,1,1.4,1.3h.1v-.4A1.4,1.4,0,0,0,78,45.7Z",
    fill: "#fbe7ab"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,45.7h0a1.5,1.5,0,0,0-1.4,1c0,.2-.1.3-.1.5h.2a1.3,1.3,0,0,1,1.3-1.4Z",
    fill: "#fbe7ab"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,45.8Z",
    fill: "#fbe7ab"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M78,45.7Z",
    fill: "#fbe7ab"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,45.7h-.1v.2h.1Z",
    fill: "#fbe7ab"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7,49.4a1.4,1.4,0,0,1,1.1-.6h0A1.4,1.4,0,0,0,79.7,49.4Z",
    fill: "#fbe7ab"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M78,51.6a1.4,1.4,0,0,1,1.4-1.2,1.3,1.3,0,0,1,1.3,1.2h0a.4.4,0,0,1,.1-.3h0a1.6,1.6,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.5,1.1.4.4,0,0,1,.1.3Z",
    fill: "#fbe7ab"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7,51.6h.1v-.3A.4.4,0,0,0,80.7,51.6Z",
    fill: "#fbe7ab"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M78,48.7h-.1a1.4,1.4,0,0,1,1.4,1.4.9.9,0,0,1,.1-.5A1.4,1.4,0,0,0,78,48.7Z",
    fill: "#fbe7ab"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,50.2h0Z",
    fill: "#fbe7ab"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,48.7h0a1.4,1.4,0,0,0-1.4,1,.8.8,0,0,1,.1.4,1.3,1.3,0,0,1,1.3-1.3Z",
    fill: "#fbe7ab"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 48.8 75.1 48.8 75.1 48.8 75.1 48.8",
    fill: "#fbe7ab"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,48.8h-.1a1.3,1.3,0,0,0-1.3,1,.9.9,0,0,0-.1.5h.1a1.1,1.1,0,0,1,.3-.8A1.4,1.4,0,0,1,80.8,48.8Z",
    fill: "#fbe7ab"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,48.7a1.3,1.3,0,0,1,1.3-1.3,1.5,1.5,0,0,1,1.4,1.3h0v-.4a1.3,1.3,0,0,0-1.4-1,1.5,1.5,0,0,0-1.4,1c0,.1.1.3.1.4Z",
    fill: "#fbe7ab"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,48.8Z",
    fill: "#fbe7ab"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M78,48.7h0a1.3,1.3,0,0,1,1.4-1.3,1.3,1.3,0,0,1,1.3,1.3h.1v-.5a1.5,1.5,0,0,0-1.4-1,1.5,1.5,0,0,0-1.5,1v.4H78Z",
    fill: "#fbe7ab"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 51.3 75.1 51.3 75.1 51.3 75.1 51.3",
    fill: "#fbe7ab"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,51.6h.1a1.2,1.2,0,0,1,1.3-1.2,1.4,1.4,0,0,1,1.4,1.2H78a.4.4,0,0,0-.1-.3,1.4,1.4,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.4,1.1h0Z",
    fill: "#fbe7ab"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,48.7h-.1a1.3,1.3,0,0,1,1.3,1.3h.2a.8.8,0,0,0-.1-.4A1.4,1.4,0,0,0,75.2,48.7Z",
    fill: "#fbe7ab"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 48.8 75.1 48.8 75.1 48.8 75.1 48.8",
    fill: "#fbe7ab"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,48.7h0c0-.1-.1-.3-.1-.4h0v.5h.1Z",
    fill: "#fbe7ab"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4,41.2c0-.2.1-.3.1-.5A1.5,1.5,0,0,0,76,40h-.1A1.6,1.6,0,0,1,76.4,41.2Z",
    fill: "#fbe7ab"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,40.7c0,.2-.1.3-.1.5h.2a1.4,1.4,0,0,1,.9-1.3h-.1A2,2,0,0,0,76.5,40.7Z",
    fill: "#fbe7ab"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7,43.4a.8.8,0,0,1,.8-.5h0A.8.8,0,0,0,79.7,43.4Z",
    fill: "#fbe7ab"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M78,45.6a1.4,1.4,0,0,1,1.4-1.2,1.3,1.3,0,0,1,1.3,1.2h0a.4.4,0,0,1,.1-.3h0a1.5,1.5,0,0,0-1.4-1,1.5,1.5,0,0,0-1.5,1,.4.4,0,0,1,.1.3Z",
    fill: "#fbe7ab"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8,45.6v-.3a.4.4,0,0,0-.1.3Z",
    fill: "#fbe7ab"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,42.8h0a1.5,1.5,0,0,0-1.4,1,.9.9,0,0,1,.1.5,1.3,1.3,0,0,1,1.3-1.4Z",
    fill: "#fbe7ab"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M78,42.7h-.1a1.4,1.4,0,0,1,1.4,1.4.9.9,0,0,1,.1-.5A1.5,1.5,0,0,0,78,42.7Z",
    fill: "#fbe7ab"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5,44.2h0Z",
    fill: "#fbe7ab"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 42.8 75.1 42.8 75.1 42.8 75.1 42.8",
    fill: "#fbe7ab"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,43.7a.9.9,0,0,0-.1.5h.1a1.1,1.1,0,0,1,.3-.8.8.8,0,0,1,.8-.5v-.2A1.6,1.6,0,0,0,79.4,43.7Z",
    fill: "#fbe7ab"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,42.7a1.3,1.3,0,0,1,1.3-1.3,1.5,1.5,0,0,1,1.4,1.3h0v-.4a1.3,1.3,0,0,0-1.4-1,1.5,1.5,0,0,0-1.4,1c0,.1.1.3.1.4Z",
    fill: "#fbe7ab"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M78,42.8h0Z",
    fill: "#fbe7ab"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,42.3v.4H78a1.5,1.5,0,0,1,1-1.3h-.1A1.9,1.9,0,0,0,77.9,42.3Z",
    fill: "#fbe7ab"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 45.3 75.1 45.3 75.1 45.3 75.1 45.3",
    fill: "#fbe7ab"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,45.6h.1a1.2,1.2,0,0,1,1.3-1.2,1.4,1.4,0,0,1,1.4,1.2H78a.4.4,0,0,0-.1-.3,1.3,1.3,0,0,0-1.4-1,1.5,1.5,0,0,0-1.4,1h0Z",
    fill: "#fbe7ab"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,42.7h-.1a1.3,1.3,0,0,1,1.3,1.4h.2a.9.9,0,0,0-.1-.5A1.5,1.5,0,0,0,75.2,42.7Z",
    fill: "#fbe7ab"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.1 42.8 75.1 42.8 75.1 42.8 75.1 42.8",
    fill: "#fbe7ab"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2,42.8h0c0-.1-.1-.3-.1-.4h0v.5h.1Z",
    fill: "#fbe7ab"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M75,57.7h0a1.4,1.4,0,0,0-1.3,1c0,.1.1.3.1.4a1.3,1.3,0,0,1,1.3-1.3H75Z",
    fill: "#fbe7ab"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.6 59.1 73.6 59.1 73.6 59.1 73.6 59.1",
    fill: "#fbe7ab"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,58.7a1.4,1.4,0,0,0-1.4-1h0a1.5,1.5,0,0,1,1.5,1.4h0C73.8,59,73.7,58.8,73.7,58.7Z",
    fill: "#fbe7ab"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,57.6h0Z",
    fill: "#fbe7ab"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M75,57.7h0Z",
    fill: "#fbe7ab"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M75,57.7h.1v-.2H75Z",
    fill: "#fbe7ab"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,57.7h-.1a1.3,1.3,0,0,1,1.4,1.3h0v-.4A1.3,1.3,0,0,0,69.5,57.7Z",
    fill: "#fbe7ab"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,57.8h-.1a1.4,1.4,0,0,0-1.4,1v.4h.1A1.3,1.3,0,0,1,72.3,57.8Z",
    fill: "#fbe7ab"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,57.7h0a1.3,1.3,0,0,1,1.3,1.3h.2A1.5,1.5,0,0,0,72.3,57.7Z",
    fill: "#fbe7ab"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.8Z",
    fill: "#fbe7ab"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.6v.2h0Z",
    fill: "#fbe7ab"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,57.6h0Z",
    fill: "#fbe7ab"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M75,51.7h0a1.4,1.4,0,0,0-1.3,1c0,.2.1.3.1.4a1.3,1.3,0,0,1,1.3-1.3H75Z",
    fill: "#fbe7ab"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6,53.2h0Z",
    fill: "#fbe7ab"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,51.7h0a1.5,1.5,0,0,1,1.5,1.5h0c0-.1-.1-.2-.1-.4A1.4,1.4,0,0,0,72.3,51.7Z",
    fill: "#fbe7ab"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,51.6h0Z",
    fill: "#fbe7ab"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M75,51.6Z",
    fill: "#fbe7ab"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M75,51.7h.1v-.2H75Z",
    fill: "#fbe7ab"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,51.7h-.1a1.4,1.4,0,0,1,1.4,1.4v-.5A1.3,1.3,0,0,0,69.5,51.7Z",
    fill: "#fbe7ab"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2,51.7h0a1.4,1.4,0,0,0-1.4,1v.5h.1a1.4,1.4,0,0,1,1.4-1.4Z",
    fill: "#fbe7ab"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,53.2a1.5,1.5,0,0,0-1.5-1.5h0a1.3,1.3,0,0,1,1.3,1.3h.2Z",
    fill: "#fbe7ab"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,51.8Z",
    fill: "#fbe7ab"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,51.7Z",
    fill: "#fbe7ab"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,51.7h-.1v.2h.1Z",
    fill: "#fbe7ab"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,56.2h0a1.3,1.3,0,0,1,1.3-1.4h0A1.3,1.3,0,0,0,73.8,56.2Z",
    fill: "#fbe7ab"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,57.6a1.4,1.4,0,0,1,1.4-1.2A1.2,1.2,0,0,1,75,57.6h0c0-.1.1-.2.1-.3h0a1.5,1.5,0,0,0-1.4-1.1,1.4,1.4,0,0,0-1.4,1.1v.3Z",
    fill: "#fbe7ab"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1,57.3c0,.1-.1.2-.1.3h.1Z",
    fill: "#fbe7ab"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2,54.7h0a1.5,1.5,0,0,0-1.4,1,.6.6,0,0,1,.1.4,1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,54.7h0a1.3,1.3,0,0,1,1.3,1.4.9.9,0,0,1,.1-.5A1.4,1.4,0,0,0,72.3,54.7Z",
    fill: "#fbe7ab"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,56.2h0Z",
    fill: "#fbe7ab"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,56.2a1.3,1.3,0,0,1,1.3-1.4H75a1.4,1.4,0,0,0-1.3,1,.9.9,0,0,0-.1.5h.2Z",
    fill: "#fbe7ab"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,54.7a1.3,1.3,0,0,1,1.3-1.3,1.3,1.3,0,0,1,1.4,1.3h0a.6.6,0,0,1,.1-.4,1.6,1.6,0,0,0-1.5-1.1,1.6,1.6,0,0,0-1.4,1.1c.1.1.1.2.1.4Z",
    fill: "#fbe7ab"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,54.7Z",
    fill: "#fbe7ab"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2,54.7h.1a1.5,1.5,0,0,1,1.4-1.3A1.3,1.3,0,0,1,75,54.7h.1v-.5a1.4,1.4,0,0,0-2.8,0A.6.6,0,0,0,72.2,54.7Z",
    fill: "#fbe7ab"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.4 57.3 69.4 57.3 69.4 57.3 69.4 57.3",
    fill: "#fbe7ab"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.6h.1a1.3,1.3,0,0,1,1.3-1.2,1.4,1.4,0,0,1,1.4,1.2h.1v-.3a1.6,1.6,0,0,0-1.5-1.1,1.6,1.6,0,0,0-1.4,1.1h0Z",
    fill: "#fbe7ab"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,54.7h-.1a1.3,1.3,0,0,1,1.4,1.3h.1a.6.6,0,0,0-.1-.4A1.3,1.3,0,0,0,69.5,54.7Z",
    fill: "#fbe7ab"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.4 54.8 69.4 54.8 69.4 54.8 69.4 54.8",
    fill: "#fbe7ab"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,54.8h.1c0-.2,0-.3-.1-.4h0Z",
    fill: "#fbe7ab"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M75,45.7h0a1.4,1.4,0,0,0-1.3,1c0,.2.1.3.1.4a1.3,1.3,0,0,1,1.3-1.3H75Z",
    fill: "#fbe7ab"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6,47.2h0Z",
    fill: "#fbe7ab"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,45.7h0a1.5,1.5,0,0,1,1.5,1.5h0c0-.1-.1-.2-.1-.4A1.4,1.4,0,0,0,72.3,45.7Z",
    fill: "#fbe7ab"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M75,45.6Z",
    fill: "#fbe7ab"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,45.7Z",
    fill: "#fbe7ab"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M75,45.7h.1v-.2H75Z",
    fill: "#fbe7ab"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,47.2v-.5a1.3,1.3,0,0,0-.7-.9H70A1.7,1.7,0,0,1,70.8,47.2Z",
    fill: "#fbe7ab"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,47.2a1.5,1.5,0,0,0-1.5-1.5h0a1.3,1.3,0,0,1,1.3,1.3h.2Z",
    fill: "#fbe7ab"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2,45.7h0a1.5,1.5,0,0,0-1.4,1v.5h.1a1.4,1.4,0,0,1,1.4-1.4Z",
    fill: "#fbe7ab"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,45.7Z",
    fill: "#fbe7ab"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,50.2h0a1.3,1.3,0,0,1,1.3-1.4h0A1.3,1.3,0,0,0,73.8,50.2Z",
    fill: "#fbe7ab"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,51.6a1.4,1.4,0,0,1,1.4-1.2A1.2,1.2,0,0,1,75,51.6h0c0-.1.1-.2.1-.3h0a1.5,1.5,0,0,0-1.4-1.1,1.4,1.4,0,0,0-1.4,1.1v.3Z",
    fill: "#fbe7ab"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M75,51.6h.1v-.3C75.1,51.4,75,51.5,75,51.6Z",
    fill: "#fbe7ab"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,48.7h0a1.3,1.3,0,0,1,1.3,1.4.9.9,0,0,1,.1-.5A1.4,1.4,0,0,0,72.3,48.7Z",
    fill: "#fbe7ab"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8,50.2h0Z",
    fill: "#fbe7ab"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2,48.7h0a1.5,1.5,0,0,0-1.4,1,.8.8,0,0,1,.1.4,1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,50.2a1.3,1.3,0,0,1,1.3-1.4H75a1.4,1.4,0,0,0-1.3,1,.9.9,0,0,0-.1.5h.2Z",
    fill: "#fbe7ab"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,48.7a1.3,1.3,0,0,1,1.3-1.3,1.3,1.3,0,0,1,1.4,1.3h0a.6.6,0,0,1,.1-.4,1.5,1.5,0,0,0-1.5-1,1.5,1.5,0,0,0-1.4,1,.6.6,0,0,1,.1.4Z",
    fill: "#fbe7ab"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,48.8Z",
    fill: "#fbe7ab"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3,48.7h0a1.5,1.5,0,0,1,1.4-1.3A1.3,1.3,0,0,1,75,48.7h.1v-.5a1.5,1.5,0,0,0-2.8,0,.6.6,0,0,0-.1.4h.1Z",
    fill: "#fbe7ab"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.4 51.3 69.4 51.3 69.4 51.3 69.4 51.3",
    fill: "#fbe7ab"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,51.6h.1a1.3,1.3,0,0,1,1.3-1.2,1.4,1.4,0,0,1,1.4,1.2h.1v-.3a1.6,1.6,0,0,0-1.5-1.1,1.6,1.6,0,0,0-1.4,1.1h0Z",
    fill: "#fbe7ab"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,48.7h-.1a1.3,1.3,0,0,1,1.4,1.3h.1a.8.8,0,0,0-.1-.4A1.3,1.3,0,0,0,69.5,48.7Z",
    fill: "#fbe7ab"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.4 48.8 69.4 48.8 69.4 48.8 69.4 48.8",
    fill: "#fbe7ab"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,48.7h0a.6.6,0,0,0-.1-.4h0v.5h.1Z",
    fill: "#fbe7ab"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,44.2h0a1.3,1.3,0,0,1,1.3-1.4h0A1.3,1.3,0,0,0,73.8,44.2Z",
    fill: "#fbe7ab"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,44.4A1.2,1.2,0,0,1,75,45.6h0c0-.1.1-.2.1-.3h0a1.4,1.4,0,0,0-1.4-1,1.3,1.3,0,0,0-1.4,1v.3h0A1.4,1.4,0,0,1,73.7,44.4Z",
    fill: "#fbe7ab"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M75,45.6h.1v-.3C75.1,45.4,75,45.5,75,45.6Z",
    fill: "#fbe7ab"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6,44.2a.9.9,0,0,1,.1-.5,1.6,1.6,0,0,0-.6-.8H73A1.4,1.4,0,0,1,73.6,44.2Z",
    fill: "#fbe7ab"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,44.2a1.3,1.3,0,0,1,1.3-1.4H75a1.5,1.5,0,0,0-1.3,1,.9.9,0,0,0-.1.5h.2Z",
    fill: "#fbe7ab"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M75,42.7h.1v-.5a1.6,1.6,0,0,0-.6-.8h-.1A1.3,1.3,0,0,1,75,42.7Z",
    fill: "#fbe7ab"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2,45.6h.1v-.3a1.8,1.8,0,0,0-.8-.9h-.1A1.5,1.5,0,0,1,72.2,45.6Z",
    fill: "#fbe7ab"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.7h-.1a1.4,1.4,0,0,0-1.3,1c0,.1.1.3.1.4a1.3,1.3,0,0,1,1.3-1.3h0Z",
    fill: "#fbe7ab"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    points: "67.9 59.1 67.9 59.1 67.9 59.1 67.9 59.1",
    fill: "#fbe7ab"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5,58.4a1.1,1.1,0,0,1,1.1-.6h0A1.1,1.1,0,0,0,65.5,58.4Z",
    fill: "#fbe7ab"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M68,58.7a1.4,1.4,0,0,0-1.3-1h0a1.4,1.4,0,0,1,1.4,1.4h0C68.1,59,68,58.8,68,58.7Z",
    fill: "#fbe7ab"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,57.6h0Z",
    fill: "#fbe7ab"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.7h0Z",
    fill: "#fbe7ab"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.7h0v-.2h0Z",
    fill: "#fbe7ab"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8,57.7h-.1a1.3,1.3,0,0,1,1.4,1.3h0a.8.8,0,0,1,.1-.4A1.4,1.4,0,0,0,63.8,57.7Z",
    fill: "#fbe7ab"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,57.8h-.1a1.3,1.3,0,0,0-1.3,1,.8.8,0,0,0-.1.4h.1a1.1,1.1,0,0,1,.3-.7A1.1,1.1,0,0,1,66.6,57.8Z",
    fill: "#fbe7ab"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7,57.7h-.1a1.1,1.1,0,0,1,1.1.6,1.9,1.9,0,0,1,.2.7h.2A1.4,1.4,0,0,0,66.7,57.7Z",
    fill: "#fbe7ab"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.8Z",
    fill: "#fbe7ab"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.6v.2h0Z",
    fill: "#fbe7ab"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,57.6h0Z",
    fill: "#fbe7ab"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,51.7h-.1a1.4,1.4,0,0,0-1.3,1c0,.2.1.3.1.4a1.3,1.3,0,0,1,1.3-1.3h0Z",
    fill: "#fbe7ab"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9,53.2h0Z",
    fill: "#fbe7ab"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5,52.4a1.1,1.1,0,0,1,1.1-.6h0A1.1,1.1,0,0,0,65.5,52.4Z",
    fill: "#fbe7ab"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7,51.7h0a1.5,1.5,0,0,1,1.4,1.5h0c0-.1-.1-.2-.1-.4A1.4,1.4,0,0,0,66.7,51.7Z",
    fill: "#fbe7ab"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,51.6h0Z",
    fill: "#fbe7ab"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7,51.7h-.1A.1.1,0,0,0,66.7,51.7Z",
    fill: "#fbe7ab"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,51.7h0v-.2h0Z",
    fill: "#fbe7ab"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1,53.2a.9.9,0,0,1,.1-.5,1.6,1.6,0,0,0-1.1-1H64A1.4,1.4,0,0,1,65.1,53.2Z",
    fill: "#fbe7ab"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,51.8h-.1a1.3,1.3,0,0,0-1.3,1,.9.9,0,0,0-.1.5h.1a1.1,1.1,0,0,1,.3-.8A1.1,1.1,0,0,1,66.6,51.8Z",
    fill: "#fbe7ab"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7,51.7h-.1a1.1,1.1,0,0,1,1.1.6,1.9,1.9,0,0,1,.2.7h.2A1.5,1.5,0,0,0,66.7,51.7Z",
    fill: "#fbe7ab"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,51.7h.2a.1.1,0,0,1-.1-.1h-.1Z",
    fill: "#fbe7ab"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7,57.6a1.3,1.3,0,0,1,2.6,0h.1v-.3h0a1.4,1.4,0,0,0-2.8,0v.3Z",
    fill: "#fbe7ab"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,57.3v.3h0Z",
    fill: "#fbe7ab"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7,54.7h-.1a1.3,1.3,0,0,1,1.3,1.4c0-.2.1-.3.1-.5A1.4,1.4,0,0,0,66.7,54.7Z",
    fill: "#fbe7ab"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1,56.2h0Z",
    fill: "#fbe7ab"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,54.7h0a1.3,1.3,0,0,0-1.3,1v.4a1.3,1.3,0,0,1,1.4-1.3Z",
    fill: "#fbe7ab"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,54.7h-.1a1.4,1.4,0,0,0-1.3,1c0,.2-.1.3-.1.5h.2a1.3,1.3,0,0,1,1.3-1.4h0Z",
    fill: "#fbe7ab"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8,54.7a1.4,1.4,0,0,1,1.4-1.3,1.3,1.3,0,0,1,1.3,1.3h0a.6.6,0,0,1,.1-.4,1.6,1.6,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.5,1.1c.1.1.1.2.1.4Z",
    fill: "#fbe7ab"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7,54.7Z",
    fill: "#fbe7ab"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,54.7h.2a1.3,1.3,0,1,1,2.6,0h.1v-.5a1.4,1.4,0,0,0-2.8,0A.6.6,0,0,0,66.5,54.7Z",
    fill: "#fbe7ab"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    points: "63.7 57.3 63.7 57.3 63.7 57.3 63.7 57.3",
    fill: "#fbe7ab"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.6h.1a1.4,1.4,0,0,1,1.4-1.2,1.3,1.3,0,0,1,1.3,1.2h.1v-.3a1.6,1.6,0,0,0-1.4-1.1,1.6,1.6,0,0,0-1.5,1.1h0Z",
    fill: "#fbe7ab"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    points: "63.7 54.8 63.7 54.8 63.7 54.8 63.7 54.8",
    fill: "#fbe7ab"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8,54.7h-.1a1.3,1.3,0,0,1,1.4,1.3h.1v-.4A1.4,1.4,0,0,0,63.8,54.7Z",
    fill: "#fbe7ab"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,54.8h.1c0-.2,0-.3-.1-.4h0Z",
    fill: "#fbe7ab"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M68,50.4a1.2,1.2,0,0,1,1.3,1.2h.1v-.3h0a1.4,1.4,0,0,0-2.8,0v.3h.1A1.2,1.2,0,0,1,68,50.4Z",
    fill: "#fbe7ab"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,51.6h0v0Z",
    fill: "#fbe7ab"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9,50.2c0-.2.1-.3.1-.5a1.4,1.4,0,0,0-.9-.9H67A1.4,1.4,0,0,1,67.9,50.2Z",
    fill: "#fbe7ab"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4,48.7h-.1a1.4,1.4,0,0,0-1.3,1c0,.2-.1.3-.1.5h.2a1.3,1.3,0,0,1,1.3-1.4h0Z",
    fill: "#fbe7ab"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3,48.7h.1v-.5a1.2,1.2,0,0,0-.9-.9h-.1A1.2,1.2,0,0,1,69.3,48.7Z",
    fill: "#fbe7ab"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5,51.6h.1v-.3a1.6,1.6,0,0,0-1.1-1h-.1A1.4,1.4,0,0,1,66.5,51.6Z",
    fill: "#fbe7ab"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.8h0a1.4,1.4,0,0,0-1.3.9v.5A1.3,1.3,0,0,1,63.7,57.8Z",
    fill: "#fbe7ab"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.6Z",
    fill: "#fbe7ab"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.6h0Z",
    fill: "#fbe7ab"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4,58.8v.3h0Z",
    fill: "#fbe7ab"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.6h0v-.3h0a1.5,1.5,0,0,0-1.3-1.1v.2A1.3,1.3,0,0,1,63.7,57.6Z",
    fill: "#fbe7ab"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,57.3v.3h0Z",
    fill: "#fbe7ab"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4,56.2a1.3,1.3,0,0,1,1.3-1.4h0a1.4,1.4,0,0,0-1.3.9v.6Z",
    fill: "#fbe7ab"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7,54.7h0v-.5a1.2,1.2,0,0,0-1.2-1h-.1A1.4,1.4,0,0,1,63.7,54.7Z",
    fill: "#fbe7ab"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1,
    y: 64.5,
    width: 5.3,
    height: 13.11,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 74.1,
    y: 64.5,
    width: 5.3,
    height: 13.11,
    fill: "#fdd058"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    points: "76.8 37.5 59.9 54.5 59.9 55.6 63.6 55.6 63.5 53.5 76.8 40.1 77 40.1 90.2 53.5 90.2 55.6 93.9 55.6 93.9 54.5 76.9 37.4 76.8 37.5",
    fill: "#fff"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    points: "76.8 37.5 59.9 54.5 59.9 55.6 63.6 55.6 63.5 53.5 76.8 40.1 77 40.1 90.2 53.5 90.2 55.6 93.9 55.6 93.9 54.5 76.9 37.4 76.8 37.5",
    fill: "#98aab6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fdd058"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 67.4,
    y: 52.3,
    width: 2.5,
    height: 6.05,
    fill: "#bbc7d0"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8,58.5H67.4a.1.1,0,0,1-.1-.1V52.3h2.6v6.1A.1.1,0,0,1,69.8,58.5Zm-2.4-.2h2.4V52.4H67.4Z",
    fill: "#fff4d0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fdd058"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 52.3,
    width: 2.5,
    height: 6.05,
    fill: "#bbc7d0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,58.5H71.2V52.3h2.7v6.1Zm-2.4-.2h2.3V52.4H71.4Z",
    fill: "#fff4d0"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5,49.1v-.4a3.4,3.4,0,1,1,6.8,0v.4Z",
    fill: "#fff"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5,49.1v-.4a3.4,3.4,0,1,1,6.8,0v.4Z",
    fill: "#fdd058"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9,48.7a3,3,0,1,0-6,0Z",
    fill: "#fff"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9,48.7a3,3,0,1,0-6,0Z",
    fill: "#bbc7d0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9,48.7H73.8a3.1,3.1,0,1,1,6.2,0ZM74,48.6h5.9a3.1,3.1,0,0,0-3-2.9A2.9,2.9,0,0,0,74,48.6Z",
    fill: "#fff4d0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fdd058"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 52.3,
    width: 2.5,
    height: 6.05,
    fill: "#bbc7d0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5,58.5H80V52.3h2.6v6.1Zm-2.4-.2h2.3V52.4H80.1Z",
    fill: "#fff4d0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 83.2,
    y: 51.6,
    width: 4,
    height: 7.56,
    fill: "#fdd058"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 52.3,
    width: 2.5,
    height: 6.05,
    fill: "#bbc7d0"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5,58.5H84a.1.1,0,0,1-.1-.1V52.3h2.6v6.1ZM84,58.3h2.4V52.4H84Z",
    fill: "#fff4d0"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6,58.5a.1.1,0,0,1-.1-.1V52.3h.2v6.1Z",
    fill: "#fff4d0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6,58.5a.1.1,0,0,1-.1-.1V52.3h.1v6.1Z",
    fill: "#fff4d0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2,58.3h-.1v-6h.2v6Z",
    fill: "#fff4d0"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2,58.5a.1.1,0,0,1-.1-.1V52.3h.1v6.1Z",
    fill: "#fff4d0"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "73 78.5 62.9 78.5 62.9 83.8 73 83.8 73 78.5",
    fill: "#98aab6"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8,55.4H67.4a.1.1,0,0,1-.1-.1h2.5Z",
    fill: "#fff4d0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7,55.4H71.4a.1.1,0,0,1-.1-.1h2.5A.1.1,0,0,1,73.7,55.4Z",
    fill: "#fff4d0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5,55.4h0Z",
    fill: "#fff4d0"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4,55.4h0Z",
    fill: "#fff4d0"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9,48.7h-.1V45.6H77v3.1Z",
    fill: "#fff4d0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 74.9,
    y1: 46.5,
    x2: 75.9,
    y2: 48.7,
    fill: "#fff"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9,48.7h0l-1-2.2H75l1,2.2h-.1Z",
    fill: "#fff4d0"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 78.9,
    y1: 46.5,
    x2: 77.9,
    y2: 48.7,
    fill: "#fff"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9,48.7h0c-.1,0-.1,0-.1-.1l1-2.2h.1a.1.1,0,0,1,.1.1l-1,2.2Z",
    fill: "#fff4d0"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8,79.6h0Z",
    fill: "#fff4d0"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8,81.8h0Z",
    fill: "#fff4d0"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8,77.7h-6c-.1,0-.1,0-.1-.1h6.2C79.9,77.7,79.9,77.7,79.8,77.7Z",
    fill: "#fff4d0"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 65.5,
    y1: 78.5,
    x2: 64.1,
    y2: 83.8,
    fill: "#fff"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1,83.8h0l1.3-5.2h.1s.1,0,0,.1l-1.3,5.2Z",
    fill: "#fff4d0"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 64.1,
    y1: 78.5,
    x2: 65.5,
    y2: 83.8,
    fill: "#fff"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5,83.8h-.1l-1.3-5.2h.1l1.3,5.2c.1.1,0,.1,0,.1Z",
    fill: "#fff4d0"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 64.1,
    y1: 78.5,
    x2: 62.9,
    y2: 83.3,
    fill: "#fff"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 62.9,
    y1: 79,
    x2: 64.1,
    y2: 83.8,
    fill: "#fff"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 66.7,
    y1: 78.5,
    x2: 65.4,
    y2: 83.8,
    fill: "#fff"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 65.4,
    y1: 78.5,
    x2: 66.7,
    y2: 83.8,
    fill: "#fff"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 78.5,
    x2: 66.6,
    y2: 83.8,
    fill: "#fff"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6,83.8h0l1.3-5.2h.2l-1.4,5.2Z",
    fill: "#fff4d0"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 66.6,
    y1: 78.5,
    x2: 68,
    y2: 83.8,
    fill: "#fff"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M68,83.8h-.1l-1.3-5.2h.1L68,83.7c.1.1,0,.1,0,.1Z",
    fill: "#fff4d0"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 69.2,
    y1: 78.5,
    x2: 67.9,
    y2: 83.8,
    fill: "#fff"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 67.9,
    y1: 78.5,
    x2: 69.2,
    y2: 83.8,
    fill: "#fff"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 70.5,
    y1: 78.5,
    x2: 69.2,
    y2: 83.8,
    fill: "#fff"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2,83.8h-.1l1.3-5.2h.2l-1.4,5.2Z",
    fill: "#fff4d0"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 70.5,
    y1: 83.8,
    x2: 69.2,
    y2: 78.5,
    fill: "#fff"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5,83.8h-.1l-1.3-5.2h.1l1.4,5.2Z",
    fill: "#fff4d0"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 71.7,
    y1: 78.5,
    x2: 70.4,
    y2: 83.8,
    fill: "#fff"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 70.4,
    y1: 78.5,
    x2: 71.7,
    y2: 83.8,
    fill: "#fff"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 78.5,
    x2: 71.7,
    y2: 83.8,
    fill: "#fff"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7,83.8h-.1l1.3-5.2h.2l-1.4,5.2Z",
    fill: "#fff4d0"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 71.7,
    y1: 78.5,
    x2: 73,
    y2: 83.8,
    fill: "#fff"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M73,83.8h-.1l-1.3-5.2h.1l1.4,5.2Z",
    fill: "#fff4d0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6,
    y: 65.7,
    width: 7.9,
    height: 7.07,
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6,
    y: 65.7,
    width: 7.9,
    height: 7.07,
    fill: "#fdd058"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5,
    y: 66.5,
    width: 6.2,
    height: 5.36,
    fill: "#bbc7d0"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7,72H65.4V66.5h6.3v5.4Zm-6.2-.2h6.1V66.6H65.5Z",
    fill: "#fff4d0"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6,72h-.1V66.5h.1v5.4Z",
    fill: "#fff4d0"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7,69.3H65.4a.1.1,0,0,1,.1-.1h6.2Z",
    fill: "#fff4d0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 65.7,
    width: 7.9,
    height: 7.07,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 65.7,
    width: 7.9,
    height: 7.07,
    fill: "#fdd058"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 81.9,
    y: 66.5,
    width: 6.2,
    height: 5.36,
    fill: "#bbc7d0"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1,72H81.8V66.5h6.4v5.4ZM82,71.8h6V66.6H82Z",
    fill: "#fff4d0"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1,69.3h0a.1.1,0,0,1,.1.1Z",
    fill: "#fff4d0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M85,72h-.1V66.5h.2v5.4Z",
    fill: "#fff4d0"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    points: "64.7 72.1 64.7 63.7 62.3 63.7 62.3 72.1 64.7 72.1",
    fill: "#fdd058"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 63.7,
    width: 0.8,
    height: 20.01,
    fill: "#98aab6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2,
    y: 73.3,
    width: 8.8,
    height: 0.84,
    fill: "#98aab6"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    points: "68 77.6 69.2 77.6 69.2 73.8 67.9 73.8 68 77.6",
    fill: "#98aab6"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9,67.7v-.3a2,2,0,0,1,4,0v.3Z",
    fill: "#fff"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9,67.7v-.5a2,2,0,0,1,4,0v.5Z",
    fill: "#98aab6"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2,67.2a1.3,1.3,0,0,0-2.6,0Z",
    fill: "#98aab6"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2,67.3H75.5a1.4,1.4,0,0,1,1.4-1.4,1.4,1.4,0,0,1,1.4,1.4Zm-2.5-.2h2.4A1.2,1.2,0,0,0,76.9,66,1.1,1.1,0,0,0,75.7,67.1Z",
    fill: "#fff4d0"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9,67.3h-.1V65.9a.1.1,0,0,1,.1-.1H77v1.3Z",
    fill: "#fff4d0"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 75.8,
    y1: 66.2,
    x2: 76.3,
    y2: 67.4,
    fill: "#fff"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3,67.3h-.1l-.5-.7h.1l.6.7Z",
    fill: "#fff4d0"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 66.2,
    x2: 77.5,
    y2: 67.4,
    fill: "#fff"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5,67.3h-.1l.5-.7H78c.1,0,.1.1,0,.1l-.5.7Z",
    fill: "#fff4d0"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    points: "65.5 77.6 65 72.7 62.1 72.7 61.6 77.6 65.5 77.6",
    fill: "#fff"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    points: "65.5 77.6 65 72.7 62.1 72.7 61.6 77.6 65.5 77.6",
    fill: "#fdd058"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    points: "62.3 77 62.6 73.4 64.5 73.4 64.8 77 62.3 77",
    fill: "#fff"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    points: "62.3 77 62.6 73.4 64.5 73.4 64.8 77 62.3 77",
    fill: "#98aab6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1,
    y: 62.2,
    width: 31.6,
    height: 1.5,
    fill: "#fff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1,
    y: 61.6,
    width: 31.6,
    height: 0.68,
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1,
    y: 61.6,
    width: 31.6,
    height: 0.68,
    fill: "#fff4d0"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.3 59.1 76.9 59.1 76.9 59.1 62.5 59.1 61.1 61.6 76.9 61.6 76.9 61.6 92.7 61.6 91.3 59.1",
    fill: "#fdd058"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.3 59.1 76.9 59.1 76.9 59.1 62.5 59.1 61.1 61.6 76.9 61.6 76.9 61.6 92.7 61.6 91.3 59.1",
    fill: "none"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 72.1,
    width: 3.6,
    height: 0.91,
    fill: "#98aab6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 63.7,
    width: 3.6,
    height: 0.91,
    fill: "#98aab6"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "80.6 78.5 80.6 83.8 90.7 83.8 90.7 78.5 80.6 78.5",
    fill: "#98aab6"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 88.1,
    y1: 78.5,
    x2: 89.4,
    y2: 83.8,
    fill: "#fff"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4,83.8h0L88,78.6h.2l1.3,5.2Z",
    fill: "#fff4d0"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 89.4,
    y1: 78.5,
    x2: 88.1,
    y2: 83.8,
    fill: "#fff"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1,83.8H88l1.4-5.2h.1l-1.3,5.2Z",
    fill: "#fff4d0"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 89.4,
    y1: 78.5,
    x2: 90.7,
    y2: 83.3,
    fill: "#fff"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 90.6,
    y1: 79,
    x2: 89.4,
    y2: 83.8,
    fill: "#fff"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 86.8,
    y1: 78.5,
    x2: 88.2,
    y2: 83.8,
    fill: "#fff"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 88.2,
    y1: 78.5,
    x2: 86.8,
    y2: 83.8,
    fill: "#fff"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 85.6,
    y1: 78.5,
    x2: 86.9,
    y2: 83.8,
    fill: "#fff"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9,83.8h-.1l-1.3-5.2h.1L87,83.7Z",
    fill: "#fff4d0"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 86.9,
    y1: 78.5,
    x2: 85.6,
    y2: 83.8,
    fill: "#fff"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6,83.8h-.1l1.3-5.2H87l-1.4,5.2Z",
    fill: "#fff4d0"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 84.3,
    y1: 78.5,
    x2: 85.7,
    y2: 83.8,
    fill: "#fff"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 85.7,
    y1: 78.5,
    x2: 84.3,
    y2: 83.8,
    fill: "#fff"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 83.1,
    y1: 78.5,
    x2: 84.4,
    y2: 83.8,
    fill: "#fff"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4,83.8h-.1L83,78.6h.1l1.4,5.2Z",
    fill: "#fff4d0"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 84.4,
    y1: 78.5,
    x2: 83.1,
    y2: 83.8,
    fill: "#fff"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1,83.8H83l1.3-5.2h.2l-1.4,5.2Z",
    fill: "#fff4d0"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 81.8,
    y1: 78.5,
    x2: 83.2,
    y2: 83.8,
    fill: "#fff"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 83.2,
    y1: 78.5,
    x2: 81.8,
    y2: 83.8,
    fill: "#fff"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 80.6,
    y1: 78.5,
    x2: 81.9,
    y2: 83.8,
    fill: "#fff"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9,83.8h-.1l-1.3-5.2h.1L82,83.7Z",
    fill: "#fff4d0"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 81.9,
    y1: 78.5,
    x2: 80.6,
    y2: 83.8,
    fill: "#fff"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6,83.8h-.1l1.3-5.2H82l-1.4,5.2Z",
    fill: "#fff4d0"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.8 72 88.8 63.7 91.2 63.7 91.2 72.1 88.8 72",
    fill: "#fdd058"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 79.8,
    y: 63.7,
    width: 0.8,
    height: 20.01,
    fill: "#98aab6"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 73.3,
    width: 8.8,
    height: 0.84,
    fill: "#98aab6"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.6 77.6 84.4 77.6 84.4 73.8 85.6 73.8 85.6 77.6",
    fill: "#98aab6"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.1 77.6 88.5 72.7 91.5 72.7 91.9 77.6 88.1 77.6",
    fill: "#fff"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.1 77.6 88.5 72.7 91.5 72.7 91.9 77.6 88.1 77.6",
    fill: "#fdd058"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.3 77 90.9 73.4 89.1 73.4 88.7 77 91.3 77",
    fill: "#98aab6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 72.1,
    width: 3.6,
    height: 0.91,
    fill: "#98aab6"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9,61.6h-.1V59.1H77v2.5Z",
    fill: "#fff4d0"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 69.7,
    y1: 59.2,
    x2: 68.9,
    y2: 61.6,
    fill: "#fff"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9,61.6h0a.1.1,0,0,1-.1-.1l.8-2.4h.1a.1.1,0,0,1,.1.1L69,61.6Z",
    fill: "#fff4d0"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 66.1,
    y1: 59.2,
    x2: 64.9,
    y2: 61.6,
    fill: "#fff"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9,61.6h0l1.2-2.4h.1L65,61.6Z",
    fill: "#fff4d0"
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 73.3,
    y1: 59.2,
    x2: 72.9,
    y2: 61.6,
    fill: "#fff"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9,61.6h0c-.1,0-.1,0-.1-.1l.4-2.3a.1.1,0,0,1,.1-.1c.1,0,.1,0,.1.1L73,61.6Z",
    fill: "#fff4d0"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 59.2,
    x2: 84.9,
    y2: 61.6,
    fill: "#fff"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9,61.6h-.1L84,59.2h.1l.8,2.4Z",
    fill: "#fff4d0"
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 87.6,
    y1: 59.2,
    x2: 88.8,
    y2: 61.6,
    fill: "#fff"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8,61.6h0l-1.2-2.4h.1l1.2,2.4h-.1Z",
    fill: "#fff4d0"
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 80.5,
    y1: 59.2,
    x2: 80.9,
    y2: 61.6,
    fill: "#fff"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9,61.6h-.1l-.4-2.4h0c.1,0,.1,0,.1.1l.4,2.3c.1.1,0,.1,0,.1Z",
    fill: "#fff4d0"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2,
    y: 63.7,
    width: 3.6,
    height: 0.91,
    fill: "#98aab6"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9,
    y: 68.9,
    width: 1.6,
    height: 7.64,
    fill: "#98aab6"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 68.9,
    width: 1.6,
    height: 7.64,
    fill: "#98aab6"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 61.1,
    y: 62.2,
    width: 31.6,
    height: 1.5,
    fill: "#fdd058"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 112.6,
    r: 4.6,
    fill: "#395c6e"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 112.6,
    r: 2.9,
    fill: "#e2e6ec"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1,114.3q-.2.5-.3,0c0-.4-.3-.5-.5-.2s-.4.2-.3-.1,0-.6-.4-.4-.4,0-.1-.3.2-.5-.2-.5-.3-.2,0-.3.5-.3.2-.6-.2-.3.1-.2.6-.1.4-.4,0-.4.3-.1.5.2.5-.2.2-.4.3,0,.3.4.6.2.3-.3.2.1.1.5.4.4.4,0,.1.2-.2.5.2.6.4.2,0,.3-.4.3-.2.5.3.4-.1.3-.5,0-.4.4,0,.4-.2.1S13.2,113.9,13.1,114.3Z",
    fill: "#98aab6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.6,
    cy: 112.6,
    r: 4.6,
    fill: "#395c6e"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.6,
    cy: 112.6,
    r: 2.9,
    fill: "#e2e6ec"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7,114.3c0,.3-.2.3-.2,0s-.4-.5-.6-.2-.4.2-.2-.1-.1-.6-.5-.4-.4,0-.1-.3.2-.5-.1-.5-.4-.2,0-.3.4-.3.1-.6-.2-.3.1-.2.6-.1.5-.4-.1-.4.2-.1.5.2.6-.2.2-.4.2,0,.4.4.6.2.4-.3.2.1.1.5.4.4.5,0,.2.2-.2.5.1.6.4.2,0,.3-.4.3-.1.5.2.4-.2.3-.5,0-.4.4.1.4-.2.1S43.8,113.9,43.7,114.3Z",
    fill: "#98aab6"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M54,111.2c.5-1.4,1.3-1.4,1.3-1.4h2.4l.6-2.5L57.2,104s-.2-.8-.8-.8h-.3l-3.9-6.1H25a2.1,2.1,0,0,0-1.5.8l-4,5.4H9.3s-.9.2-.9.8H5.5s-.9-.2-1,.6a.1.1,0,0,0-.1.1h.1c.3-.1.4.5.4.5v.5s.4-.1.5.4.7,4.2.7,4.2h0a2.7,2.7,0,0,1,.7,1.7h.8l1.1-2.2s.5-1.4,1.6-1.4h4.2a3.3,3.3,0,0,1,2.4,1,7.6,7.6,0,0,1,1.6,2.9,1.4,1.4,0,0,0,1.3,1H37.4l2.2-4.3a.9.9,0,0,1,.9-.6h6.3a1.4,1.4,0,0,1,1.1.9l1.1,2.8h4.7Z",
    fill: "#fbde8b"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2,110l-.4-.2h.4Z",
    fill: "#fbde8b"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 112.6,
    r: 0.9,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.6,
    cy: 112.6,
    r: 0.9,
    fill: "#fff"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 102.8 41.2 98.9 50.1 98.9 53.3 102.8 41.2 102.8",
    fill: "#fff"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    points: "32.4 102.8 32.4 98.9 38.9 98.9 38.9 102.8 32.4 102.8",
    fill: "#fff"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    points: "22.1 102.8 24.8 98.9 30.4 98.9 30.4 102.8 22.1 102.8",
    fill: "#fff"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3,107.6a1,1,0,0,0-.9.4L38,110.6H19.9a1.6,1.6,0,0,1-.8-.3,8.6,8.6,0,0,0-2-2.2,5.8,5.8,0,0,0-2.6-1.3H9.1a2.1,2.1,0,0,0-1.1.6H7.1l-.4-2c-.2-.5.8-.4.8-.4H55.1c.7,0,.7.3.7.3l.5,1.9s.2.5-.5.5Z",
    fill: "#bbc7d0"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 105.7,
    width: 3.1,
    height: 0.93,
    rx: 0.5,
    fill: "#fff"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M21,112.6a1.1,1.1,0,0,1-1.1-1v-7.7h0l4.4-6h.2c.1.1.1.1,0,.2l-4.3,6v7.6s.1.8.8.8h9.8s.3-.1.3-.7V97.9a.1.1,0,0,1,.1-.1c.1,0,.2,0,.2.1v13.8c0,.9-.6.9-.6.9Z",
    fill: "#fbde8b"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1,112.6H31.7s-.6,0-.6-.9.1-.1.2-.1a.1.1,0,0,1,.1.1c0,.6.3.7.3.7H37l1.9-3.7c0-.1.4-1.1,1-1.3V97.9a.1.1,0,0,1,.1-.1h0c.1,0,.2,0,.2.1v9.7h-.1c-.4,0-.9.8-1,1.1l-1.9,3.8Z",
    fill: "#fbde8b"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    y1: 103.9,
    x2: 30.7,
    y2: 103.9,
    fill: "#fff",
    stroke: "#fff4d0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.51
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 37.3,
    y1: 103.9,
    x2: 39.4,
    y2: 103.9,
    fill: "#fff",
    stroke: "#fff4d0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.51
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7,97.5s-2.5-5.3-6.6-4.9-12.3.4-14.9.4-11.4,0-14.9-.4-6.6,4.9-6.6,4.9.2.8.2.8A15.3,15.3,0,0,1,21.8,97H50.9c1.4,0,5.6.2,7.6,1.2C58.5,98.3,59,98.3,58.7,97.5Z",
    fill: "#395c6e"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,102.8h-.1V99c0-.1,0-.2.1-.2a.2.2,0,0,1,.2.2v3.7Z",
    fill: "#fbde8b"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4,102.8h-.1V98.8a.2.2,0,0,1,.2.2v3.7Z",
    fill: "#fbde8b"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9,97.3a.2.2,0,0,1-.2-.2V92.4c0-.1.1-.1.2-.1s.1,0,.1.1v4.7C45,97.2,45,97.3,44.9,97.3Z",
    fill: "#fbde8b"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1,97.1h-.2V92.4c0-.1.1-.1.2-.1s.1,0,.1.1V97Z",
    fill: "#fbde8b"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7,111.3v-1.5H55.3s-.8,0-1.3,1.4l-.3,1h3.8S58.7,112,58.7,111.3Z",
    fill: "#bbc7d0"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M6,110.3h.1s-.7-3.8-.7-4.2-.5-.4-.5-.4v-.5s-.1-.6-.4-.5H4.4c-.2,0-.5.2-.3.6l.7,4.7.4.2C5.4,110.2,5.7,110.6,6,110.3Z",
    fill: "#e2e6ec"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M6,110.3l-.8-.3H4.1s-.7-.1-.7,1.1.5.9.5.9H6.8a2.7,2.7,0,0,0-.7-1.7Z",
    fill: "#bbc7d0"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M105.3,75.4s-5.9,2-6.2,8.4h6.4S105.3,75.3,105.3,75.4Z",
    fill: "#395c6e"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.1 60 145.1 57.3 145.1 57.3 145.2 48.2 120.8 40.8 120.8 46 105.2 51.6 105.1 84 143.4 83.8 145.1 83.8 168.3 83.8 168.4 67 145.1 60",
    fill: "#bbc7d0"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.8 68 139.8 67.8 139.8 46.3 137.4 45.6 137.4 67.8 137.4 68 137.4 68.1 137.4 83.9 139.8 83.9 139.8 68.1 139.8 68",
    fill: "none"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.3 68 137.3 67.8 137.3 45.6 134.9 44.9 134.9 67.8 134.9 68 134.9 68.1 134.9 83.9 137.3 83.9 137.3 68.1 137.3 68",
    fill: "none"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.4 68 142.4 67.8 142.4 47.1 140 46.4 140 67.8 140 68 140 68.1 140 83.9 142.4 83.9 142.4 68.1 142.4 68",
    fill: "none"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.8 68 134.8 67.8 134.8 44.9 132.4 44.1 132.4 67.8 132.4 68 132.4 68.1 132.4 83.9 134.8 83.9 134.8 68.1 134.8 68",
    fill: "none"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.9 68 144.9 67.8 144.9 47.8 142.5 47.1 142.5 67.8 142.5 68 142.5 68.1 142.5 83.9 144.9 83.9 144.9 68.1 144.9 68",
    fill: "none"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.5 68 147.5 67.8 147.5 60.4 145.3 59.7 145.3 57 145.3 57 145.3 48 145.1 47.9 145.1 67.8 145.1 68 145.1 68.1 145.1 83.9 145.3 83.9 145.3 83.8 147.5 83.8 147.5 68.1 147.5 68",
    fill: "none"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.7 68 162.7 67.8 162.7 65 160.3 64.2 160.3 67.8 160.3 68 160.3 68.1 160.3 83.8 162.7 83.8 162.7 68.1 162.7 68",
    fill: "none"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.8 83.8 167.8 68.1 167.8 68 167.8 67.8 167.8 66.5 165.4 65.8 165.4 67.8 165.4 68 165.4 68.1 165.4 83.8 167.8 83.8",
    fill: "none"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.2 68 160.2 67.8 160.2 64.2 157.8 63.5 157.8 67.8 157.8 68 157.8 68.1 157.8 83.8 160.2 83.8 160.2 68.1 160.2 68",
    fill: "none"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    points: "155.1 68 155.1 67.8 155.1 62.7 152.7 62 152.7 67.8 152.7 68 152.7 68.1 152.7 83.8 155.1 83.8 155.1 68.1 155.1 68",
    fill: "none"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.5 68 152.5 67.8 152.5 61.9 150.1 61.2 150.1 67.8 150.1 68 150.1 68.1 150.1 83.8 152.5 83.8 152.5 68.1 152.5 68",
    fill: "none"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.6 68 157.6 67.8 157.6 63.4 155.2 62.7 155.2 67.8 155.2 68 155.2 68.1 155.2 83.8 157.6 83.8 157.6 68.1 157.6 68",
    fill: "none"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    points: "150 68 150 67.8 150 61.1 147.6 60.4 147.6 67.8 147.6 68 147.6 68.1 147.6 83.8 150 83.8 150 68.1 150 68",
    fill: "none"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    points: "165.2 68 165.2 67.8 165.2 65.7 162.8 65 162.8 67.8 162.8 68 162.8 68.1 162.8 83.8 165.2 83.8 165.2 68.1 165.2 68",
    fill: "none"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.4 68 114.4 67.8 114.4 47.9 112 48.8 112 67.8 112 68 112 68.1 112 83.9 114.4 83.9 114.4 68.1 114.4 68",
    fill: "none"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.9 68 111.9 67.8 111.9 48.8 109.5 49.7 109.5 67.8 109.5 68 109.5 68.1 109.5 83.9 111.9 83.9 111.9 68.1 111.9 68",
    fill: "none"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    points: "117 68 117 67.8 117 47 114.6 47.9 114.6 67.8 114.6 68 114.6 68.1 114.6 83.9 117 83.9 117 68.1 117 68",
    fill: "none"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    points: "106.8 68 106.8 67.8 106.8 50.7 105.1 51.3 105.1 83.9 106.8 83.9 106.8 68.1 106.8 68",
    fill: "none"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.9 68 167.9 68.1 167.9 83.8 168.4 83.8 168.5 66.7 167.9 66.5 167.9 67.8 167.9 68",
    fill: "none"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.3 68 109.3 67.8 109.3 49.8 106.9 50.7 106.9 67.8 106.9 68 106.9 68.1 106.9 83.9 109.3 83.9 109.3 68.1 109.3 68",
    fill: "none"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.5 68 119.5 67.8 119.5 46 117.1 46.9 117.1 67.8 117.1 68 117.1 68.1 117.1 83.9 119.5 83.9 119.5 68.1 119.5 68",
    fill: "none"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.2 68 132.2 67.8 132.2 44.1 129.8 43.4 129.8 67.8 129.8 68 129.8 68.1 129.8 83.9 132.2 83.9 132.2 68.1 132.2 68",
    fill: "none"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    points: "127.1 68 127.1 67.8 127.1 42.6 124.7 41.9 124.7 67.8 124.7 68 124.7 68.1 124.7 83.9 127.1 83.9 127.1 68.1 127.1 68",
    fill: "none"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.7 68 129.7 67.8 129.7 43.4 127.3 42.7 127.3 67.8 127.3 68 127.3 68.1 127.3 83.9 129.7 83.9 129.7 68.1 129.7 68",
    fill: "none"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.6 68 124.6 67.8 124.6 41.9 122.2 41.2 122.2 67.8 122.2 68 122.2 68.1 122.2 83.9 124.6 83.9 124.6 68.1 124.6 68",
    fill: "none"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    points: "122 68 122 67.8 122 41.1 121 40.8 121 46 120.4 45.7 119.6 46 119.6 67.8 119.6 68 119.6 68.1 119.6 83.9 122 83.9 122 68.1 122 68",
    fill: "none"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.9 68 167.8 68 167.8 68.1 167.8 83.8 167.9 83.8 167.9 68.1 167.9 68",
    fill: "#e2e6ec"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M167.9,67.7h0V66.5h-.1v1.3Z",
    fill: "#e2e6ec"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M167.9,67.8h-.1V68h.1Z",
    fill: "#e2e6ec"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    points: "165.4 68 165.2 68 165.2 68.1 165.2 83.8 165.4 83.8 165.4 68.1 165.4 68",
    fill: "#e2e6ec"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.8 68 162.7 68 162.7 68.1 162.7 83.8 162.8 83.8 162.8 68.1 162.8 68",
    fill: "#e2e6ec"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.3 68 160.2 68 160.2 68.1 160.2 83.8 160.3 83.8 160.3 68.1 160.3 68",
    fill: "#e2e6ec"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    points: "157.8 68 157.6 68 157.6 68.1 157.6 83.8 157.8 83.8 157.8 68.1 157.8 68",
    fill: "#e2e6ec"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    points: "155.2 68 155.1 68 155.1 68.1 155.1 83.8 155.2 83.8 155.2 68.1 155.2 68",
    fill: "#e2e6ec"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M165.3,67.7h.1v-2h-.2v2.1Z",
    fill: "#e2e6ec"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M162.8,67.7h0V65h-.1v2.8Z",
    fill: "#e2e6ec"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2,67.7h.1V64.2h-.1v3.6Z",
    fill: "#e2e6ec"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M157.7,67.7h.1V63.5h-.2v4.4Z",
    fill: "#e2e6ec"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M155.2,67.7h0V62.7h-.1v5.1Z",
    fill: "#e2e6ec"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M165.3,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M162.8,67.7h-.1V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2,67.7h0V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M157.7,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M155.2,67.7h-.1V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.7 68 152.5 68 152.5 68.1 152.5 83.8 152.7 83.8 152.7 68.1 152.7 68",
    fill: "#e2e6ec"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.1 68 150 68 150 68.1 150 83.8 150.1 83.8 150.1 68.1 150.1 68",
    fill: "#e2e6ec"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.6 68 147.5 68 147.5 68.1 147.5 83.8 147.6 83.8 147.6 68.1 147.6 68",
    fill: "#e2e6ec"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.1 68 144.9 68 144.9 68.1 144.9 83.9 145.1 83.9 145.1 68.1 145.1 68",
    fill: "#e2e6ec"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    points: "142.5 68 142.4 68 142.4 68.1 142.4 83.9 142.5 83.9 142.5 68.1 142.5 68",
    fill: "#e2e6ec"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M152.6,67.7h.1V62h-.2v5.9Z",
    fill: "#e2e6ec"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M150.1,67.7h0V61.2H150v6.6Z",
    fill: "#e2e6ec"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5,67.7h.1V60.4h-.1v7.4Z",
    fill: "#e2e6ec"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M145,67.7h.1V47.9h-.2v20Z",
    fill: "#e2e6ec"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4,67.7h.1V47.1h-.1V67.8Z",
    fill: "#e2e6ec"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M152.6,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M150.1,67.7H150V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5,67.7h0V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M145,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4,67.7h0V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    points: "140 68 139.8 68 139.8 68.1 139.8 83.9 140 83.9 140 68.1 140 68",
    fill: "#e2e6ec"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    points: "137.4 68 137.3 68 137.3 68.1 137.3 83.9 137.4 83.9 137.4 68.1 137.4 68",
    fill: "#e2e6ec"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    points: "134.9 68 134.8 68 134.8 68.1 134.8 83.9 134.9 83.9 134.9 68.1 134.9 68",
    fill: "#e2e6ec"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.4 68 132.2 68 132.2 68.1 132.2 83.9 132.4 83.9 132.4 68.1 132.4 68",
    fill: "#e2e6ec"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    points: "129.8 68 129.7 68 129.7 68.1 129.7 83.9 129.8 83.9 129.8 68.1 129.8 68",
    fill: "#e2e6ec"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M139.9,67.7h.1V46.4h-.2V67.8Z",
    fill: "#e2e6ec"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M137.4,67.7h0V45.6h-.1V67.8Z",
    fill: "#e2e6ec"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M134.8,67.7h.1V44.9h-.1V67.8Z",
    fill: "#e2e6ec"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M132.3,67.7h.1V44.1h-.2V67.8Z",
    fill: "#e2e6ec"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M129.7,67.7h.1V43.4h-.1V67.8Z",
    fill: "#e2e6ec"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M139.9,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M137.4,67.7h-.1V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M134.8,67.7h0V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M132.3,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M129.7,67.7h0V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    points: "127.3 68 127.1 68 127.1 68.1 127.1 83.9 127.3 83.9 127.3 68.1 127.3 68",
    fill: "#e2e6ec"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    points: "124.7 68 124.6 68 124.6 68.1 124.6 83.9 124.7 83.9 124.7 68.1 124.7 68",
    fill: "#e2e6ec"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.2 68 122 68 122 68.1 122 83.9 122.2 83.9 122.2 68.1 122.2 68",
    fill: "#e2e6ec"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.6 68 119.5 68 119.5 68.1 119.5 83.9 119.6 83.9 119.6 68.1 119.6 68",
    fill: "#e2e6ec"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.1 68 117 68 117 68.1 117 83.9 117.1 83.9 117.1 68.1 117.1 68",
    fill: "#e2e6ec"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M127.2,67.7h.1V42.7h-.2V67.8Z",
    fill: "#e2e6ec"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M124.7,67.7h0V41.9h-.1V67.8Z",
    fill: "#e2e6ec"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M122.1,67.7h.1V41.2H122V67.8Z",
    fill: "#e2e6ec"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M119.6,67.7h0V46h-.1V67.8Z",
    fill: "#e2e6ec"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M117,67.7h.1V46.9H117V67.8Z",
    fill: "#e2e6ec"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M127.2,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M124.7,67.7h-.1V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M122.1,67.7H122V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M119.6,67.7h-.1V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M117,67.7h0V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    points: "114.6 68 114.4 68 114.4 68.1 114.4 83.9 114.6 83.9 114.6 68.1 114.6 68",
    fill: "#e2e6ec"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    points: "112 68 111.9 68 111.9 68.1 111.9 83.9 112 83.9 112 68.1 112 68",
    fill: "#e2e6ec"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    points: "109.5 68 109.3 68 109.3 68.1 109.3 83.9 109.5 83.9 109.5 68.1 109.5 68",
    fill: "#e2e6ec"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    points: "106.9 68 106.8 68 106.8 68.1 106.8 83.9 106.9 83.9 106.9 68.1 106.9 68",
    fill: "#e2e6ec"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5,67.7h.1V47.9h-.2V67.8Z",
    fill: "#e2e6ec"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M112,67.7h0v-19h-.1v19Z",
    fill: "#e2e6ec"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M109.4,67.7h.1V49.7h-.2v18Z",
    fill: "#e2e6ec"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M106.9,67.7h0V50.7h-.1V67.8Z",
    fill: "#e2e6ec"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M112,67.7h-.1V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M109.4,67.7h-.1V68h.2v-.2Z",
    fill: "#e2e6ec"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M106.9,67.7h-.1V68h.1v-.2Z",
    fill: "#e2e6ec"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "120.4 46.1 105.1 51.8 105.1 84 145.3 84 145.3 57.4",
    fill: "none"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "120.4 46.1 105.1 51.8 105.1 84 145.3 84 145.3 57.4",
    fill: "none"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    points: "121 46.1 121 44 101.8 51.1 101.8 53.1 121 46.1",
    fill: "#fff"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    points: "121 46.1 121 44 101.8 51.1 101.8 53.1 121 46.1",
    fill: "#fbe7ab"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.2 65.2 121 65.2 121 41.2 145.3 48.4 145.2 65.2",
    fill: "none"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    points: "145.2 65.2 121 65.2 121 41.2 145.3 48.4 145.2 65.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.38
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.6 49.2 147.6 47.4 118.4 38.7 118.4 40.5 147.6 49.2",
    fill: "#e2e6ec"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    points: "147.6 49.2 147.6 47.4 118.4 38.7 118.4 40.5 147.6 49.2",
    fill: "#fbe7ab"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 50.6,
    width: 10.2,
    height: 5.27,
    fill: "#fff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 50.6,
    width: 10.2,
    height: 5.27,
    fill: "#fbe7ab"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 129.6,
    y: 51.8,
    width: 7.9,
    height: 3.01,
    fill: "#395c6e"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M137.8,55h-8.4V51.6h8.4Zm-8-.4h7.5V52h-7.5Z",
    fill: "#e2e6ec"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M133.6,54.9a.1.1,0,0,1-.1-.1v-3h.2v3Z",
    fill: "#e2e6ec"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 55,
    width: 9.8,
    height: 5.27,
    fill: "#fff"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 55,
    width: 9.8,
    height: 5.27,
    fill: "#fbe7ab"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 109.4,
    y: 56.1,
    width: 7.5,
    height: 3.01,
    fill: "#395c6e"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M117.2,59.3h-8V55.9h8Zm-7.5-.4h7.1V56.3h-7.1Z",
    fill: "#e2e6ec"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2,59.2a.1.1,0,0,1-.1-.1v-3a.1.1,0,0,1,.1-.1c.1,0,.1,0,.1.1v3C113.3,59.2,113.3,59.2,113.2,59.2Z",
    fill: "#e2e6ec"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 62.1,
    width: 9.8,
    height: 9.79,
    fill: "#fff"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 62.1,
    width: 9.8,
    height: 9.79,
    fill: "#fbe7ab"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 109.4,
    y: 63.3,
    width: 7.5,
    height: 7.53,
    fill: "#395c6e"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M117.2,71h-8V63h8Zm-7.5-.4h7.1V63.5h-7.1Z",
    fill: "#e2e6ec"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2,70.9h-.1V63.1c.1,0,.1.1.1.2v7.5A.1.1,0,0,1,113.2,70.9Z",
    fill: "#e2e6ec"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 131.9,
    y: 68.5,
    width: 10.1,
    height: 9.79,
    fill: "#fff"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 131.9,
    y: 68.5,
    width: 10.1,
    height: 9.79,
    fill: "#fbe7ab"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 69.7,
    width: 7.9,
    height: 7.53,
    fill: "#395c6e"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M141.1,77.4h-8.3V69.5h8.3Zm-7.9-.4h7.5V69.9h-7.5Z",
    fill: "#e2e6ec"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8,77.3h-.1V69.7a.1.1,0,0,1,.1-.1c.1,0,.1,0,.1.1v7.5Z",
    fill: "#e2e6ec"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.9 67.8 170.9 66 141.7 57.3 141.7 59.1 170.9 67.8",
    fill: "#fbe7ab"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.3 78.2 120.9 78.2 120.9 84 103.3 84 103.3 78.2",
    fill: "#fff"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.3 78.2 120.9 78.2 120.9 84 103.3 84 103.3 78.2",
    fill: "#fbe7ab"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 68.4,
    width: 7.8,
    height: 15.53,
    fill: "#fbe7ab"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 122.8,
    y: 68.4,
    width: 7.8,
    height: 15.53,
    fill: "none"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 123.8,
    y: 69.4,
    width: 5.7,
    height: 13.5,
    fill: "#395c6e"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 124.4,
    y: 70,
    width: 4.5,
    height: 2.12,
    fill: "#e2e6ec"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 124.4,
    y: 73.4,
    width: 4.5,
    height: 2.12,
    fill: "#e2e6ec"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 124.4,
    y: 76.7,
    width: 4.5,
    height: 2.12,
    fill: "#e2e6ec"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 124.4,
    y: 80.1,
    width: 4.5,
    height: 2.12,
    fill: "#e2e6ec"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M151.3,59.8c-2.1-1.9,2.2-2.8-.1-4.8s-1.3-1.4-1.5-3.7-.5-1.8-.9-1.8h-.2a.1.1,0,0,0-.1.1h-.1c-.4,0-.9.2-1,1.8s.8,1.7-1.4,3.7,2,2.9-.1,4.8-3.1,2.7-1.3,5.1.4,1.1.2,4.4,1.7,3.3,3.2,2.6V85.4h.8V71.9a2.5,2.5,0,0,0,3.6-2.6c-.3-3.3-1.7-2,.1-4.4s.9-3.2-1.2-5.1m-2.7-10.3h0",
    fill: "#395c6e"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M160,68.9c-1.8-1.3,1.9-1.9,0-3.2s-1.1-1-1.3-2.6-.5-1.2-.8-1.2h-.4c-.3,0-.7.1-.8,1.2s.7,1.2-1.3,2.6,1.8,1.9,0,3.2-2.7,1.8-1.1,3.5,1.6.8,2.9.4V85.4h.7V72.8c1.3.4,1.6,1.2,3.2-.4s.7-2.2-1.1-3.5m-2.3-7Z",
    fill: "#395c6e"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 80.2,
    width: 17.6,
    height: 0.1,
    fill: "#fff"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 79.3,
    width: 17.6,
    height: 0.1,
    fill: "#fff"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 81.2,
    width: 17.6,
    height: 0.1,
    fill: "#fff"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 82.2,
    width: 17.6,
    height: 0.1,
    fill: "#fff"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 103.3,
    y: 83.1,
    width: 17.6,
    height: 0.1,
    fill: "#fff"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5,49.5a1,1,0,0,1,2,0",
    fill: "#fbde8b"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5,49.4a1,1,0,1,1,2,0",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M184.3,83.8S176.2,77,176.2,62c.1.1.2.1.3-.1s.3.2.1-.2.8.3.7-1.1V58l.5.6a6,6,0,0,0,.2-2.4,3,3,0,0,0,2.3,2.4s.3-1.7-.6-2.3l1.9,1.2c.9.7-.3-2-1.3-2.6,2.3,2,2.2,1,4.4,2s-1.7-3-4.7-5.1c1.5.1,1.7-.6,3.7-.4s-3.8-2.2-5.7-1.6c1-.7,2.3-.4,1.6-.8s-2.8-.2-3.8.4c-.6-1.4-6.2-1.7-5.2-1.2a7.4,7.4,0,0,1,2.7,1.8c-5.3.9-7.7,7.4-6.6,6.2s2-.7,4.4-2.7c-3,2.4-3,6.2-2.4,5.1s1.8-1.7,3.6-3.4c-1.5,1.3-1.4,4.2-1,3.4s1.7-1.7,2.3-2.4c0,.9-.5,1.7.2,2.4l.7-.9v1.7s-.3,2.3.1,2.2.3.2.5.1c-.4,4.4-.4,13.6,4.4,22.1",
    fill: "#395c6e"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M180.9,68.6a.2.2,0,0,0,.3,0c.4-.5.1-.9,0-.9s.9.4,1.2.1-.4-1.1-.4-2c.1.7.5.5.5.5s.1-1.3.2-1.7a4.3,4.3,0,0,0,.9,1,3.4,3.4,0,0,0,.9-.8h.1l.6-.6-.2-.4.4.3a5.8,5.8,0,0,1,1.2-1l-1.8-1.4c1.7-1,3.8.2,3.7-.3a8.7,8.7,0,0,0-5.8-1.1A2.3,2.3,0,0,0,184,59c-1.5-.3-1.5.8-3.5.9a5.9,5.9,0,0,0-5.1-.9,8.6,8.6,0,0,1,2.9,1.3c-1.8.4-5.4,1.5-6.8,4.3.4.4,1-1.4,4.4-1.8a4.6,4.6,0,0,0-2.5,3.5c0,.6,2.1-2.3,3.7-2.4-.7.5-.5,1.3-1.1,2.4a4.4,4.4,0,0,0,2.4-1.7,2.4,2.4,0,0,0,.2,1.7,2.8,2.8,0,0,0,.6-.6v1.1s-.3,1.6.1,1.6l.6-.3a20.3,20.3,0,0,0,4.4,15.7h5A18.2,18.2,0,0,1,180.9,68.6Z",
    fill: "#395c6e"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    points: "229.1 64.8 229.1 57 233.4 57 233.4 83.8 229.2 83.8 229.1 64.8",
    fill: "#fbde8b"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    points: "207.5 50.2 207.5 50.1 207.5 50.1 207.5 50.1 207.5 50.2 185.9 65.7 185.9 83.8 207.5 83.8 207.5 83.8 229.1 83.8 229.1 65.7 207.5 50.2",
    fill: "#fdd058"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M225.8,63.3h-.1L210.1,52c0,.1,0,.2-.1.2a.3.3,0,0,1-.1-.2.1.1,0,0,1,.1-.1l-2.5-1.7h0L185.9,65.7V83.8h43.2V82.2h0V73.5h0V65.7Zm2.8,6.7h.2c0,.1-.1.1-.2.1a.1.1,0,0,1-.1-.1Zm-3.3-6.1h.1a.1.1,0,0,1,.1.1h-.2Zm-.7,2.7c.1,0,.1,0,.1.1h-.1Zm-1.8-2a.1.1,0,0,1,.1.1h-.3C222.6,64.6,222.7,64.6,222.8,64.6Zm-.6-2c.1,0,.1,0,.1.1h-.2A.1.1,0,0,1,222.2,62.6Zm-2.6,1.8h0Zm-1-.4Zm-1.6.3h-.1C216.9,64.3,216.9,64.3,217,64.3Zm-5.3-8.9h0c-.1,0-.1,0-.1-.1Zm0,8.7h-.1C211.6,64.1,211.6,64.1,211.7,64.1ZM210,54.3a.1.1,0,0,1,0,.2h0Zm0,6.4h.1c0,.1,0,.1-.1.1a.1.1,0,0,1-.1-.1Zm.1,2.5h-.2a.1.1,0,0,1,.1-.1C210.1,63.1,210.1,63.1,210.1,63.2Zm-.1,6.2h.1c0,.1,0,.2-.1.2v-.2Zm-.6-11.3a.1.1,0,0,1,.1.1h-.3C209.2,58.1,209.3,58.1,209.4,58.1Zm0,8.7V67h-.3ZM208,52.5c.1,0,.1,0,.1.1a.1.1,0,0,1-.1.1h-.1A.1.1,0,0,1,208,52.5Zm0,8.7h.1c0,.1,0,.1-.1.1a.1.1,0,0,1-.1-.1Zm0,8.8h.1a.1.1,0,0,1-.1.1h0Zm-1.1-15.1a.1.1,0,0,1-.1.1c-.1,0-.2,0-.2-.1s.1-.1.2-.1A.1.1,0,0,1,206.9,54.9Zm0,8.7a.3.3,0,0,1-.1.2.2.2,0,0,1-.2-.2h.3Zm-.3-12.2a.1.1,0,0,1,0,.2h0Zm0,8.8h0Zm0,8.7h0Zm-.5-12c.1,0,.2,0,.2.1s-.1.1-.2.1a.1.1,0,1,1,0-.2Zm0,8.7.2.2H206Zm-.9-7.6a.1.1,0,0,1,.1.1c0,.1,0,.1-.1.1a.1.1,0,0,1-.1-.1Zm0,8.8c.1,0,.1,0,.1.1h-.2A.1.1,0,0,1,205.2,66.8Zm-1.9-8a.1.1,0,0,1,.1.1h-.1a.1.1,0,0,1-.1-.1C203.2,58.8,203.2,58.8,203.3,58.8Zm0,8.8h.1a.1.1,0,0,1-.1.1c-.1,0-.1,0-.1-.1Zm-.5-8.1h.2c0,.1-.1.1-.2.1a.1.1,0,0,1-.1-.1Zm0,8.8c.1,0,.2,0,.2.1h-.3A.1.1,0,0,1,202.8,68.3Zm-.7-6.1h.1a.1.1,0,0,1-.1.1h0Zm-1.8-2h.1a.1.1,0,0,1-.1.1c-.1,0-.2,0-.2-.1Zm0,8.7h.1v.2a.2.2,0,0,1-.2-.2Zm-.6-10.7h.1c0,.1,0,.1-.1.1s-.1,0-.1-.1Zm0,8.7h.1c0,.1,0,.2-.1.2s-.1-.1-.1-.2ZM197,60c.1,0,.1,0,.1.1a.1.1,0,0,1-.1.1h0Zm0,8.8h.1c0,.1,0,.1-.1.1Zm-1-9.2c.1,0,.1,0,.1.1H196Zm0,8.7a.1.1,0,0,1,.1.1H196Zm-1.5-8.4h0a.1.1,0,0,1-.1-.1C194.4,59.9,194.4,59.9,194.5,59.9Zm0,8.8Zm-5.3-.2h0ZM187.5,65c.1,0,.1.1.1.2h-.2A.3.3,0,0,1,187.5,65Zm.1,2.5h0Zm22.5,4.4H210A.1.1,0,0,1,210.1,71.9Zm-23.2,8.3h0Zm0-8.8c-.1,0-.2,0-.2-.1h.3A.1.1,0,0,1,186.9,71.4Zm.6,11.4h-.1a.1.1,0,0,1,.1-.1c.1,0,.1,0,.1.1Zm-.1-6.5h.2a.1.1,0,0,1-.1.1Zm.1-2.3h0a.1.1,0,0,1,.1.1Zm1.7,3.4c-.1,0-.1,0-.1-.1h.1Zm5.3.2h0Zm1.5-.4h0c.1,0,.1,0,.1.1Zm1,.5h.1A.1.1,0,0,1,197,77.7Zm2.7-1.8c-.1,0-.1,0-.1-.1h.2C199.8,75.9,199.8,75.9,199.7,75.9Zm.6,2c-.1,0-.2,0-.2-.1h.3A.1.1,0,0,1,200.3,77.9Zm1.8,2h.1C202.2,79.9,202.2,79.9,202.1,79.9Zm0-8.8Zm.7,6.1a.1.1,0,0,1-.1-.1h.3C203,77.2,202.9,77.2,202.8,77.2Zm.5-.7h-.1c0-.1,0-.1.1-.1a.1.1,0,0,1,.1.1Zm1.9-.8a.1.1,0,0,1-.1-.1h.2C205.3,75.7,205.3,75.7,205.2,75.7Zm.9,7.7H206v-.2l.2.2Zm0-8.8h0Zm.5,3.2h0Zm.2,3.5a.2.2,0,0,1-.2-.2h.2a.3.3,0,0,1,.1.2Zm0-8.8h-.2c0-.1.1-.1.2-.1a.1.1,0,0,1,.1.1ZM208,79c0-.1-.1-.1-.1-.2h.2C208.1,78.9,208.1,79,208,79Zm1.4-3.2h-.2c0-.1.1-.1.2-.1a.1.1,0,0,1,.1.1Zm.6,4.9h-.1a.1.1,0,0,1,.1-.1c.1,0,.1,0,.1.1Zm0-2.3a.1.1,0,0,1-.1-.1h.2C210.1,78.4,210.1,78.4,210,78.4Zm1.7,3.4h-.1c0-.1,0-.1.1-.1h0Zm0-8.8h0Zm5.3,8.9h-.1c0-.1,0-.1.1-.1Zm0-8.7c-.1,0-.1,0-.1-.1h.1Zm1.6,8.4h0Zm0-8.7a.1.1,0,0,1-.1-.1h.1Zm1,9.1h0Zm0-8.7h-.1a.1.1,0,0,1,.1-.1h0Zm2.6,7h-.1a.1.1,0,0,1,.1-.1c.1,0,.1,0,.1.1Zm0-8.8h0a.1.1,0,0,1,.1.1Zm.6,10.8h-.2c0-.1.1-.1.2-.1a.1.1,0,0,1,.1.1Zm0-8.8h0Zm1.8,2h0Zm.8,6.1h0Zm0-8.7h-.1a.1.1,0,0,0-.1-.1c0-.1.1-.1.1-.2h.1v.2Zm.4,7.9h0Zm0-8.7h0Zm1.9,8h0Zm0-8.8h0Zm.9,7.7h-.1a.1.1,0,0,1,.1-.1c.1,0,.2,0,.2.1Z",
    fill: "none"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M228.6,70.2c.1,0,.2,0,.2-.1h-.3A.1.1,0,0,0,228.6,70.2Z",
    fill: "#fff4d0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M225.4,64.1h.1a.1.1,0,0,0-.1-.1h-.1v.2Z",
    fill: "#fff4d0"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M225.8,63.3Z",
    fill: "#fff4d0"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M227.7,79.9h0Z",
    fill: "#fff4d0"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M225.4,81.4h-.1v.2h.1Z",
    fill: "#fff4d0"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M228.6,78.8a.1.1,0,0,0-.1.1h.3C228.8,78.8,228.7,78.8,228.6,78.8Z",
    fill: "#fff4d0"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1,82.1h0Z",
    fill: "#fff4d0"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M225.8,80.7h0Z",
    fill: "#fff4d0"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M227.7,71.2h0Z",
    fill: "#fff4d0"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M225.4,72.6h-.1v.3h.2Z",
    fill: "#fff4d0"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1,73.4h0v-.2Z",
    fill: "#fff4d0"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M225.8,71.9h0Z",
    fill: "#fff4d0"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M217,64.4h0c-.1,0-.1,0-.1.1Z",
    fill: "#fff4d0"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M224.6,66.8h.1c0-.1,0-.1-.1-.1h0Z",
    fill: "#fff4d0"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M205.2,66.9h.1c0-.1,0-.1-.1-.1a.1.1,0,0,0-.1.1Z",
    fill: "#fff4d0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 68.7,
    r: 0.1,
    fill: "#fff4d0"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M189.2,68.6Z",
    fill: "#fff4d0"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M225.3,64.1v-.2h0Z",
    fill: "#fff4d0"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M222.8,64.8h.1a.1.1,0,0,0-.1-.1c-.1,0-.2,0-.2.1Z",
    fill: "#fff4d0"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.2,
    cy: 62.7,
    r: 0.1,
    fill: "#fff4d0"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4,67.1h.1v-.2l-.2.2Z",
    fill: "#fff4d0"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M210,69.7c.1,0,.1-.1.1-.2h-.2Z",
    fill: "#fff4d0"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M208,70.2a.1.1,0,0,0,.1-.1H208Z",
    fill: "#fff4d0"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M206.6,63.6a.2.2,0,0,0,.2.2.3.3,0,0,0,.1-.2h-.3Z",
    fill: "#fff4d0"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M203.3,67.7a.1.1,0,0,0,.1-.1h-.2C203.2,67.7,203.2,67.7,203.3,67.7Z",
    fill: "#fff4d0"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,63.2h.2c0-.1,0-.1-.1-.1A.1.1,0,0,0,209.9,63.2Z",
    fill: "#fff4d0"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M205.2,58.2c.1,0,.1,0,.1-.1a.1.1,0,0,0-.1-.1h-.1A.1.1,0,0,0,205.2,58.2Z",
    fill: "#fff4d0"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M202.8,68.5h.2c0-.1-.1-.1-.2-.1a.1.1,0,0,0-.1.1Z",
    fill: "#fff4d0"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.3,
    cy: 69,
    r: 0.1,
    fill: "#fff4d0"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M199.7,67.2c.1,0,.1-.1.1-.2h-.2C199.6,67.1,199.6,67.2,199.7,67.2Z",
    fill: "#fff4d0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M206.1,65.9h.2l-.2-.2v.2Z",
    fill: "#fff4d0"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.5,
    cy: 60,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.1,
    cy: 62.3,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.6,
    cy: 69,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.7,
    cy: 64.2,
    r: 0.1,
    fill: "#fff4d0"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M187.4,67.5h0Z",
    fill: "#fff4d0"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M219.6,64.5Z",
    fill: "#fff4d0"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4,58.3h.1a.1.1,0,0,0-.1-.1c-.1,0-.2,0-.2.1Z",
    fill: "#fff4d0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M210,60.9c.1,0,.1,0,.1-.1h-.2A.1.1,0,0,0,210,60.9Z",
    fill: "#fff4d0"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M208,61.4c.1,0,.1,0,.1-.1h-.2A.1.1,0,0,0,208,61.4Z",
    fill: "#fff4d0"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M206.6,54.9c0,.1.1.1.2.1a.1.1,0,0,0,0-.2C206.7,54.8,206.6,54.8,206.6,54.9Z",
    fill: "#fff4d0"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M203.3,59h.1a.1.1,0,0,0-.1-.1c-.1,0-.1,0-.1.1A.1.1,0,0,0,203.3,59Z",
    fill: "#fff4d0"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M210,54.5a.1.1,0,0,0,0-.2h0Z",
    fill: "#fff4d0"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M218.6,64.1h0Z",
    fill: "#fff4d0"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M202.8,59.7c.1,0,.2,0,.2-.1h-.3A.1.1,0,0,0,202.8,59.7Z",
    fill: "#fff4d0"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M200.3,60.4a.1.1,0,0,0,.1-.1h-.3C200.1,60.4,200.2,60.4,200.3,60.4Z",
    fill: "#fff4d0"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.7,
    cy: 58.3,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.1,
    cy: 57,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.6,
    cy: 60.3,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 68.8,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.7,
    cy: 55.4,
    r: 0.1,
    fill: "#fff4d0"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,65.3h.1c0-.1,0-.2-.1-.2a.3.3,0,0,0-.1.2Z",
    fill: "#fff4d0"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M196,68.5h.1a.1.1,0,0,0-.1-.1h0Z",
    fill: "#fff4d0"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,52a.3.3,0,0,0,.1.2c.1,0,.1-.1.1-.2H210A.1.1,0,0,0,209.9,52Z",
    fill: "#fff4d0"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M208,52.7a.1.1,0,0,0,.1-.1c0-.1,0-.1-.1-.1a.1.1,0,0,0-.1.1Z",
    fill: "#fff4d0"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M206.6,51.6a.1.1,0,0,0,0-.2h0Z",
    fill: "#fff4d0"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 60.1,
    r: 0.1,
    fill: "#fff4d0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M196,59.7h.1c0-.1,0-.1-.1-.1Z",
    fill: "#fff4d0"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 81.9,
    r: 0.1,
    fill: "#fff4d0"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M225.2,81.5h.1v-.2Z",
    fill: "#fff4d0"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.8,
    cy: 82.2,
    r: 0.1,
    fill: "#fff4d0"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M222.2,80.1a.1.1,0,0,0-.1.1h.2C222.3,80.1,222.3,80.1,222.2,80.1Z",
    fill: "#fff4d0"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 73.1,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.6,
    cy: 75.4,
    r: 0.1,
    fill: "#fff4d0"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8,81h-.2a.2.2,0,0,0,.2.2h.1A.3.3,0,0,0,206.8,81Z",
    fill: "#fff4d0"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M210,80.6a.1.1,0,0,0-.1.1h.2C210.1,80.6,210.1,80.6,210,80.6Z",
    fill: "#fff4d0"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M205.2,75.5h-.1a.1.1,0,0,0,.1.1c.1,0,.1,0,.1-.1Z",
    fill: "#fff4d0"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.1,
    cy: 83.3,
    r: 0.1,
    fill: "#fff4d0"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M194.5,77.4h0Z",
    fill: "#fff4d0"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M202.1,79.7h0c.1,0,.1,0,.1-.1Z",
    fill: "#fff4d0"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7,81.6c-.1,0-.1,0-.1.1h.1Z",
    fill: "#fff4d0"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.2,
    cy: 77.3,
    r: 0.1,
    fill: "#fff4d0"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M225.2,72.8a.1.1,0,0,1,.1.1v-.3C225.3,72.7,225.2,72.7,225.2,72.8Z",
    fill: "#fff4d0"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.8,
    cy: 73.4,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.2,
    cy: 71.4,
    r: 0.1,
    fill: "#fff4d0"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.6,
    cy: 82,
    r: 0.1,
    fill: "#fff4d0"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4,75.6c-.1,0-.2,0-.2.1h.3A.1.1,0,0,0,209.4,75.6Z",
    fill: "#fff4d0"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M210,78.2h-.1a.1.1,0,0,0,.1.1c.1,0,.1,0,.1-.1Z",
    fill: "#fff4d0"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M208,78.7h-.1c0,.1.1.1.1.2s.1-.1.1-.2Z",
    fill: "#fff4d0"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8,72.3c-.1,0-.2,0-.2.1h.3A.1.1,0,0,0,206.8,72.3Z",
    fill: "#fff4d0"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M203.3,76.3c-.1,0-.1,0-.1.1h.2A.1.1,0,0,0,203.3,76.3Z",
    fill: "#fff4d0"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,71.9h.2a.1.1,0,0,0-.1-.1Z",
    fill: "#fff4d0"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M218.6,81.5h0Z",
    fill: "#fff4d0"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M202.8,77h-.1a.1.1,0,0,0,.1.1c.1,0,.2,0,.2-.1Z",
    fill: "#fff4d0"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M200.3,77.7h-.2c0,.1.1.1.2.1a.1.1,0,0,0,.1-.1Z",
    fill: "#fff4d0"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.7,
    cy: 75.8,
    r: 0.1,
    fill: "#fff4d0"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M206.1,74.4h0Z",
    fill: "#fff4d0"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.1,
    cy: 71.1,
    r: 0.1,
    fill: "#fff4d0"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M206.7,77.8h0Z",
    fill: "#fff4d0"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.7,
    cy: 72.9,
    r: 0.1,
    fill: "#fff4d0"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M186.9,80h0Z",
    fill: "#fff4d0"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,82.6a.1.1,0,0,0-.1.1h.2C187.6,82.6,187.6,82.6,187.5,82.6Z",
    fill: "#fff4d0"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,76.4a.1.1,0,0,0,.1-.1h-.1Z",
    fill: "#fff4d0"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.6,
    cy: 73.2,
    r: 0.1,
    fill: "#fff4d0"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M218.6,72.7h-.1a.1.1,0,0,0,.1.1h0Z",
    fill: "#fff4d0"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M197,77.5h0a.1.1,0,0,0,.1-.1Z",
    fill: "#fff4d0"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M186.9,71.2h-.2c0,.1.1.1.2.1a.1.1,0,0,0,.1-.1Z",
    fill: "#fff4d0"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5,73.8h.1A.1.1,0,0,0,187.5,73.8Z",
    fill: "#fff4d0"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M196,77.1h.1C196.1,77.1,196.1,77.1,196,77.1Z",
    fill: "#fff4d0"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    points: "207.5 50.2 207.5 50.1 207.5 50.1 207.5 50.1 207.5 50.2 185.9 65.7 185.9 83.8 207.5 83.8 207.5 83.8 229.1 83.8 229.1 65.7 207.5 50.2",
    fill: "none"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M183.2,66.3a1.1,1.1,0,0,1,.3-1.5,1,1,0,0,1,1.4.3",
    fill: "#fbde8b"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M184.9,65.1a1.1,1.1,0,0,1,.3-1.5,1,1,0,0,1,1.4.3",
    fill: "#fbde8b"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M186.6,63.9a1.2,1.2,0,0,1,.2-1.5,1.1,1.1,0,0,1,1.5.3",
    fill: "#fbde8b"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M188.3,62.7a1.1,1.1,0,0,1,.2-1.4,1,1,0,0,1,1.5.2",
    fill: "#fbde8b"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M190,61.5a.9.9,0,0,1,.2-1.4,1,1,0,0,1,1.4.2",
    fill: "#fbde8b"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6,60.3a1,1,0,0,1,.3-1.4,1.1,1.1,0,0,1,1.4.2",
    fill: "#fbde8b"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3,59.1a1,1,0,0,1,.3-1.4,1,1,0,0,1,1.4.3",
    fill: "#fbde8b"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M195,58a1.1,1.1,0,0,1,.3-1.5,1,1,0,0,1,1.4.3",
    fill: "#fbde8b"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7,56.8a1.1,1.1,0,0,1,.3-1.5,1,1,0,0,1,1.4.3",
    fill: "#fbde8b"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M198.4,55.6a1.1,1.1,0,0,1,.2-1.4,1,1,0,0,1,1.5.2",
    fill: "#fbde8b"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M200.1,54.4a1.1,1.1,0,0,1,.2-1.4,1.1,1.1,0,0,1,1.5.2",
    fill: "#fbde8b"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M201.8,53.2a.9.9,0,0,1,.2-1.4,1.1,1.1,0,0,1,1.4.2",
    fill: "#fbde8b"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M203.4,52a1,1,0,0,1,.3-1.4,1,1,0,0,1,1.4.3",
    fill: "#fbde8b"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M205.1,50.9a1.1,1.1,0,0,1,.3-1.5,1,1,0,0,1,1.4.3",
    fill: "#fbde8b"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M231.8,66.3a1.1,1.1,0,0,0-.3-1.5,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M231.8,66.2a1,1,0,0,0-.3-1.4,1,1,0,0,0-1.4.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M230.1,65.1a1.1,1.1,0,0,0-.3-1.5,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M228.4,63.9a1.1,1.1,0,0,0-.3-1.5,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M226.7,62.7a1.1,1.1,0,0,0-.2-1.4,1,1,0,0,0-1.5.2",
    fill: "#fbde8b"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M225,61.5a1,1,0,0,0-.2-1.4,1.1,1.1,0,0,0-1.5.2",
    fill: "#fbde8b"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3,60.3a.9.9,0,0,0-.2-1.4,1.1,1.1,0,0,0-1.4.2",
    fill: "#fbde8b"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M221.7,59.1a1,1,0,0,0-.3-1.4,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M220,58a1.1,1.1,0,0,0-.3-1.5,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M218.3,56.8a1.1,1.1,0,0,0-.3-1.5,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M216.6,55.6a1,1,0,0,0-.3-1.4.9.9,0,0,0-1.4.2",
    fill: "#fbde8b"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M214.9,54.4a1.1,1.1,0,0,0-.2-1.4,1.1,1.1,0,0,0-1.5.2",
    fill: "#fbde8b"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M213.2,53.2a1,1,0,0,0-.2-1.4,1.2,1.2,0,0,0-1.5.2",
    fill: "#fbde8b"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,52a.9.9,0,0,0-.2-1.4,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,50.9a1.1,1.1,0,0,0-.3-1.5,1,1,0,0,0-1.4.3",
    fill: "#fbde8b"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M183.2,66.2a1,1,0,0,1,.3-1.4,1.1,1.1,0,0,1,1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M184.9,65a1,1,0,0,1,1.7-1.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M186.6,63.8a1.1,1.1,0,0,1,.2-1.4,1.2,1.2,0,0,1,1.5.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M188.3,62.6a1.1,1.1,0,0,1,.2-1.4,1.1,1.1,0,0,1,1.5.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M190,61.5a1,1,0,0,1,.2-1.5,1,1,0,0,1,1.4.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M191.6,60.3a1.1,1.1,0,0,1,.3-1.5,1,1,0,0,1,1.4.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3,59.1a1,1,0,0,1,.3-1.4.9.9,0,0,1,1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M195,57.9a1,1,0,0,1,1.7-1.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M196.7,56.7a1,1,0,0,1,.3-1.4,1.1,1.1,0,0,1,1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M198.4,55.5a1.1,1.1,0,0,1,.2-1.4,1.1,1.1,0,0,1,1.5.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M200.1,54.4a1.2,1.2,0,0,1,.2-1.5,1.1,1.1,0,0,1,1.5.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M201.8,53.2a1,1,0,0,1,.2-1.5,1,1,0,0,1,1.4.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M203.4,52a1,1,0,0,1,.3-1.4.9.9,0,0,1,1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M205.1,50.8a1,1,0,0,1,.3-1.4,1,1,0,0,1,1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M230.1,65a1,1,0,0,0-1.7-1.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M228.4,63.8a1,1,0,0,0-.3-1.4,1.1,1.1,0,0,0-1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M226.7,62.6a1.1,1.1,0,0,0-.2-1.4,1.1,1.1,0,0,0-1.5.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M225,61.5a1.1,1.1,0,0,0-.2-1.5,1.1,1.1,0,0,0-1.5.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3,60.3a1,1,0,0,0-.2-1.5,1,1,0,0,0-1.4.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M221.7,59.1a1,1,0,0,0-.3-1.4.9.9,0,0,0-1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M220,57.9a1,1,0,0,0-1.7-1.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M218.3,56.7a1,1,0,0,0-.3-1.4,1.1,1.1,0,0,0-1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M216.6,55.5a1,1,0,1,0-1.7-1.1",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M214.9,54.4a1.2,1.2,0,0,0-.2-1.5,1.1,1.1,0,0,0-1.5.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M213.2,53.2a1.1,1.1,0,0,0-.2-1.5,1.1,1.1,0,0,0-1.5.3",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5,52a1,1,0,0,0-1.6-1.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,50.8a1,1,0,0,0-.3-1.4,1,1,0,0,0-1.4.2",
    fill: "none",
    stroke: "#98aab6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.33
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.8 66.3 207.5 49.1 207.5 49 207.5 49.1 207.5 49 207.5 49.1 183.3 66.3 183.3 67.7 207.5 50.4 231.8 67.7 231.8 66.3",
    fill: "#fff"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,56.2a2.4,2.4,0,1,0-4.8,0v3.4h4.8Z",
    fill: "#fff"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M209.9,56.2a2.4,2.4,0,1,0-4.8,0v3.4h4.8Z",
    fill: "#fff"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M205.7,58.9V56.2a1.8,1.8,0,0,1,3.6,0v2.7Z",
    fill: "#e2e6ec"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M209.3,59h-3.6a.1.1,0,0,1-.1-.1V56.2a1.9,1.9,0,0,1,3.8,0v2.7A.1.1,0,0,1,209.3,59Zm-3.5-.1h3.4V56.2a1.7,1.7,0,0,0-3.4,0Z",
    fill: "#fff"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M207.5,58.9c-.1,0-.1,0-.1-.1V54.2a.1.1,0,0,1,.1-.1h.1v4.6A.1.1,0,0,1,207.5,58.9Z",
    fill: "#fff"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M209.1,56.9h-3.3c0-.1,0-.1.1-.1h3.2c.1,0,.1,0,.1.1Z",
    fill: "#fff"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 188.4,
    y: 65,
    width: 9.6,
    height: 11.27,
    fill: "#fff"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 188.4,
    y: 65,
    width: 9.6,
    height: 11.27,
    fill: "none"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 65.6,
    width: 8.3,
    height: 10.01,
    fill: "#fff"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 189.5,
    y: 66.1,
    width: 7.4,
    height: 9.05,
    fill: "#e2e6ec"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 202.7,
    y: 65,
    width: 9.6,
    height: 11.27,
    fill: "#fff"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 203.3,
    y: 65.6,
    width: 8.3,
    height: 10.01,
    fill: "#fff"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 203.8,
    y: 66.1,
    width: 7.4,
    height: 9.05,
    fill: "#e2e6ec"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 216.7,
    y: 65,
    width: 9.6,
    height: 11.27,
    fill: "#fff"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 216.7,
    y: 65,
    width: 9.6,
    height: 11.27,
    fill: "none"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 217.4,
    y: 65.6,
    width: 8.3,
    height: 10.01,
    fill: "#fff"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 217.9,
    y: 66.1,
    width: 7.4,
    height: 9.05,
    fill: "#e2e6ec"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M207.5,75.2a.1.1,0,0,1-.1-.1v-9h.2v9C207.6,75.2,207.6,75.2,207.5,75.2Z",
    fill: "#fff"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M193.5,76h-.1V66.1h.1v9.8Z",
    fill: "#fff"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 185.2,
    y: 71.8,
    width: 1.3,
    height: 12.02,
    fill: "#98aab6"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 200.2,
    y: 71.8,
    width: 1.3,
    height: 12.02,
    fill: "#98aab6"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 192.8,
    y: 71.8,
    width: 1.3,
    height: 5.46,
    fill: "#98aab6"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 228.5,
    y: 71.8,
    width: 1.3,
    height: 12.02,
    fill: "#98aab6"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M221.5,76h0V66.1h.1v9.8Z",
    fill: "#fff"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 213.5,
    y: 71.8,
    width: 1.3,
    height: 12.02,
    fill: "#98aab6"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 220.9,
    y: 71.8,
    width: 1.3,
    height: 5.87,
    fill: "#98aab6"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 183.8,
    y: 76.3,
    width: 48,
    height: 1.43,
    fill: "#98aab6"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 183.9,
    y: 73.1,
    width: 17.6,
    height: 1.43,
    fill: "#98aab6"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 213.6,
    y: 73.1,
    width: 17.6,
    height: 1.43,
    fill: "#98aab6"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 183.8,
    y: 71.3,
    width: 18.4,
    height: 0.55,
    fill: "#98aab6"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.2 76.3 207.5 76.3 201.8 76.3 199.9 86.3 199.9 88.9 207.5 88.9 207.5 88.9 215.1 88.9 215.1 86.3 213.2 76.3",
    fill: "#fff"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.2 76.3 207.5 76.3 201.8 76.3 199.9 86.3 199.9 88.9 207.5 88.9 207.5 88.9 215.1 88.9 215.1 86.3 213.2 76.3",
    fill: "#fdd058"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    points: "202.6 76.3 200.9 86.3 200.9 88.9 214 88.9 214 86.3 212.3 76.3 202.6 76.3",
    fill: "#fbde8b"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 228.6,
    y: 56.1,
    width: 5.3,
    height: 0.94,
    fill: "#fdd058"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M219.8,81.7s1.1-1.4.6-1.7-.8.8-.8.8.5-2.2.1-2.4-1.3,2.1-1.3,2.1-.2-1.2-.6-1.3-.1,1.6-.1,1.6-.9-2.2-1.2-1.9.5,2.8.5,2.8-.9-1.1-1.2-1,.1,4.4,3,4.3,3.3-4.5,2.7-4.8-1.7,1.5-1.7,1.5",
    fill: "#395c6e"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M227.3,81.7s1.1-1.4.6-1.7-.8.8-.8.8.6-2.2.2-2.4-1.4,2.1-1.4,2.1-.2-1.2-.6-1.3-.1,1.6-.1,1.6-.9-2.2-1.2-1.9.5,2.8.5,2.8-.8-1.1-1.2-1,.1,4.4,3,4.3,3.3-4.5,2.8-4.8-1.8,1.5-1.8,1.5",
    fill: "#395c6e"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M190.2,81.7s1.1-1.4.6-1.7-.9.8-.9.8.6-2.2.2-2.4-1.3,2.1-1.3,2.1-.2-1.2-.6-1.3-.2,1.6-.2,1.6-.8-2.2-1.2-1.9.6,2.8.6,2.8-.9-1.1-1.2-1,.1,4.4,2.9,4.3,3.3-4.5,2.8-4.8-1.7,1.5-1.7,1.5",
    fill: "#395c6e"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M197.7,81.7s1.1-1.4.6-1.7-.9.8-.9.8.6-2.2.2-2.4-1.3,2.1-1.3,2.1-.2-1.2-.6-1.3-.1,1.6-.1,1.6-.9-2.2-1.2-1.9.5,2.8.5,2.8-.9-1.1-1.2-1,.1,4.4,3,4.3,3.3-4.5,2.7-4.8-1.7,1.5-1.7,1.5",
    fill: "#395c6e"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 214.2,
    y: 64.5,
    width: 1.1,
    height: 3.27,
    fill: "#fff4d0"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 64.5,
    width: 1.1,
    height: 3.27,
    fill: "#fff4d0"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 71.3,
    width: 18.4,
    height: 0.55,
    fill: "#98aab6"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.8 66.3 207.5 49.1 207.5 49 207.5 49.1 207.5 49 207.5 49.1 183.3 66.3 183.3 67.7 207.5 50.4 231.8 67.7 231.8 66.3",
    fill: "#98aab6"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M214.4,86.6h0Z",
    fill: "#fdd058"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M212.9,78.4h0Z",
    fill: "#fdd058"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M213.6,82.4H201.3a.1.1,0,0,1-.1-.1h12.5A.1.1,0,0,1,213.6,82.4Z",
    fill: "#fdd058"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8,84.4h.1C213.9,84.4,213.9,84.4,213.8,84.4Z",
    fill: "#fdd058"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M213.3,80.4h.1A.1.1,0,0,1,213.3,80.4Z",
    fill: "#fdd058"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M49,68.8c-.3-.8-1.4-.7-2.2-.5s-2.6,1.4-2.9.5,3.5-2.3,3.5-2.3a1.5,1.5,0,0,0,.9-1.3c-.1-.5-.7-.9-1.6-.4s-2.2,1.1-2.5.4,2.3-1.9,2.3-1.9,1.3-.7,1.1-1.2-.8-.4-1.5,0l-1.9.9c-.6.3-1.1.2-1.2-.2s1.2-.9,2.2-1.5,2.3-1.1,1.9-1.8-.6-.3-1.1,0l-1.4.6s-.7.4-.9.1a.5.5,0,0,1,.1-.7c.2-.3,2.8-1.2,2.9-2.6s-.3-.5-.8-.3-1.3.7-1.5.2.4-.8,1.1-1.4,1.6-1.8,1.4-2.6-.1-1.5-1.4-.5l-1.4,1.1c-.6.4-1.1.4-1.1-.1a2.3,2.3,0,0,1,1-1.8s1.6-1.1,1.4-1.6-.5-.2-1.1.3l-1.2.8s-.8-.8.9-2.4a2.3,2.3,0,0,0,.9-2.1l-.2-.7c-.1-.8-.6-1-1-.6s-.7.2-.7-.3a3.9,3.9,0,0,1,.6-1.5c.2-.4.6-.9.5-1.1s-.2-.4-.5-.2l-.5.4a2.3,2.3,0,0,1,0-1.7c.3-.7.7-.9.6-2s-.8-2.4-1.2-1c0-.5,0-1.4-.3-1.4s-.3,1.8-.3,1.8-.5,2.4-.6,2.4-.6,2-.6,2.3.8,1,1,2.1-.4,1.4-.9.2a.6.6,0,0,0-1.2.2,2.8,2.8,0,0,0,.7,2.3c.4.4,1.2.9,1,1.5s-.3.4-.6.3a1.6,1.6,0,0,1-.9-.5c-.4-.3-.9.1-.9.8s1.2,2,1.2,2,1.1,1.1,1.1,1.6-.5.4-1.1,0-1.3-.9-1.8-.2.3,1.2.8,1.6,1.4.8,1.2,1.4-1,.2-1.4,0-.9-.3-1.1.1.6,1.2,1,1.6,1.7,1.1,1.4,1.6-1.3-.1-1.8-.3a.9.9,0,0,0-1.2.2c-.2.5.1.9,1.1,1.4S41,62,40.6,62.6s-2.5-.3-2.5-.3-1.4-.3-1.5.3.5.9,1.2,1.2,2,.7,1.8,1.4-1.6.2-2.2,0-1.2-.1-1.3.3.4,1.1,1.1,1.4,3,1,2.5,2-2.4-.2-2.4-.2-1.3-.5-1.9.4,2.3,3.2,5.9,5v9.5h1.1V74.1c1.3-.3,3.4-1.7,5.1-2.9S49,68.8,49,68.8Z",
    fill: "#395c6e"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    points: "18.8 52.9 35.4 52.9 52.4 83.8 33.6 83.8 18.8 52.9",
    fill: "#98aab6"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,72.2a.9.9,0,0,0,.9.8.8.8,0,0,0,.9-.8,1.3,1.3,0,0,1-.9-.7C41.3,71.9,41,72.1,40.5,72.2Z",
    fill: "none"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,55.3a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,31.8,55.3Z",
    fill: "none"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M26,59.3h0a1.2,1.2,0,0,1-1,.7h0a1.1,1.1,0,0,0,1,.9h0a.9.9,0,0,0,.9-.9h0A1,1,0,0,1,26,59.3Z",
    fill: "none"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,67.1a.9.9,0,1,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,35.7,67.1Z",
    fill: "none"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,65.4a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,31.8,65.4Z",
    fill: "none"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,68.1h0a1,1,0,0,0,.9.9h0a1.1,1.1,0,0,0,.9-1h.1a1.1,1.1,0,0,1-1-.7h0A1,1,0,0,1,34.7,68.1Z",
    fill: "none"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,59.3a1,1,0,0,1-1,.7.1.1,0,0,1,.1.1.9.9,0,1,0,1.8,0h0A.9.9,0,0,1,27.9,59.3Z",
    fill: "none"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,59.9a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,34.7,59.9Z",
    fill: "none"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,66a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,34.7,66Z",
    fill: "none"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,80.6a1.1,1.1,0,0,1-.7.6h-.3a1.1,1.1,0,0,0,1,.8,1.1,1.1,0,0,0,.9-.8H45A.9.9,0,0,1,44.4,80.6Z",
    fill: "none"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,80.1a1.1,1.1,0,0,0,.9-.9.9.9,0,0,1-.9-.7,1.1,1.1,0,0,1-1,.7A1.1,1.1,0,0,0,44.4,80.1Z",
    fill: "none"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,65.3a.9.9,0,0,1-.9.8h0a.9.9,0,1,0,1.8,0h.1A1,1,0,0,1,33.7,65.3Z",
    fill: "none"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,67.4a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,31.8,67.4Z",
    fill: "none"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,70.1h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9.1.1,0,0,1,.1-.1,1.1,1.1,0,0,1-1-.7h0A1,1,0,0,1,34.7,70.1Z",
    fill: "none"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M27,56a.9.9,0,0,0,1.8,0h0a1,1,0,0,1-.9-.8,1.1,1.1,0,0,1-1,.8Z",
    fill: "none"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M24,56.9a.9.9,0,0,0,.9-.9H25a1.1,1.1,0,0,1-1-.8,1,1,0,0,1-.9.8h0A.9.9,0,0,0,24,56.9Z",
    fill: "none"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,58.1H25a1,1,0,0,1-1-.8.9.9,0,0,1-.9.8h0a.9.9,0,0,0,.9.9A.9.9,0,0,0,24.9,58.1Z",
    fill: "none"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,60.1h0A.1.1,0,0,1,25,60h0a1,1,0,0,1-1-.7.9.9,0,0,1-.9.7h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M26,58.9h0a.9.9,0,0,0,.9-.9h0a1,1,0,0,1-.9-.7h0a1.2,1.2,0,0,1-1,.7h0A1.1,1.1,0,0,0,26,58.9Z",
    fill: "none"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,78.5a1,1,0,0,1-.9.7.9.9,0,1,0,1.8,0A1,1,0,0,1,34.7,78.5Z",
    fill: "none"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M25,56.3a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,25,56.3Z",
    fill: "none"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,81.2h0a.9.9,0,0,0,.9-.9h.1a1.1,1.1,0,0,1-1-.7h0a1,1,0,0,1-.9.7h0A.9.9,0,0,0,35.6,81.2Z",
    fill: "none"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,68a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,34.7,68Z",
    fill: "none"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,69.1a.9.9,0,1,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,35.7,69.1Z",
    fill: "none"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6,81.2h-.2a.9.9,0,0,0,1.8,0h-.3a.9.9,0,0,1-.6-.6A1.1,1.1,0,0,1,45.6,81.2Z",
    fill: "none"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,68.4a1,1,0,0,1-.9.7.9.9,0,1,0,1.8,0A1,1,0,0,1,34.7,68.4Z",
    fill: "none"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,67.1h0a.9.9,0,0,1-.9-.8.9.9,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,80.6a1.1,1.1,0,0,1-.7.6h-.2a.9.9,0,0,0,1.8,0h-.2A.9.9,0,0,1,36.6,80.6Z",
    fill: "none"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M25,58.3a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,25,58.3Z",
    fill: "none"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M25,56h0a1.1,1.1,0,0,0,1,.9h0a.9.9,0,0,0,.9-.9h0a1,1,0,0,1-.9-.7h0a1.2,1.2,0,0,1-1,.7Z",
    fill: "none"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,65.4a.9.9,0,0,1-.9.7.9.9,0,0,0,1.8,0A1.1,1.1,0,0,1,29.8,65.4Z",
    fill: "none"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,62.4a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,34.7,62.4Z",
    fill: "none"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,63.1a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,35.7,63.1Z",
    fill: "none"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,72.2h.1a1.1,1.1,0,0,1-1-.7h0a1,1,0,0,1-.9.7h0a.9.9,0,0,0,.9.9h0A.9.9,0,0,0,36.5,72.2Z",
    fill: "none"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,72.5a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,36.6,72.5Z",
    fill: "none"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,64.1a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1,1,0,0,1-.9-.8,1,1,0,0,1-1,.7Z",
    fill: "none"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,64h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a1.1,1.1,0,0,1-1-.7h0A1,1,0,0,1,34.7,64Z",
    fill: "none"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,74.2a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,38.6,74.2Z",
    fill: "none"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,66a.9.9,0,0,0,.9-.9h.1a1,1,0,0,1-1-.8,1,1,0,0,1-1,.8h.1A.9.9,0,0,0,30.8,66Z",
    fill: "none"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,76.2a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,38.6,76.2Z",
    fill: "none"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,61h-.2a.9.9,0,0,0,1.8,0h-.2a.8.8,0,0,1-.7-.7A1,1,0,0,1,35.9,61Z",
    fill: "none"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,74.2h0a1,1,0,0,1-.9-.8,1.1,1.1,0,0,1-1,.8h0a1,1,0,0,0,1,.9A.9.9,0,0,0,38.5,74.2Z",
    fill: "none"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,74.5a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,36.6,74.5Z",
    fill: "none"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,75.2h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1.3,1.3,0,0,1-1-.8A.9.9,0,0,1,37.6,75.2Z",
    fill: "none"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,63.4a.9.9,0,0,1-.9.7.9.9,0,0,0,1.8,0A1.1,1.1,0,0,1,29.8,63.4Z",
    fill: "none"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,79.2h0a1,1,0,0,0,.9-1h.1a1.1,1.1,0,0,1-1-.7h0a1,1,0,0,1-.9.7h0A.9.9,0,0,0,35.6,79.2Z",
    fill: "none"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,77.2h.1a.9.9,0,0,0,1.8,0h0a.9.9,0,0,1-.9-.8A1,1,0,0,1,41.4,77.2Z",
    fill: "none"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,63.4a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,31.8,63.4Z",
    fill: "none"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,73.2h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1.2,1.2,0,0,1-1-.7C38.5,72.8,38.1,73.1,37.6,73.2Z",
    fill: "none"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9,71.1h-.2a.9.9,0,0,0,1.8,0h-.2a.8.8,0,0,1-.7-.7A1,1,0,0,1,35.9,71.1Z",
    fill: "none"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,80.2h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a1,1,0,0,1-1-.7h0A1,1,0,0,1,44.4,80.2Z",
    fill: "none"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,78.2h0a1,1,0,0,0,.9,1,.9.9,0,0,0,.9-.9h.1a1,1,0,0,1-1-.8A.9.9,0,0,1,42.5,78.2Z",
    fill: "none"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,59.3a1,1,0,0,1-.9.7h0a.9.9,0,0,0,1.8,0h0c0-.1,0-.1.1-.1h0A1,1,0,0,1,33.7,59.3Z",
    fill: "none"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,72.1h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1.1,1.1,0,0,1-.9-.8A1,1,0,0,1,36.6,72.1Z",
    fill: "none"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,65.1h0a1.1,1.1,0,0,1-.9-.8,1.1,1.1,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,67.1h.1a1,1,0,0,1-1-.7,1,1,0,0,1-1,.7h.1a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,74.4a1.1,1.1,0,0,1-1,.8h.1a.9.9,0,0,0,1.8,0h0A1.1,1.1,0,0,1,42.4,74.4Z",
    fill: "none"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,71.1h0a1.2,1.2,0,0,1-1-.7.9.9,0,0,1-.6.7h-.3a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a.1.1,0,0,1,.1.1h0a.9.9,0,0,0,1.8,0h0c.1,0,.1,0,.1.1a.9.9,0,0,0,1.8,0h-.2a1.2,1.2,0,0,1-.7-.7,1,1,0,0,1-1,.7h0a1,1,0,0,1-.9-.7A1.1,1.1,0,0,1,39.5,71.1Z",
    fill: "none"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,69.4a1.2,1.2,0,0,1-.9.8.9.9,0,0,0,1.8,0A1.2,1.2,0,0,1,39.5,69.4Z",
    fill: "none"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,73.1a.1.1,0,0,1,.1.1.9.9,0,0,0,1.8,0h0a1.2,1.2,0,0,1-.9-.8A1,1,0,0,1,41.4,73.1Z",
    fill: "none"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,70.5a1.1,1.1,0,0,1-.7.6h-.2a.9.9,0,0,0,1.8,0h-.3A.9.9,0,0,1,34.7,70.5Z",
    fill: "none"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,68.1c.1.5.4.9.9.9a.9.9,0,0,0,.9-.9,1.1,1.1,0,0,1-.9-.7A.9.9,0,0,1,40.5,68.1Z",
    fill: "none"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M25,62.4a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,25,62.4Z",
    fill: "none"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,79.3h0a1.2,1.2,0,0,1-1-.7.8.8,0,0,1-.9.7h0a1,1,0,0,0,1,1A.9.9,0,0,0,39.5,79.3Z",
    fill: "none"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,79.5a1.2,1.2,0,0,1-.9.8.9.9,0,0,0,1.8,0A1.2,1.2,0,0,1,39.5,79.5Z",
    fill: "none"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,66.4a1,1,0,0,1-.9.7.9.9,0,1,0,1.8,0A1,1,0,0,1,26.9,66.4Z",
    fill: "none"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,75.1h0a.9.9,0,0,0,.9-.9h.1a1.2,1.2,0,0,1-1-.8h0a1.1,1.1,0,0,1-.9.8h0A.9.9,0,0,0,35.6,75.1Z",
    fill: "none"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,79.2h0a1,1,0,0,1-.9-.7,1.1,1.1,0,0,1-1,.7h.1a.9.9,0,0,0,.9.9A.9.9,0,0,0,41.4,79.2Z",
    fill: "none"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,64a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,26.9,64Z",
    fill: "none"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,79.5a1,1,0,0,1-1,.7h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0A1.1,1.1,0,0,1,37.6,79.5Z",
    fill: "none"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,78.2a1.1,1.1,0,0,0,1,1,1,1,0,0,0,.9-1h0a.9.9,0,0,1-.9-.8,1,1,0,0,1-1,.8Z",
    fill: "none"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,59.3a.9.9,0,0,1-.9.7.9.9,0,1,0,1.8,0A1.1,1.1,0,0,1,29.8,59.3Z",
    fill: "none"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,74.5a1,1,0,0,1-.9.7.9.9,0,1,0,1.8,0A1,1,0,0,1,34.7,74.5Z",
    fill: "none"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,74.1a1.1,1.1,0,0,0,.9-.9.9.9,0,0,1-.9-.7,1.1,1.1,0,0,1-1,.7A1.1,1.1,0,0,0,44.4,74.1Z",
    fill: "none"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,75.2a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,45.4,75.2Z",
    fill: "none"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,72.2h0a.1.1,0,0,1,.1-.1h0a1,1,0,0,1-1-.7,1.2,1.2,0,0,1-.9.8h0a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,81.1a.9.9,0,0,0,.9-.8,1.2,1.2,0,0,1-.9-.8,1.2,1.2,0,0,1-.9.8A.9.9,0,0,0,49.2,81.1Z",
    fill: "none"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,79.2h0a1,1,0,0,1-.9-.7,1,1,0,0,1-1,.7h.1a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,72.5a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,34.7,72.5Z",
    fill: "none"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,79.5a1.1,1.1,0,0,1-.9.8,1,1,0,0,0,.9.8.9.9,0,0,0,.9-.8A1.4,1.4,0,0,1,41.4,79.5Z",
    fill: "none"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,77.2a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,45.4,77.2Z",
    fill: "none"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,59.1h0a1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7h0a1,1,0,0,0,.9,1A.9.9,0,0,0,29.8,59.1Z",
    fill: "none"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,57.9a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,34.7,57.9Z",
    fill: "none"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,71.5a1.3,1.3,0,0,1-1,.7,1,1,0,0,0,1,.8.9.9,0,0,0,.9-.8C32.2,72.1,31.9,71.9,31.8,71.5Z",
    fill: "none"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,58h0a.9.9,0,0,1-.9-.8,1,1,0,0,1-1,.8H27a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,78.5a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,36.6,78.5Z",
    fill: "none"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,58.3a1,1,0,0,1-.9.7.9.9,0,1,0,1.8,0A1,1,0,0,1,26.9,58.3Z",
    fill: "none"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,58.9a.9.9,0,0,0,.9-.9,1.1,1.1,0,0,1-.9-.7.9.9,0,0,1-.9.7A.9.9,0,0,0,29.8,58.9Z",
    fill: "none"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,78.2c.1.5.4.9.9.9a.9.9,0,0,0,.9-.9,1.1,1.1,0,0,1-.9-.7A.9.9,0,0,1,40.5,78.2Z",
    fill: "none"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,58a1,1,0,0,0,1.9,0,.9.9,0,0,1-.9-.7A1.1,1.1,0,0,1,30.8,58Z",
    fill: "none"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,55.3a.9.9,0,0,1-.9.7.9.9,0,1,0,1.8,0A1.1,1.1,0,0,1,29.8,55.3Z",
    fill: "none"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,79.2a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,45.4,79.2Z",
    fill: "none"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,77.2h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1.1,1.1,0,0,1-1-.8A.8.8,0,0,1,37.6,77.2Z",
    fill: "none"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,80.3h0a.9.9,0,1,0,1.8,0h.1a1,1,0,0,1-1-.7A1.2,1.2,0,0,1,42.5,80.3Z",
    fill: "none"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,76.5a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,36.6,76.5Z",
    fill: "none"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,67a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,39.5,67Z",
    fill: "none"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,69a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,39.5,69Z",
    fill: "none"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,76.1a1.1,1.1,0,0,0,.9-.9.9.9,0,0,1-.9-.7,1.1,1.1,0,0,1-1,.7A1.1,1.1,0,0,0,44.4,76.1Z",
    fill: "none"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,79.1a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,39.5,79.1Z",
    fill: "none"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,70.2a1,1,0,0,0,.9.8.9.9,0,0,0,.9-.8,1.4,1.4,0,0,1-.9-.8A1.1,1.1,0,0,1,40.5,70.2Z",
    fill: "none"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,74.2c.1.5.4.9.9.9a.9.9,0,0,0,.9-.9,1.1,1.1,0,0,1-.9-.7A.9.9,0,0,1,40.5,74.2Z",
    fill: "none"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,63.1h0a.9.9,0,1,0,1.8,0,.1.1,0,0,1,.1-.1,1,1,0,0,1-1-.7,1,1,0,0,1-1,.7A.1.1,0,0,1,29.9,63.1Z",
    fill: "none"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,65.1h0a1.1,1.1,0,0,1-.9-.8,1.1,1.1,0,0,1-.9.8h0a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,57a.9.9,0,1,0,1.8,0h0a.9.9,0,0,1-.9-.8.9.9,0,0,1-.9.8Z",
    fill: "none"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,67.1h0a.9.9,0,0,1-.9-.8.9.9,0,0,1-.9.8h0a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,61.4c-.1.4-.4.6-.9.7a.9.9,0,0,0,1.8,0A1.3,1.3,0,0,1,29.8,61.4Z",
    fill: "none"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,63h0a.9.9,0,1,0,1.8,0h0a1.2,1.2,0,0,1-.9-.8A1,1,0,0,1,31.8,63Z",
    fill: "none"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8,64.1h0a.9.9,0,1,0,1.8,0h.1a1,1,0,0,1-1-.7A1.1,1.1,0,0,1,32.8,64.1Z",
    fill: "none"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,67.4a.9.9,0,0,1-.9.7.9.9,0,0,0,1.8,0A1.1,1.1,0,0,1,29.8,67.4Z",
    fill: "none"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,61.4a1.3,1.3,0,0,1-1,.7,1,1,0,0,0,1,.8.9.9,0,0,0,.9-.8C32.2,62,31.9,61.8,31.8,61.4Z",
    fill: "none"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,69.4a1.1,1.1,0,0,1-.9.8.9.9,0,0,0,1.8,0A1.4,1.4,0,0,1,29.8,69.4Z",
    fill: "none"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,76.2h.1a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a.9.9,0,0,1-.9-.8,1,1,0,0,1-1,.8,1.1,1.1,0,0,1-1-.7h0a1,1,0,0,1-.9.7,1,1,0,0,1-1-.8.9.9,0,0,1-.9.8h0a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,74.2h.1a1.1,1.1,0,0,1-1-.8,1.1,1.1,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,72a1.1,1.1,0,0,0,.9-.8H45a.9.9,0,0,1-.6-.6,1.1,1.1,0,0,1-.7.6h-.3A1.1,1.1,0,0,0,44.4,72Z",
    fill: "none"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,76.5a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,34.7,76.5Z",
    fill: "none"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,57h0a.9.9,0,1,0,1.8,0h.1a1,1,0,0,1-1-.7,1,1,0,0,1-1,.7Z",
    fill: "none"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M28,57h0a.9.9,0,0,0,1.8,0h0a.9.9,0,0,1-.9-.8A.9.9,0,0,1,28,57Z",
    fill: "none"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,68.2h.1a1,1,0,0,1-1-.8.9.9,0,0,1-.9.8h0a1,1,0,0,0,.9,1A1,1,0,0,0,34.6,68.2Z",
    fill: "none"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,69.4a1.4,1.4,0,0,1-1,.8,1.1,1.1,0,0,0,1,.8,1.1,1.1,0,0,0,.9-.8A1.1,1.1,0,0,1,31.8,69.4Z",
    fill: "none"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M26,57a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,26,57Z",
    fill: "none"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,59h0a.9.9,0,1,0,1.8,0h0a1,1,0,0,1-.9-.7A1,1,0,0,1,31.8,59Z",
    fill: "none"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,73.1h.1a.9.9,0,0,0,1.8,0h0a1,1,0,0,1-.9-.7A1.1,1.1,0,0,1,39.5,73.1Z",
    fill: "none"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M25,60.4a1.1,1.1,0,0,1-.7.6h-.2a.9.9,0,0,0,1.8,0h-.2A.9.9,0,0,1,25,60.4Z",
    fill: "none"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,75.2h.1a.9.9,0,0,0,1.8,0h0a.9.9,0,0,1-.9-.8A1.1,1.1,0,0,1,39.5,75.2Z",
    fill: "none"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,71.5a1.1,1.1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,39.5,71.5Z",
    fill: "none"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,61.9a.9.9,0,0,0,.9-.8h-.3a.9.9,0,0,1-.6-.6,1.1,1.1,0,0,1-.7.6h-.2A.9.9,0,0,0,34.7,61.9Z",
    fill: "none"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,76.2c.1.5.4.9.9.9a.9.9,0,0,0,.9-.9,1.1,1.1,0,0,1-.9-.7A.9.9,0,0,1,40.5,76.2Z",
    fill: "none"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,59h.1a1,1,0,0,1-1-.7,1,1,0,0,1-1,.7h.1a.9.9,0,0,0,.9.9A1,1,0,0,0,31.7,59Z",
    fill: "none"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,66.1c.1.5.4.9.9.9a.9.9,0,0,0,.9-.9,1.1,1.1,0,0,1-.9-.7A.9.9,0,0,1,40.5,66.1Z",
    fill: "none"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,77.2h.1a.9.9,0,0,0,1.8,0h0a1,1,0,0,1-.9-.7A1.1,1.1,0,0,1,39.5,77.2Z",
    fill: "none"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,66.1a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a.9.9,0,0,1-.9-.8,1,1,0,0,1-1,.8Z",
    fill: "none"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,65.1a.9.9,0,1,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,35.7,65.1Z",
    fill: "none"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,68.1h0a1.1,1.1,0,0,0,1,1,1,1,0,0,0,.9-1h0a.9.9,0,0,1-.9-.8A1,1,0,0,1,36.6,68.1Z",
    fill: "none"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,59.3a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,31.8,59.3Z",
    fill: "none"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,66.1h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a1.1,1.1,0,0,1-1-.7h0A1,1,0,0,1,34.7,66.1Z",
    fill: "none"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,70.1h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a.9.9,0,0,1-.9-.7A1,1,0,0,1,36.6,70.1Z",
    fill: "none"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,65a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,39.5,65Z",
    fill: "none"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,70.2h0c0-.1,0-.1.1-.1h0a1,1,0,0,1-1-.7,1,1,0,0,1-.9.7h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4,76.5v0Z",
    fill: "none"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,70.2h0a.9.9,0,0,0,.9.9h.1L44.8,70h-.4Z",
    fill: "none"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,70.2h0a.9.9,0,0,1-.9-.7,1.1,1.1,0,0,1-.9.7l.5.9h.4A.9.9,0,0,0,28.8,70.2Z",
    fill: "none"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M26,67a.9.9,0,0,0,.9-.9h0a1,1,0,0,1-.9-.7h0a1.6,1.6,0,0,1-.9.7l.4.8Z",
    fill: "none"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,82.6a1.1,1.1,0,0,1-1,.7l.2.5h1.5c.1-.2.2-.3.2-.5A.9.9,0,0,1,44.4,82.6Z",
    fill: "none"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6,67.1l.2.4c.1-.1.1-.2.1-.4Z",
    fill: "none"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,78.2h0a.9.9,0,0,0,.9.9h0a1,1,0,0,0,.9-1h.1a1,1,0,0,1-1-.7h0A1,1,0,0,1,44.4,78.2Z",
    fill: "none"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,68.1h0a1,1,0,0,1-.9-.7h0l-.2.2.7,1.3A1,1,0,0,0,26.9,68.1Z",
    fill: "none"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,79.5a1,1,0,0,1-.9.7h0a.9.9,0,0,0,.9.9,1,1,0,0,0,1-.9h0A1.2,1.2,0,0,1,47.2,79.5Z",
    fill: "none"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,73.2h0a1,1,0,0,1-.9-.7c-.1.3-.2.5-.5.6l.6,1.1A1,1,0,0,0,29.8,73.2Z",
    fill: "none"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,72.2h0a1.1,1.1,0,0,1-.9-.8v.2l.6,1.3A.8.8,0,0,0,28.8,72.2Z",
    fill: "none"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3,78.2a1,1,0,0,0,.9,1,1.1,1.1,0,0,0,1-1h0a1,1,0,0,1-1-.8.9.9,0,0,1-.9.8Z",
    fill: "none"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6,71.1h-.1l.2.4a.4.4,0,0,0,.1-.3Z",
    fill: "none"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,59h-.5l.3.6A.9.9,0,0,0,22,59Z",
    fill: "none"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,74.2a1.1,1.1,0,0,1-.9-.7,1,1,0,0,1-.8.7l.4.7.4.2A.9.9,0,0,0,30.7,74.2Z",
    fill: "none"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1,55h.1A.9.9,0,1,0,22,55h.1a.9.9,0,0,0,.9.9,1,1,0,0,0,1-.9h0a1.1,1.1,0,0,1-1-.8,1.1,1.1,0,0,1-.9.8,1,1,0,0,1-1-.8.9.9,0,0,1-.9.8l-.5-.2.3.7a.9.9,0,0,0,.1-.5Z",
    fill: "none"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M23,58a1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7l.4.7.5.2A.9.9,0,0,0,23,58Z",
    fill: "none"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,56a.9.9,0,0,1-.9-.7l-.2.3.6,1.2A1,1,0,0,0,21.1,56Z",
    fill: "none"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M22,57h.1a1,1,0,0,1-1-.7,1,1,0,0,1-.4.5l.5,1.1A.8.8,0,0,0,22,57Z",
    fill: "none"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,65.1a1,1,0,0,1-.9-.7l-.4.6.5,1A1,1,0,0,0,25.9,65.1Z",
    fill: "none"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,64.1H25a1,1,0,0,1-1-.7.4.4,0,0,1-.1.3l.6,1.3A.9.9,0,0,0,24.9,64.1Z",
    fill: "none"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,76.5a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,44.4,76.5Z",
    fill: "none"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M24,63.1h-.4l.3.5c0-.1.1-.3.1-.4Z",
    fill: "none"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,62.1h0A.1.1,0,0,1,25,62h0a1.1,1.1,0,0,0,1,.9h0a.9.9,0,0,0,.9-.9h0a.1.1,0,0,1,.1.1.9.9,0,1,0,1.8,0h0a1.1,1.1,0,0,1-.9-.8,1,1,0,0,1-1,.7,1,1,0,0,1-.9-.7h0a1.2,1.2,0,0,1-1,.7,1,1,0,0,1-1-.7,1.1,1.1,0,0,1-.8.8l.3.7.5.2A.9.9,0,0,0,24.9,62.1Z",
    fill: "none"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M24,61.1h-.3a1.2,1.2,0,0,1-.7-.7c0,.2-.2.4-.4.6l.5,1.1A1.1,1.1,0,0,0,24,61.1Z",
    fill: "none"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M23,60a1,1,0,0,1-.9-.7c0,.1-.1.2-.1.3l.6,1.2A1,1,0,0,0,23,60Z",
    fill: "none"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,81.6a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,39.5,81.6Z",
    fill: "none"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4,83.8h.3a.4.4,0,0,1-.1-.3Z",
    fill: "none"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,82.6a1,1,0,0,1-.9.7c0,.2.1.3.2.5h1.4c.1-.2.2-.3.2-.5A1,1,0,0,1,36.6,82.6Z",
    fill: "none"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,83.5a.4.4,0,0,1-.1.3h.2a.4.4,0,0,0-.1-.3Z",
    fill: "none"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,82.6a1,1,0,0,1-.9.7.9.9,0,0,0,.1.5h1.5c.1-.2.2-.3.2-.5A1,1,0,0,1,34.7,82.6Z",
    fill: "none"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,80.6a1.1,1.1,0,0,1-.7.6h-.2a.9.9,0,0,0,1.8,0h-.3A.9.9,0,0,1,34.7,80.6Z",
    fill: "none"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,83.8h.2v0Z",
    fill: "none"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,83.7h.2v-.3C33.7,83.6,33.7,83.7,33.6,83.7Z",
    fill: "none"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,83.8h.1v0Z",
    fill: "none"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,75.2h-.4l.3.5c.1-.1.1-.2.1-.4Z",
    fill: "none"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,83.3a1.2,1.2,0,0,1-.9-.8,1,1,0,0,1-1,.7,1,1,0,0,1-.9-.7,1.1,1.1,0,0,1-1,.7,1.2,1.2,0,0,1-1-.7c0,.4-.4.7-.9.8h0c0,.2.1.3.2.5h1.5c.1-.2.2-.3.2-.5h.1a.9.9,0,0,0,.1.5h1.5c.1-.2.2-.3.2-.5h.1a.9.9,0,0,0,.1.5h1.6a.9.9,0,0,0,.1-.5Z",
    fill: "none"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4,83.8h.2c0-.1-.1-.1-.1-.2S39.5,83.7,39.4,83.8Z",
    fill: "none"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,78.2a.9.9,0,0,1-.9-.7c-.2.4-.5.7-.8.7l.3.8h.5A1.1,1.1,0,0,0,32.7,78.2Z",
    fill: "none"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,77.2h.1a1,1,0,0,1-1-.7,1,1,0,0,1-.4.5l.5,1.1A.8.8,0,0,0,31.7,77.2Z",
    fill: "none"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,76.2a1.1,1.1,0,0,1-.9-.7v.2l.6,1.2A.7.7,0,0,0,30.7,76.2Z",
    fill: "none"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,81.5h0a1,1,0,0,1-.9.7h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1A1,1,0,0,1,45.3,81.5Z",
    fill: "none"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,79.2h-.4l.2.5c.1-.1.1-.2.1-.4Z",
    fill: "none"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,83.3h-.2l.2.4v-.3Z",
    fill: "none"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,81.6a.9.9,0,0,1-.9.7.9.9,0,0,0,.9.8.8.8,0,0,0,.9-.8A1.1,1.1,0,0,1,41.4,81.6Z",
    fill: "none"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,82.3h.1a1,1,0,0,1-1-.7,1.1,1.1,0,0,1-.8.8l.4.8h.4A.9.9,0,0,0,34.6,82.3Z",
    fill: "none"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,80.3a1.1,1.1,0,0,1-.9-.8.3.3,0,0,0-.1.2l.6,1.3A1.3,1.3,0,0,0,32.7,80.3Z",
    fill: "none"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,81.3h-.2a1.2,1.2,0,0,1-.7-.7c0,.2-.2.4-.4.6l.6,1.1A1,1,0,0,0,33.6,81.3Z",
    fill: "none"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,81.3h-.2a1.2,1.2,0,0,1-.7-.7,1,1,0,0,1-1,.7,1,1,0,0,1-.9-.7,1.1,1.1,0,0,1-1,.7,1.2,1.2,0,0,1-1-.7.9.9,0,0,1-.6.7h-.3a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h.1a.9.9,0,1,0,1.8,0h.1a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,69.1a1,1,0,0,1-.9-.7.9.9,0,0,1-.4.6l.5,1A.9.9,0,0,0,27.8,69.1Z",
    fill: "none"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,60.1a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a.9.9,0,0,1-.9-.7,1,1,0,0,1-1,.7Z",
    fill: "none"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,76.1a.9.9,0,0,0,.9-.9h.1a1,1,0,0,1-1-.8,1,1,0,0,1-1,.8h.1A.9.9,0,0,0,30.8,76.1Z",
    fill: "none"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,77.2h0a.9.9,0,0,1-.9-.8.9.9,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,74.1a.9.9,0,0,0,.9-.9.1.1,0,0,1,.1-.1,1,1,0,0,1-1-.7,1,1,0,0,1-1,.7.1.1,0,0,1,.1.1h0A.9.9,0,0,0,30.8,74.1Z",
    fill: "none"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,68.1h0a.9.9,0,0,1-.9-.8,1,1,0,0,1-1,.8H27a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,82.3h0a1.1,1.1,0,0,1-.9-.8,1,1,0,0,1-1,.7h0a1,1,0,0,0,1,.9A.9.9,0,0,0,38.5,82.3Z",
    fill: "none"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,79.2h0a1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7h0a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3,82.3h.1a1,1,0,0,1-1-.7,1.2,1.2,0,0,1-.9.8h0a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,62a1.1,1.1,0,0,1-1-.7h0a1,1,0,0,1-.9.7,1,1,0,0,1-1-.7,1.2,1.2,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0h0c0-.1,0-.1.1-.1h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9.1.1,0,0,1,.1-.1h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1.1,1.1,0,0,1-.9-.8A1,1,0,0,1,36.6,62Z",
    fill: "none"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M27,66.1a.9.9,0,1,0,1.8,0h0a.9.9,0,0,1-.9-.8,1,1,0,0,1-1,.8Z",
    fill: "none"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,65.1h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1.3,1.3,0,0,1-1-.8A.9.9,0,0,1,37.6,65.1Z",
    fill: "none"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,82.3h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a1.1,1.1,0,0,1-1-.7h0a1,1,0,0,1-.9.7Z",
    fill: "none"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,57.2a.9.9,0,0,1-.9.8h0a.9.9,0,0,0,.9.9.9.9,0,0,0,.9-.8h.1A1,1,0,0,1,33.7,57.2Z",
    fill: "none"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M26,55a.9.9,0,0,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,26,55Z",
    fill: "none"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M25,55.9a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,25,55.9Z",
    fill: "none"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M28,55h0a.9.9,0,0,0,1.8,0h.1a.9.9,0,1,0,1.8,0h.1a.9.9,0,1,0,1.8,0h0a1.1,1.1,0,0,1-.9-.8,1.1,1.1,0,0,1-.9.8,1,1,0,0,1-1-.8,1,1,0,0,1-1,.8,1.1,1.1,0,0,1-.9-.8A1.1,1.1,0,0,1,28,55Z",
    fill: "none"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,55.9a.9.9,0,0,0,.9-.9,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7A.9.9,0,0,0,34.7,55.9Z",
    fill: "none"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,59a.9.9,0,1,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,35.7,59Z",
    fill: "none"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,55.3a1,1,0,0,1-.9.7A.9.9,0,1,0,23,56,1,1,0,0,1,22.1,55.3Z",
    fill: "none"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M24,59h0a1,1,0,0,1-1-.7,1,1,0,0,1-.9.7h0a1,1,0,0,0,.9,1A1.1,1.1,0,0,0,24,59Z",
    fill: "none"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M26,65h0a.9.9,0,0,0,.9-.9h0a1,1,0,0,1-.9-.7h0a1.2,1.2,0,0,1-1,.7h0A1.1,1.1,0,0,0,26,65Z",
    fill: "none"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M24,57h0a1,1,0,0,1-1-.8.9.9,0,0,1-.9.8h0a.9.9,0,0,0,.9.9A1,1,0,0,0,24,57Z",
    fill: "none"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,60h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9.1.1,0,0,1,.1-.1,1.1,1.1,0,0,1-1-.7h0A1,1,0,0,1,34.7,60Z",
    fill: "none"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,54.9a.9.9,0,0,0,.9-.9,1.1,1.1,0,0,1-.9-.7.9.9,0,0,1-.9.7A.9.9,0,0,0,29.8,54.9Z",
    fill: "none"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,54.9a.9.9,0,0,0,.9-.9h0a.1.1,0,0,1,.1-.1h0a1,1,0,0,1-1-.7,1.1,1.1,0,0,1-.9.8h0A.9.9,0,0,0,33.7,54.9Z",
    fill: "none"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,74.2h0a.9.9,0,0,0,1.8,0h.1a1.1,1.1,0,0,1-1-.8A1.1,1.1,0,0,1,42.5,74.2Z",
    fill: "none"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,54a1,1,0,0,0,1.9,0,.9.9,0,0,1-.9-.7A1.1,1.1,0,0,1,30.8,54Z",
    fill: "none"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,56h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a1.1,1.1,0,0,1-1-.7h0A1,1,0,0,1,34.7,56Z",
    fill: "none"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,82.3h0a1.2,1.2,0,0,1-1-.8,1,1,0,0,1-.9.7h0a.9.9,0,0,0,.9.9A1,1,0,0,0,48.2,82.3Z",
    fill: "none"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M25,54h0a1.1,1.1,0,0,0,1,.9h0a.9.9,0,0,0,.9-.9h0a1,1,0,0,1-.9-.7h0a1.2,1.2,0,0,1-1,.7Z",
    fill: "none"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M27,54a.9.9,0,0,0,1.8,0h0a1,1,0,0,1-.9-.8,1,1,0,0,1-1,.7Z",
    fill: "none"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2,54A.9.9,0,1,0,23,54a1,1,0,0,1-.9-.7A1,1,0,0,1,21.2,54Z",
    fill: "none"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,54a.9.9,0,0,1-.9-.7,1.3,1.3,0,0,1-.9.7l.3.7.6.2A1.1,1.1,0,0,0,21.1,54Z",
    fill: "none"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,58h0a.9.9,0,0,0,.9.8h0a.9.9,0,0,0,.9-.9h.1a1.1,1.1,0,0,1-1-.7h0A1,1,0,0,1,34.7,58Z",
    fill: "none"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M24,54.9a.9.9,0,0,0,.9-.9H25a1,1,0,0,1-1-.7,1,1,0,0,1-.9.8h0A.9.9,0,0,0,24,54.9Z",
    fill: "none"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,57a.9.9,0,1,0,1.8,0,1,1,0,0,1-.9-.7A1,1,0,0,1,35.7,57Z",
    fill: "none"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,74.2h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a1.1,1.1,0,0,1-1-.8h0A1.1,1.1,0,0,1,44.4,74.2Z",
    fill: "none"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,63.1h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a1.2,1.2,0,0,1-1-.7C38.5,62.7,38.1,63,37.6,63.1Z",
    fill: "none"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3,76.2a1,1,0,0,1-1-.7h0a1,1,0,0,1-.9.7,1,1,0,0,1-1-.8.9.9,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0h.1a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.9-.9h.1a.9.9,0,0,0,.9.9,1,1,0,0,0,1-.9h0a1,1,0,0,1-1-.8A.9.9,0,0,1,46.3,76.2Z",
    fill: "none"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,79.2h0a.9.9,0,0,0,.9,1,.9.9,0,0,0,.9-.9h.1a1,1,0,0,1-1-.7A.9.9,0,0,1,47.3,79.2Z",
    fill: "none"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,55.2a1.1,1.1,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0h.1A1.1,1.1,0,0,1,33.7,55.2Z",
    fill: "none"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,66.3a.8.8,0,0,1-.9.8h0a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0A1.1,1.1,0,0,1,38.5,66.3Z",
    fill: "none"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,65.1h.1a.9.9,0,1,0,1.8,0h0a.9.9,0,0,1-.9-.8A1.1,1.1,0,0,1,39.5,65.1Z",
    fill: "none"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,69.1a1.2,1.2,0,0,1-1-.7.8.8,0,0,1-.9.7h0a1,1,0,0,0,1,1,.9.9,0,0,0,.9-.9h.1a.9.9,0,0,0,.9.9.9.9,0,0,0,.9-1h.1a.9.9,0,1,0,1.8,0h0a1,1,0,0,1-.9-.7,1,1,0,0,1-1,.7,1,1,0,0,1-.9-.7A1.1,1.1,0,0,1,39.5,69.1Z",
    fill: "none"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,71.4a1.2,1.2,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0h0a.1.1,0,0,1,.1-.1h0A1,1,0,0,1,43.4,71.4Z",
    fill: "none"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,70.1h0a.9.9,0,0,0,1.8,0h0c0-.1,0-.1.1-.1h0a1,1,0,0,1-1-.7A1,1,0,0,1,42.5,70.1Z",
    fill: "none"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,66.4a1.1,1.1,0,0,1-1,.7h.1a.9.9,0,1,0,1.8,0h0A1,1,0,0,1,40.5,66.4Z",
    fill: "none"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,81.6a1,1,0,0,1-.9.7.9.9,0,0,0,1.8,0A1,1,0,0,1,49.2,81.6Z",
    fill: "none"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,64.4a1,1,0,0,1-.9.7.9.9,0,1,0,1.8,0A1,1,0,0,1,26.9,64.4Z",
    fill: "none"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,68.1h0a1,1,0,0,0,.9,1,1,1,0,0,0,.7-.4l-.7-1.3A1.1,1.1,0,0,1,42.5,68.1Z",
    fill: "none"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,64a.9.9,0,0,0,.9-.9h0a1,1,0,0,1-.9-.7,1.2,1.2,0,0,1-.9.8h0A.9.9,0,0,0,28.9,64Z",
    fill: "none"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,64.1h0a1,1,0,0,1-.9-.8,1,1,0,0,1-1,.7H27a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,69.1a1.1,1.1,0,0,0,1,.9h.3l-.6-1.1A.9.9,0,0,1,43.4,69.1Z",
    fill: "none"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,65.1a.9.9,0,0,0,.9.9h.2L42,64.9l-.6.2Z",
    fill: "none"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,64.1c.1.5.4.9.9.9l.5-.2-.6-1.1A1.2,1.2,0,0,1,40.5,64.1Z",
    fill: "none"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,66.1a.9.9,0,0,0,.6.9l-.5-.9Z",
    fill: "none"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,66.3a1,1,0,0,1-1,.8h.1a.9.9,0,0,0,.9.9,1,1,0,0,0,.9-.7v-.2A1.1,1.1,0,0,1,42.4,66.3Z",
    fill: "none"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,61.1h0c.1,0,.1,0,.1.1h0a.9.9,0,1,0,1.8,0c0-.1,0-.1.1-.1h0a.9.9,0,1,0,1.8,0h-.2a1.2,1.2,0,0,1-.7-.7,1,1,0,0,1-.9.7,1,1,0,0,1-1-.7,1,1,0,0,1-1,.7,1,1,0,0,1-.9-.7,1.2,1.2,0,0,1-.7.7H28a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,69.2h.1a.9.9,0,0,0,.9.9.9.9,0,0,0,.9-1h.1a.9.9,0,1,0,1.8,0h0a1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7,1,1,0,0,1-1-.7,1,1,0,0,1-1,.7,1,1,0,0,1-.9-.7,1,1,0,0,1-.9.7h0a.9.9,0,0,0,.9,1A.9.9,0,0,0,29.8,69.2Z",
    fill: "none"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3,74.2a.9.9,0,0,0,.9.9h.3l-.6-1.2-.6.3Z",
    fill: "none"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,75.2a.9.9,0,0,0,.8.9l-.5-1Z",
    fill: "none"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,76.4a.9.9,0,0,1-.9.8h0a.9.9,0,0,0,.9.9.8.8,0,0,0,.8-.4l-.4-.7A.9.9,0,0,1,48.2,76.4Z",
    fill: "none"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3,78.2a.9.9,0,0,0,.9.9h.5l-.6-1.2A.9.9,0,0,1,48.3,78.2Z",
    fill: "none"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,73.2a.9.9,0,0,0,.9.9.9.9,0,0,0,.6-.3l-.7-1.2A1,1,0,0,1,45.4,73.2Z",
    fill: "none"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8,71.9l-.4-.7h0A1,1,0,0,0,45.8,71.9Z",
    fill: "none"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,71.2h0c.1,0,.1,0,.1.1h0a.9.9,0,0,0,1.8,0c0-.1,0-.1.1-.1h0a.9.9,0,0,0,1.8,0h-.2a1.2,1.2,0,0,1-.7-.7,1,1,0,0,1-.9.7h0a1,1,0,0,1-1-.7,1,1,0,0,1-1,.7h0a1,1,0,0,1-.9-.7,1.2,1.2,0,0,1-.7.7H28a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,71.5c-.1.4-.4.6-.9.7a.9.9,0,0,0,1.8,0A1.1,1.1,0,0,1,29.8,71.5Z",
    fill: "none"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,71.4h0a1,1,0,0,1-.9.7h0a.9.9,0,0,0,.9.9h0a1,1,0,0,0,.9-.6l-.3-.4A1.3,1.3,0,0,1,45.3,71.4Z",
    fill: "none"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2,53.9a.9.9,0,0,0,.9-.9H18.8Z",
    fill: "none"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,53h0a.9.9,0,1,0,1.8,0H29.8A.1.1,0,0,1,29.9,53Z",
    fill: "none"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,53.9h0a.9.9,0,0,0,.9.9h0a.9.9,0,0,0,.7-.3l-.7-1.2A1.1,1.1,0,0,1,34.7,53.9Z",
    fill: "none"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,53.8a.8.8,0,0,0,.9-.8H26.2c0,.1-.1.1-.2.1A.8.8,0,0,0,26.9,53.8Z",
    fill: "none"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,53a.9.9,0,1,0,1.8,0H31.8Z",
    fill: "none"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,53.8a.8.8,0,0,0,.8-.5v-.4H33.8A.8.8,0,0,0,34.7,53.8Z",
    fill: "none"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M28,53a.9.9,0,0,0,1.8,0H28Z",
    fill: "none"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M25,53.8a.8.8,0,0,0,.9-.8c-.1,0-.2,0-.2-.1H24.1A.8.8,0,0,0,25,53.8Z",
    fill: "none"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,73.5a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,31.8,73.5Z",
    fill: "none"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2,53h0A.9.9,0,1,0,22,53a.1.1,0,0,1,.1-.1H20.2Z",
    fill: "none"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,53a.9.9,0,0,0,.9.9,1,1,0,0,0,1-.9h0c-.1,0-.2,0-.2-.1H22.1Z",
    fill: "none"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,60.3a.8.8,0,0,1-.7.7H26a.9.9,0,0,0,1.8,0h-.2A1,1,0,0,1,26.9,60.3Z",
    fill: "none"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,59h0a1.1,1.1,0,0,0,1,1l.5-.2-.7-1.3A.8.8,0,0,1,37.6,59Z",
    fill: "none"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,60.3a.9.9,0,0,1-.6.7h-.3a1,1,0,0,0,1,.9.9.9,0,0,0,.9-.9h0a.1.1,0,0,1,.1.1h0a1,1,0,0,0,.7.9l-.5-1h-.3A1.2,1.2,0,0,1,38.5,60.3Z",
    fill: "none"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,55.9h.3l-.6-1.1a.7.7,0,0,1-.6.3A.9.9,0,0,0,36.6,55.9Z",
    fill: "none"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,61.4a1.1,1.1,0,0,1-.9.7.9.9,0,0,0,1.8,0h0A1.3,1.3,0,0,1,39.5,61.4Z",
    fill: "none"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,60.9h.2l-.5-1.1a.7.7,0,0,1-.6.2A.9.9,0,0,0,39.5,60.9Z",
    fill: "none"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,57.2a1,1,0,0,1-1,.8h0a1,1,0,0,0,1,.9,1,1,0,0,0,.8-.5l-.3-.5A.8.8,0,0,1,37.6,57.2Z",
    fill: "none"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,56a1,1,0,0,0,1,.9l-.6-1Z",
    fill: "none"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M38,57.8l-.4-.7A1.6,1.6,0,0,0,38,57.8Z",
    fill: "none"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,62.3a1.1,1.1,0,0,1-1,.7h.1a.9.9,0,0,0,.9.9.8.8,0,0,0,.7-.4l-.4-.8A.5.5,0,0,1,40.5,62.3Z",
    fill: "none"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,83.5a.4.4,0,0,1-.1.3h.2v-.3Z",
    fill: "none"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1,83.2a1,1,0,0,1-.9-.7,1.2,1.2,0,0,1-1,.7,1,1,0,0,1-1-.7,1.1,1.1,0,0,1-.9.8h0c0,.2.1.3.2.5H49a.9.9,0,0,0,.1-.5h.1c0,.2.1.3.2.5h1.5c.1-.2.2-.3.2-.5h.1a.9.9,0,0,0,.1.5h1.1l-.5-.9A1.1,1.1,0,0,1,51.1,83.2Z",
    fill: "none"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M51,83.8h.2c0-.1-.1-.1-.1-.2S51.1,83.7,51,83.8Z",
    fill: "none"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9,81.1l-.5-.9h-.2A.8.8,0,0,0,50.9,81.1Z",
    fill: "none"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,79.2h0a1.1,1.1,0,0,0,1,.9h.2L49.7,79l-.5.2Z",
    fill: "none"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3,82.6a1,1,0,0,1-.9.7.9.9,0,0,0,.1.5H47c.1-.2.2-.3.2-.5A1,1,0,0,1,46.3,82.6Z",
    fill: "none"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,73.2h0a1.2,1.2,0,0,1-.9-.8,1,1,0,0,1-.9.7h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2,80.5a1.2,1.2,0,0,1-1,.7,1,1,0,0,1-1-.7,1,1,0,0,1-.7.7h-.2a.9.9,0,1,0,1.8,0h.1a1.1,1.1,0,0,0,1,.9.9.9,0,0,0,.9-.8l-.2-.2A1,1,0,0,1,50.2,80.5Z",
    fill: "none"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,75.2h0a1.1,1.1,0,0,1-.9-.8,1.1,1.1,0,0,1-.9.8h0a.9.9,0,0,0,1.8,0Z",
    fill: "none"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,78.3h.1a1,1,0,0,1-1-.8.9.9,0,0,1-.9.8h0a1,1,0,0,0,.9,1A.9.9,0,0,0,34.6,78.3Z",
    fill: "none"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,75.5a1.1,1.1,0,0,1-1,.7,1,1,0,0,0,1.9,0A.9.9,0,0,1,31.8,75.5Z",
    fill: "none"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2,82.3a.8.8,0,0,0,.9.8.8.8,0,0,0,.7-.3l-.4-.8c-.2-.1-.2-.3-.3-.4A1,1,0,0,1,50.2,82.3Z",
    fill: "none"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1,83.8h.3l-.2-.3A.4.4,0,0,1,47.1,83.8Z",
    fill: "none"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,80.3h.1a1,1,0,0,1-1-.7,1.2,1.2,0,0,1-.9.8h0a.9.9,0,1,0,1.8,0Z",
    fill: "none"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1,83.8h.2c-.1-.1-.1-.1-.1-.2S49.1,83.7,49.1,83.8Z",
    fill: "none"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,71.1Z",
    fill: "#395c6e"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,71.1Z",
    fill: "#395c6e"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,71.1h0Z",
    fill: "#395c6e"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,81.2h.3a1.1,1.1,0,0,0,.7-.6.4.4,0,0,1-.1-.3A.9.9,0,0,1,45.3,81.2Z",
    fill: "#395c6e"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,80.3h0a1,1,0,0,1-1,.9h.3a1,1,0,0,0,.7-.7v-.2Z",
    fill: "#395c6e"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3,80.3h-.1a.4.4,0,0,0,.1.3.9.9,0,0,0,.6.6h.3A.9.9,0,0,1,46.3,80.3Z",
    fill: "#395c6e"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,81.2h0Z",
    fill: "#395c6e"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,81.2Z",
    fill: "#395c6e"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,81.2Z",
    fill: "#395c6e"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,79.2Z",
    fill: "#395c6e"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2,80.2Z",
    fill: "#395c6e"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1,80.3h.1a1.1,1.1,0,0,1-1-.9v.2A1.2,1.2,0,0,0,50.1,80.3Z",
    fill: "#395c6e"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,80.3h0a.9.9,0,0,1-.9-1h0a.4.4,0,0,1-.1.3A1.2,1.2,0,0,0,48.2,80.3Z",
    fill: "#395c6e"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1,79.2h0a.9.9,0,0,1-.9.9h.1a1.2,1.2,0,0,0,.9-.8v-.2h-.1Z",
    fill: "#395c6e"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,81.1a.9.9,0,0,1-.9-.8h-.1v.2a1,1,0,0,0,1,.7,1.2,1.2,0,0,0,1-.7.4.4,0,0,1-.1-.3h0A.9.9,0,0,1,49.2,81.1Z",
    fill: "#395c6e"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2,80.2Z",
    fill: "#395c6e"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2,80.3h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.7.7h0A.8.8,0,0,1,50.2,80.3Z",
    fill: "#395c6e"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,79.2h.1a1,1,0,0,0,.9-.7.4.4,0,0,1-.1-.3,1,1,0,0,1-.9,1Z",
    fill: "#395c6e"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,78.2a1.1,1.1,0,0,1-1,1h.1a.9.9,0,0,0,.9-.7v-.3Z",
    fill: "#395c6e"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2,78.2a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0a1,1,0,0,1-.9-1h-.1Z",
    fill: "#395c6e"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 79.5 45.3 79.5 45.3 79.5 45.3 79.5",
    fill: "#395c6e"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,79.2Z",
    fill: "#395c6e"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,79.2h0a.9.9,0,0,1-1.8,0h-.1v.3h0a1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7.4.4,0,0,0,.1-.3h-.1Z",
    fill: "#395c6e"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,78.2h0a.9.9,0,0,1-.9-.9h0c0,.1,0,.2-.1.2A1,1,0,0,0,48.2,78.2Z",
    fill: "#395c6e"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,78.1a.1.1,0,0,1,.1.1h0a.9.9,0,0,0,.8-.4H49A.8.8,0,0,1,48.2,78.1Z",
    fill: "#395c6e"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3,78.2h0a.1.1,0,0,0-.1-.1h0v.3a1,1,0,0,0,1,.7l.5-.2h-.5A.9.9,0,0,1,48.3,78.2Z",
    fill: "#395c6e"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,77.1h.1a1,1,0,0,0,.9-.7.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3,76.2h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0A.9.9,0,0,1,46.3,76.2Z",
    fill: "#395c6e"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,76.2a1,1,0,0,1-1,.9.1.1,0,0,1,.1.1h0a.9.9,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 77.5 45.3 77.5 45.3 77.5 45.3 77.5",
    fill: "#395c6e"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,77.1Z",
    fill: "#395c6e"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,77.2h0a.9.9,0,0,1-1.8,0h-.1v.4h0a1,1,0,0,0,1,.7.9.9,0,0,0,.9-.8c.1,0,.1-.1.1-.2h0a.1.1,0,0,0-.1-.1Z",
    fill: "#395c6e"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,75.2h0c0,.1,0,.2-.1.2a1,1,0,0,0,1,.8h-.1A.9.9,0,0,1,47.3,75.2Z",
    fill: "#395c6e"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6,77v-.5l-.2-.3v.2A.9.9,0,0,0,48.6,77Z",
    fill: "#395c6e"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,75.1h0a.1.1,0,0,1,.1.1h0a1,1,0,0,0,.9-.7.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,75.2h-.1C47.3,75.1,47.3,75.1,47.3,75.2Z",
    fill: "#395c6e"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2,74.2a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0a.9.9,0,0,1-.9-.9h-.1Z",
    fill: "#395c6e"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 75.5 45.3 75.5 45.3 75.5 45.3 75.5",
    fill: "#395c6e"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,75.1h0a.1.1,0,0,1,.1.1h0A.1.1,0,0,0,45.3,75.1Z",
    fill: "#395c6e"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,75.2h0a.9.9,0,0,1-1.8,0h0a.1.1,0,0,0-.1-.1h0v.4h0a1,1,0,0,0,1,.7.9.9,0,0,0,.9-.8c.1,0,.1-.1.1-.2h0c0-.1,0-.1-.1-.1Z",
    fill: "#395c6e"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,73.1h.1a1,1,0,0,0,.8-.6h0A1,1,0,0,1,45.3,73.1Z",
    fill: "#395c6e"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 73.4 45.3 73.4 45.3 73.4 45.3 73.4",
    fill: "#395c6e"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,73.1h0Z",
    fill: "#395c6e"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,73.2h-.1v.3h0a1.1,1.1,0,0,0,1,.8l.6-.3h0a.9.9,0,0,1-.6.3A.9.9,0,0,1,45.4,73.2Z",
    fill: "#395c6e"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,71.1Z",
    fill: "#395c6e"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 71.4 45.3 71.4 45.3 71.4 45.3 71.4",
    fill: "#395c6e"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,71.1Z",
    fill: "#395c6e"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,71.2h-.1v.3h0a1.3,1.3,0,0,0,.6.7v-.2A1,1,0,0,1,45.4,71.2Z",
    fill: "#395c6e"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,83.6c0,.1,0,.1.1.2h.1c-.1-.2-.2-.3-.2-.5Z",
    fill: "#395c6e"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1,83.3c0,.2-.1.3-.2.5H51c.1-.1.1-.1.1-.2Z",
    fill: "#395c6e"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,83.2Z",
    fill: "#395c6e"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,83.3h0c0,.1,0,.1-.1.2l.2.3h.1c-.1-.2-.2-.3-.2-.5Z",
    fill: "#395c6e"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,83.3h-.1a.9.9,0,0,1-.1.5h.1c0-.1.1-.1.1-.2Z",
    fill: "#395c6e"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1,83.2h0v.3c0,.1.1.1.1.2h.1a.9.9,0,0,1-.1-.5Z",
    fill: "#395c6e"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,83.2h.1a1,1,0,0,0,.9-.7.4.4,0,0,1-.1-.3A.9.9,0,0,1,45.3,83.2Z",
    fill: "#395c6e"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,82.3h0a1,1,0,0,1-1,.9h.1a1.1,1.1,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3,82.3h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0A.9.9,0,0,1,46.3,82.3Z",
    fill: "#395c6e"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 83.5 45.3 83.5 45.3 83.5 45.3 83.5",
    fill: "#395c6e"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,83.2Z",
    fill: "#395c6e"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,83.3h-.1c0,.2-.1.3-.2.5h.1a.4.4,0,0,0,.1-.3C47.3,83.4,47.3,83.4,47.3,83.3Z",
    fill: "#395c6e"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,83.3h-.1v.3h0v.3h.1a.9.9,0,0,1-.1-.5Z",
    fill: "#395c6e"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2,81.2Z",
    fill: "#395c6e"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2,82.2h0a1,1,0,0,0,.9-.7h0A.9.9,0,0,1,50.2,82.2Z",
    fill: "#395c6e"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1,82.3h.1a1.1,1.1,0,0,1-1-.9v.3A1,1,0,0,0,50.1,82.3Z",
    fill: "#395c6e"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,81.5a1.2,1.2,0,0,0,1,.8h0a.9.9,0,0,1-.9-.9h0A.3.3,0,0,1,47.2,81.5Z",
    fill: "#395c6e"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3,82.2h0a1,1,0,0,0,.9-.7v-.3h-.1a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4,82l-.3-.5h0C51.2,81.7,51.2,81.9,51.4,82Z",
    fill: "#395c6e"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2,82.2Z",
    fill: "#395c6e"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,82.2h0v.2a1,1,0,0,0,1,.7,1.2,1.2,0,0,0,1-.7.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1,83.1a.8.8,0,0,1-.9-.8h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1.1,1.1,0,0,0,.8-.3h-.1A.8.8,0,0,1,51.1,83.1Z",
    fill: "#395c6e"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,81.2Z",
    fill: "#395c6e"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3,81.3Z",
    fill: "#395c6e"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,81.2h0Z",
    fill: "#395c6e"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 81.5 45.3 81.5 45.3 81.5 45.3 81.5",
    fill: "#395c6e"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4,81.2Z",
    fill: "#395c6e"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2,81.2h0a.9.9,0,0,1-1.8,0h-.1v.3h0a1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7.3.3,0,0,0,.1-.2h-.1Z",
    fill: "#395c6e"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,61h.3a1,1,0,0,0,.7-.7.3.3,0,0,1-.1-.2.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,60.1a.9.9,0,0,1-.9.9h.3a.9.9,0,0,0,.6-.7v-.2h0Z",
    fill: "#395c6e"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,60.1a.3.3,0,0,0,.1.2.8.8,0,0,0,.7.7h.3a1,1,0,0,1-1-.9h0A.1.1,0,0,0,36.5,60.1Z",
    fill: "#395c6e"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,61h0Z",
    fill: "#395c6e"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,61Z",
    fill: "#395c6e"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,61Z",
    fill: "#395c6e"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,60h.1a1.1,1.1,0,0,1-1-1h0v.3A.9.9,0,0,0,38.5,60Z",
    fill: "#395c6e"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,60h0a.7.7,0,0,0,.6-.2h-.1l-.5.2Z",
    fill: "#395c6e"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,60h-.1v.2a1.2,1.2,0,0,0,1,.7h0A.9.9,0,0,1,38.6,60Z",
    fill: "#395c6e"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,58.9a.1.1,0,0,1,.1.1h0a1,1,0,0,0,.9-.7c0-.1-.1-.2-.1-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,58.9h0a.8.8,0,0,0,.8-.5h0A1,1,0,0,1,37.6,58.9Z",
    fill: "#395c6e"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,58c0,.1.1.2.1.3a1,1,0,0,0,.9.7h0a.1.1,0,0,1,.1-.1,1,1,0,0,1-1-.9h-.1Z",
    fill: "#395c6e"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,58.9h.1A.1.1,0,0,0,35.6,58.9Z",
    fill: "#395c6e"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,59h0a.9.9,0,1,1-1.8,0h-.1v.4a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.7V59h0A.1.1,0,0,0,37.5,59Z",
    fill: "#395c6e"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,57.2a.8.8,0,0,0,.5.7H38a1.6,1.6,0,0,1-.4-.7h0Z",
    fill: "#395c6e"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,56.9h0c.1,0,.1,0,.1.1h0a1,1,0,0,0,.9-.7c0-.1-.1-.2-.1-.3A.9.9,0,0,1,35.6,56.9Z",
    fill: "#395c6e"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,56h-.1c0,.1.1.2.1.3a1,1,0,0,0,.9.7h0a.1.1,0,0,1,.1-.1h0A1,1,0,0,1,36.6,56Z",
    fill: "#395c6e"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    points: "37.6 57 37.6 57 37.6 57 37.6 57",
    fill: "#395c6e"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,56.9h0a.1.1,0,0,1,.1.1h0C35.7,56.9,35.7,56.9,35.6,56.9Z",
    fill: "#395c6e"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,57h0a.9.9,0,1,1-1.8,0h0a.1.1,0,0,0-.1-.1v.4a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.8V57h0A.1.1,0,0,0,37.5,57Z",
    fill: "#395c6e"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,54.9h0c.1,0,.1,0,.1.1h0a.7.7,0,0,0,.6-.3h0A.9.9,0,0,1,35.6,54.9Z",
    fill: "#395c6e"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,55h0c0-.1,0-.1-.1-.1h0C35.7,54.9,35.7,54.9,35.7,55Z",
    fill: "#395c6e"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,55h0c0-.1,0-.1-.1-.1v.4a1.1,1.1,0,0,0,1,.7h0A.9.9,0,0,1,35.7,55Z",
    fill: "#395c6e"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M45,71.1h.3a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,45,71.1Z",
    fill: "#395c6e"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,70.1h0c-.1,0-.1,0-.1.1h0C44.3,70.1,44.3,70.1,44.4,70.1Z",
    fill: "#395c6e"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 71.1 45.3 71.1 45.3 71.1 45.3 71.1",
    fill: "#395c6e"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1,71.1h.3a.9.9,0,0,1-.9-.9h0c0,.1,0,.1-.1.1v.2A1.2,1.2,0,0,0,43.1,71.1Z",
    fill: "#395c6e"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3,70.2h0a.9.9,0,0,1-.9.9h.3a1.1,1.1,0,0,0,.7-.6v-.3h0C44.3,70.1,44.3,70.1,44.3,70.2Z",
    fill: "#395c6e"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,71.1h0Z",
    fill: "#395c6e"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,71.1Z",
    fill: "#395c6e"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,71.1h.3a1,1,0,0,0,.7-.7v-.2a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,71.1h.3a.9.9,0,0,0,.6-.7v-.2h0A.9.9,0,0,1,37.6,71.1Z",
    fill: "#395c6e"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,70.2v.2a.8.8,0,0,0,.7.7h.3a1,1,0,0,1-1-.9h0A.1.1,0,0,0,36.5,70.2Z",
    fill: "#395c6e"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,71.1Z",
    fill: "#395c6e"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,71.1h0Z",
    fill: "#395c6e"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,71.1Z",
    fill: "#395c6e"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,69.1h0a.9.9,0,0,0,.7-.3h0A1,1,0,0,1,43.4,69.1Z",
    fill: "#395c6e"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,69.1h.1a1,1,0,0,1-.9-1h-.1v.3A1,1,0,0,0,43.3,69.1Z",
    fill: "#395c6e"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,69.1h0v.3a1,1,0,0,0,1,.7h0A1.1,1.1,0,0,1,43.4,69.1Z",
    fill: "#395c6e"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,69.1Z",
    fill: "#395c6e"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,70.1h0a1.1,1.1,0,0,0,.9-.8v-.3a.9.9,0,0,1-.9,1Z",
    fill: "#395c6e"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,70.2h.1a.9.9,0,0,1-.9-.9v.2A1.2,1.2,0,0,0,40.4,70.2Z",
    fill: "#395c6e"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,69.4a.9.9,0,0,0,.9.7h.1a1,1,0,0,1-1-1h0Z",
    fill: "#395c6e"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,70.1h0a1.2,1.2,0,0,0,.9-.8v-.2h-.1a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,69.1h-.1v.3a1.4,1.4,0,0,0,.9.8.1.1,0,0,1,.1-.1h0A.9.9,0,0,1,41.5,69.1Z",
    fill: "#395c6e"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,69.1h0a.9.9,0,0,1-.9,1h0c.1,0,.1,0,.1-.1a1,1,0,0,0,.9-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,70.1Z",
    fill: "#395c6e"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,70.1h0v.2a1.2,1.2,0,0,0,1,.7h0a1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,70.1a.1.1,0,0,0-.1.1.9.9,0,0,1-.9.8,1,1,0,0,1-.9-.8h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0a1,1,0,0,0,1-.7v-.2Z",
    fill: "#395c6e"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,69.1h.1a1,1,0,0,0,.9-.7c0-.1-.1-.2-.1-.3A1.1,1.1,0,0,1,35.6,69.1Z",
    fill: "#395c6e"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,68.1h-.1c0,.1.1.2.1.3a1,1,0,0,0,.9.7h.1A1.1,1.1,0,0,1,36.6,68.1Z",
    fill: "#395c6e"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,68.1a1,1,0,0,1-.9,1h0a.8.8,0,0,0,.9-.7v-.3Z",
    fill: "#395c6e"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,69.1Z",
    fill: "#395c6e"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,69.1h0a.9.9,0,1,1-1.8,0h-.1v.3a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,66.1h-.1v.2a1.1,1.1,0,0,0,.8.8h-.1A.9.9,0,0,1,42.5,66.1Z",
    fill: "#395c6e"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,68h0a.9.9,0,0,0,.9-.7v-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,68.1h.1a.9.9,0,0,1-.9-.9c0,.1-.1.2-.1.3A1,1,0,0,0,40.4,68.1Z",
    fill: "#395c6e"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,67.1Z",
    fill: "#395c6e"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,67.3a.9.9,0,0,0,.9.8h.1a1,1,0,0,1-1-.9h0Z",
    fill: "#395c6e"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,67.1h0a.9.9,0,0,1-.9.9h0a1,1,0,0,0,.9-.7c0-.1.1-.2.1-.3h-.1Z",
    fill: "#395c6e"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,68h.1a1.1,1.1,0,0,0,.9-.7h-.1A1,1,0,0,1,42.4,68Z",
    fill: "#395c6e"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,67.1v.3a1.1,1.1,0,0,0,.9.7h.1a.9.9,0,0,1-.9-.9Z",
    fill: "#395c6e"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,69a.9.9,0,0,1-.9-.9h-.1v.3a1.2,1.2,0,0,0,1,.7,1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3h0A.9.9,0,0,1,39.5,69Z",
    fill: "#395c6e"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,68Z",
    fill: "#395c6e"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,68.1h-.1a.9.9,0,0,1-.9.9c-.5,0-.8-.4-.9-.9h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.7v-.3Z",
    fill: "#395c6e"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,67h.1a1,1,0,0,0,.9-.7c0-.1-.1-.2-.1-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,66.1a.9.9,0,0,1-.9.9h0a.8.8,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,66.1c0,.1.1.2.1.3a1,1,0,0,0,.9.7h.1a1,1,0,0,1-1-.9h-.1Z",
    fill: "#395c6e"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,67Z",
    fill: "#395c6e"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,67.1h0a.9.9,0,1,1-1.8,0h-.1v.4a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.8v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,66.1h.1a.9.9,0,0,1-.9-.9c0,.1-.1.2-.1.3A1,1,0,0,0,40.4,66.1Z",
    fill: "#395c6e"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,65.1Z",
    fill: "#395c6e"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,66h0a.9.9,0,0,0,.9-.7v-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,66.1h.1a1,1,0,0,1-1-.9h0v.2A.9.9,0,0,0,38.5,66.1Z",
    fill: "#395c6e"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,65.1h0a.9.9,0,0,1-.9.9h0a1,1,0,0,0,.9-.7c0-.1.1-.2.1-.3h-.1Z",
    fill: "#395c6e"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,66.1Z",
    fill: "#395c6e"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,65.1v.3a1.1,1.1,0,0,0,.9.7h.1a.9.9,0,0,1-.9-.9Z",
    fill: "#395c6e"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,67a.9.9,0,0,1-.9-.9h-.1v.2a1.1,1.1,0,0,0,1,.8,1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3h0A.9.9,0,0,1,39.5,67Z",
    fill: "#395c6e"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,66Z",
    fill: "#395c6e"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,66.1h-.1a.9.9,0,0,1-.9.9c-.5,0-.8-.4-.9-.9h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.8v-.2Z",
    fill: "#395c6e"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,65h.1a1,1,0,0,0,.9-.7c0-.1-.1-.2-.1-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,64.1a.9.9,0,0,1-.9.9h0a.9.9,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,64.1c0,.1.1.2.1.3a1,1,0,0,0,.9.7h.1a1,1,0,0,1-1-.9h-.1Z",
    fill: "#395c6e"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,65Z",
    fill: "#395c6e"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,65.1h0a.9.9,0,1,1-1.8,0h-.1v.4a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.8v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,63Z",
    fill: "#395c6e"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,64.1h.1a.9.9,0,0,1-.9-.9c0,.1-.1.2-.1.3A1,1,0,0,0,40.4,64.1Z",
    fill: "#395c6e"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,64h0a1.2,1.2,0,0,0,.8-.4h-.1A.8.8,0,0,1,40.5,64Z",
    fill: "#395c6e"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,64.1h.1a1,1,0,0,1-1-.9h0v.2A1,1,0,0,0,38.5,64.1Z",
    fill: "#395c6e"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,63.1h0a.9.9,0,0,1-.9.9h0a1,1,0,0,0,.9-.7c0-.1.1-.2.1-.3h-.1Z",
    fill: "#395c6e"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,65a.9.9,0,0,1-.9-.9h-.1v.2a1.3,1.3,0,0,0,1,.8,1.1,1.1,0,0,0,1-.8c-.1,0-.1-.1-.1-.2h0A.9.9,0,0,1,39.5,65Z",
    fill: "#395c6e"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,64h0Z",
    fill: "#395c6e"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,64.1h-.1c0,.1,0,.2.1.2a.9.9,0,0,0,.9.8l.6-.2h-.1l-.5.2C40.9,65,40.6,64.6,40.5,64.1Z",
    fill: "#395c6e"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,63h.1a1,1,0,0,0,.9-.7c0-.1-.1-.2-.1-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,62.1a.9.9,0,0,1-.9.9h0c.5-.1.9-.4.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,62.1h0a.1.1,0,0,0-.1.1c0,.1.1.2.1.3a1,1,0,0,0,.9.7h.1A1,1,0,0,1,36.6,62.1Z",
    fill: "#395c6e"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,63Z",
    fill: "#395c6e"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,63h0a.9.9,0,0,1-1.8,0h-.1v.3a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.7v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,61Z",
    fill: "#395c6e"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6,61.1c0,.1-.1.2-.1.3a1.3,1.3,0,0,0,.9.7h-.1A1,1,0,0,1,39.6,61.1Z",
    fill: "#395c6e"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,62h0a1.1,1.1,0,0,0,.9-.7c0-.1.1-.2.1-.3h0a.1.1,0,0,0-.1-.1h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,61.3a1.1,1.1,0,0,0,.9.8h.1a1,1,0,0,1-1-.9h0Z",
    fill: "#395c6e"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,62.9a.8.8,0,0,1-.9-.8h-.1v.2a1.2,1.2,0,0,0,1,.7,1.1,1.1,0,0,0,1-.7h-.1A.8.8,0,0,1,39.5,62.9Z",
    fill: "#395c6e"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8,62.8l-.4-.6h.1A.5.5,0,0,0,40.8,62.8Z",
    fill: "#395c6e"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,61Z",
    fill: "#395c6e"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,61.1Z",
    fill: "#395c6e"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,61h0Z",
    fill: "#395c6e"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,61Z",
    fill: "#395c6e"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,61h0a.9.9,0,0,1-1.8,0h-.1v.3a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.7v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3,80.3Z",
    fill: "#395c6e"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M45,81.2h.3a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,45,81.2Z",
    fill: "#395c6e"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 81.2 45.3 81.2 45.3 81.2 45.3 81.2",
    fill: "#395c6e"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,81.2h.1a.9.9,0,0,1-.9-.9h-.1v.2a1.2,1.2,0,0,0,.7.7Z",
    fill: "#395c6e"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,80.6v-.3h-.1a.9.9,0,0,1-.9.9h.3A1.1,1.1,0,0,0,44.4,80.6Z",
    fill: "#395c6e"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,81.2h0Z",
    fill: "#395c6e"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,81.2Z",
    fill: "#395c6e"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,81.2h.3a1.1,1.1,0,0,0,.7-.6c0-.1-.1-.2-.1-.3A.9.9,0,0,1,35.6,81.2Z",
    fill: "#395c6e"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,81.2a1,1,0,0,1-1-.9h-.1c0,.1.1.2.1.3a.9.9,0,0,0,.7.6h.3Z",
    fill: "#395c6e"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,80.3h0a.9.9,0,0,1-.9.9h.3a.9.9,0,0,0,.6-.7v-.2Z",
    fill: "#395c6e"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,81.2h0Z",
    fill: "#395c6e"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,81.2h0Z",
    fill: "#395c6e"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,81.2Z",
    fill: "#395c6e"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,79.2h0a.9.9,0,0,1-.9-.9v.2A.9.9,0,0,0,45.3,79.2Z",
    fill: "#395c6e"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,78.2Z",
    fill: "#395c6e"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 79.2 45.3 79.2 45.3 79.2 45.3 79.2",
    fill: "#395c6e"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,79.2h.1a1,1,0,0,1-.9-1h-.1v.3A1,1,0,0,0,43.3,79.2Z",
    fill: "#395c6e"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3,78.2h0a.9.9,0,0,1-.9.9h0a1.1,1.1,0,0,0,1-.7v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,79.2h0a1,1,0,0,1-1.9,0h0v.3a1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7h0Z",
    fill: "#395c6e"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,79.2h0v0Z",
    fill: "#395c6e"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6,79.3a.3.3,0,0,1-.1.2,1.2,1.2,0,0,0,.9.8h.1A.9.9,0,0,1,39.6,79.3Z",
    fill: "#395c6e"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,79.5v-.3a.9.9,0,0,1-.9,1h0A1.1,1.1,0,0,0,41.4,79.5Z",
    fill: "#395c6e"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,79.2h0Z",
    fill: "#395c6e"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,79.5a.3.3,0,0,0,.1-.2h-.1a.9.9,0,0,1-.9.9h0A1.2,1.2,0,0,0,39.5,79.5Z",
    fill: "#395c6e"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,79.2h0v.3a1.1,1.1,0,0,0,.9.8h.1A1,1,0,0,1,37.6,79.2Z",
    fill: "#395c6e"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,79.2h-.1v.3a1.4,1.4,0,0,0,.9.8h.1A.9.9,0,0,1,41.5,79.2Z",
    fill: "#395c6e"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,79.2h0a.9.9,0,0,1-.9,1h.1a1.2,1.2,0,0,0,.9-.8v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,80.2h0a.9.9,0,0,1-1.8,0h-.1v.2a1.2,1.2,0,0,0,1,.7,1.1,1.1,0,0,0,1-.7A.4.4,0,0,1,40.4,80.2Z",
    fill: "#395c6e"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,80.2Z",
    fill: "#395c6e"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,80.2h-.1a.9.9,0,0,1-.9.8,1,1,0,0,1-.9-.8h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.7v-.2Z",
    fill: "#395c6e"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,79.2h.1a1,1,0,0,0,.9-.7v-.3a1,1,0,0,1-.9,1Z",
    fill: "#395c6e"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,78.2h0a1,1,0,0,1-.9,1h0a.8.8,0,0,0,.9-.7v-.3Z",
    fill: "#395c6e"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,79.2h.1a1.1,1.1,0,0,1-1-1h-.1v.3A1,1,0,0,0,37.5,79.2Z",
    fill: "#395c6e"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,79.2Z",
    fill: "#395c6e"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,79.5v-.3h-.1a.9.9,0,0,1-1.8,0h-.1v.3a1.1,1.1,0,0,0,1,.7A1,1,0,0,0,37.6,79.5Z",
    fill: "#395c6e"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 77.1 45.3 77.1 45.3 77.1 45.3 77.1",
    fill: "#395c6e"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,76.2Z",
    fill: "#395c6e"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,77.2h0a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,45.3,77.2Z",
    fill: "#395c6e"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,77.2h0a1.1,1.1,0,0,0,1-.7v-.3h-.1a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,76.4a.9.9,0,0,0,.9.8h.1a.9.9,0,0,1-.9-.9h-.1Z",
    fill: "#395c6e"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,77.2h.1v.2a1,1,0,0,0,1,.8,1,1,0,0,0,.9-.7h0v-.3h0a1,1,0,0,1-1.9,0h-.1Z",
    fill: "#395c6e"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,77.2h0v-.1h0Z",
    fill: "#395c6e"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,77.2Z",
    fill: "#395c6e"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,78.2h0a.1.1,0,0,1,.1-.1.9.9,0,0,1-.9-.9v.3A1,1,0,0,0,40.4,78.2Z",
    fill: "#395c6e"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,78.1h0a.9.9,0,0,0,.9-.7v-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,78.2a.1.1,0,0,1,.1-.1,1,1,0,0,1-1-.9h0v.2a.9.9,0,0,0,.9.8Z",
    fill: "#395c6e"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,77.2h0a.9.9,0,0,1-.9.9h0a1,1,0,0,0,.9-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,78.1h.1a.9.9,0,0,0,.9-.8v-.2h-.1A.9.9,0,0,1,42.4,78.1Z",
    fill: "#395c6e"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,77.2v.3a1.1,1.1,0,0,0,.9.7h.1a.9.9,0,0,1-.9-.9Z",
    fill: "#395c6e"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,79.1a.9.9,0,0,1-.9-.9h0a.1.1,0,0,0-.1.1h0v.3a1.2,1.2,0,0,0,1,.7,1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3h0A.9.9,0,0,1,39.5,79.1Z",
    fill: "#395c6e"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,78.1Z",
    fill: "#395c6e"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,78.2h-.1a.9.9,0,0,1-.9.9c-.5,0-.8-.4-.9-.9h0a.1.1,0,0,0-.1.1h0a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.7v-.3Z",
    fill: "#395c6e"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,77.1a.1.1,0,0,1,.1.1h0a1,1,0,0,0,.9-.7v-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,77.2h0a.8.8,0,0,0,.9-.8v-.2h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,77.2h0a.1.1,0,0,1,.1-.1,1,1,0,0,1-1-.9h-.1v.3A1,1,0,0,0,37.5,77.2Z",
    fill: "#395c6e"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,77.2h0a.1.1,0,0,0-.1-.1h0A.1.1,0,0,1,35.7,77.2Z",
    fill: "#395c6e"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,77.4v-.2h0a.1.1,0,0,0-.1.1h0a.9.9,0,0,1-1.8,0h0a.1.1,0,0,0-.1-.1v.4a1.1,1.1,0,0,0,1,.7A1,1,0,0,0,37.6,77.4Z",
    fill: "#395c6e"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,75.2h0a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,45.3,75.2Z",
    fill: "#395c6e"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,74.2Z",
    fill: "#395c6e"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 75.1 45.3 75.1 45.3 75.1 45.3 75.1",
    fill: "#395c6e"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,75.2h0a.1.1,0,0,1,.1-.1.9.9,0,0,1-.9-.9h-.1v.2A1.1,1.1,0,0,0,43.3,75.2Z",
    fill: "#395c6e"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3,74.2h0a.9.9,0,0,1-.9.9h0a1.1,1.1,0,0,0,1-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,75.2h0a1,1,0,0,1-1.9,0h0a.1.1,0,0,0-.1.1h.1v.2a1,1,0,0,0,1,.8,1,1,0,0,0,.9-.7h0Z",
    fill: "#395c6e"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,75.2h0v-.1h0Z",
    fill: "#395c6e"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,75.2Z",
    fill: "#395c6e"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,76.1h0a.9.9,0,0,0,.9-.7v-.3A.9.9,0,0,1,40.5,76.1Z",
    fill: "#395c6e"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6,75.2v.3a1,1,0,0,0,.9.7h0c0-.1,0-.1.1-.1A.9.9,0,0,1,39.6,75.2Z",
    fill: "#395c6e"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,76.2c0-.1,0-.1.1-.1a1,1,0,0,1-1-.9h0v.2a.9.9,0,0,0,.9.8Z",
    fill: "#395c6e"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,75.2h0a.9.9,0,0,1-.9.9h0a1,1,0,0,0,.9-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,75.2h-.1v.3a1.1,1.1,0,0,0,.9.7h.1A.9.9,0,0,1,41.5,75.2Z",
    fill: "#395c6e"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,75.2h-.1a.9.9,0,0,1-.9.9h.1a.9.9,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,77.1a.9.9,0,0,1-.9-.9h0c-.1,0-.1,0-.1.1h0v.2a1.1,1.1,0,0,0,1,.8,1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3h0A.9.9,0,0,1,39.5,77.1Z",
    fill: "#395c6e"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,76.1Z",
    fill: "#395c6e"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,76.2h-.1a.9.9,0,0,1-.9.9c-.5,0-.8-.4-.9-.9h0c-.1,0-.1,0-.1.1h0a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.8v-.2Z",
    fill: "#395c6e"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,74.5v-.3a.9.9,0,0,1-.9.9h0c.1,0,.1,0,.1.1h0A1,1,0,0,0,36.6,74.5Z",
    fill: "#395c6e"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,74.2h-.1v.3a1,1,0,0,0,.9.7h0c0-.1,0-.1.1-.1A1,1,0,0,1,36.6,74.2Z",
    fill: "#395c6e"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,74.2a.9.9,0,0,1-.9.9h0a.9.9,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,75.1h0c.1,0,.1,0,.1.1h0C35.7,75.1,35.7,75.1,35.6,75.1Z",
    fill: "#395c6e"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,75.2h0c-.1,0-.1,0-.1.1h0a.9.9,0,0,1-1.8,0h0c0-.1,0-.1-.1-.1v.4a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.8v-.2Z",
    fill: "#395c6e"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 73.1 45.3 73.1 45.3 73.1 45.3 73.1",
    fill: "#395c6e"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,72.1h0a.1.1,0,0,0-.1.1h0A.1.1,0,0,1,44.4,72.1Z",
    fill: "#395c6e"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,73.2h0a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,45.3,73.2Z",
    fill: "#395c6e"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,72.4a1.2,1.2,0,0,0,.9.8h.1a.9.9,0,0,1-.9-.9h-.1Z",
    fill: "#395c6e"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3,72.2h0a.9.9,0,0,1-.9.9h0a1.1,1.1,0,0,0,1-.7v-.3h0A.1.1,0,0,0,44.3,72.2Z",
    fill: "#395c6e"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,73.2h0a1,1,0,0,1-1.9,0h0v.2a1.1,1.1,0,0,0,1,.8,1.1,1.1,0,0,0,.9-.8h0Z",
    fill: "#395c6e"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,73.1h0v-.1Z",
    fill: "#395c6e"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6,73.2v.3a1,1,0,0,0,.9.7h0c0-.1,0-.1.1-.1A.9.9,0,0,1,39.6,73.2Z",
    fill: "#395c6e"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,74.1h0a.9.9,0,0,0,.9-.7v-.3A.9.9,0,0,1,40.5,74.1Z",
    fill: "#395c6e"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,73.1Z",
    fill: "#395c6e"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,73.2h0v.2a1,1,0,0,0,.9.8h0c0-.1,0-.1.1-.1A1,1,0,0,1,37.6,73.2Z",
    fill: "#395c6e"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,73.2h0a.9.9,0,0,1-.9.9h0a1,1,0,0,0,.9-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,73.2a.1.1,0,0,0-.1-.1h0v.3a1.1,1.1,0,0,0,.9.7h.1A.9.9,0,0,1,41.5,73.2Z",
    fill: "#395c6e"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,73.2h0a.9.9,0,0,1-.9.9h.1a1.1,1.1,0,0,0,.9-.8v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,75.1a.9.9,0,0,1-.9-.9h0c-.1,0-.1,0-.1.1h0v.2a1.3,1.3,0,0,0,1,.8,1.1,1.1,0,0,0,1-.8c-.1,0-.1-.1-.1-.2h0A.9.9,0,0,1,39.5,75.1Z",
    fill: "#395c6e"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,74.1Z",
    fill: "#395c6e"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,74.2h-.1a.9.9,0,0,1-.9.9c-.5,0-.8-.4-.9-.9h0c-.1,0-.1,0-.1.1h0c0,.1,0,.2.1.2a.9.9,0,0,0,.9.8,1.1,1.1,0,0,0,1-.8v-.2Z",
    fill: "#395c6e"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,72.5v-.3a.9.9,0,0,1-.9.9h.1A1,1,0,0,0,36.6,72.5Z",
    fill: "#395c6e"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,73.1h0c.5-.1.9-.4.9-.8v-.2h0A.9.9,0,0,1,37.6,73.1Z",
    fill: "#395c6e"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5,72.2v.3a1,1,0,0,0,.9.7h.1a1,1,0,0,1-1-.9h-.1Z",
    fill: "#395c6e"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,73.1h0Z",
    fill: "#395c6e"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,73.4v-.2h-.1a.9.9,0,0,1-1.8,0h-.1v.3a1.2,1.2,0,0,0,1,.8A1.1,1.1,0,0,0,37.6,73.4Z",
    fill: "#395c6e"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,71.1Z",
    fill: "#395c6e"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,71.2h0Z",
    fill: "#395c6e"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,71.2h0Z",
    fill: "#395c6e"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,71.1h0a1.1,1.1,0,0,1-.9.8,1.1,1.1,0,0,1-1-.8h0v.2a1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7h0Z",
    fill: "#395c6e"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,71.1h0v0Z",
    fill: "#395c6e"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,72.1h0c.5-.1.8-.3.9-.7v-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,72.2h.1a.9.9,0,0,1-.9-.9v.3A1,1,0,0,0,40.4,72.2Z",
    fill: "#395c6e"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,71.1Z",
    fill: "#395c6e"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6,72.1h0a1.1,1.1,0,0,0,.9-.7v-.3h0a.1.1,0,0,0-.1-.1h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,71.4a1.1,1.1,0,0,0,.9.8h.1a1,1,0,0,1-1-.9h0Z",
    fill: "#395c6e"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,71.2c0-.1,0-.1-.1-.1h0v.3a1.3,1.3,0,0,0,.9.7h.1A.9.9,0,0,1,41.5,71.2Z",
    fill: "#395c6e"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,71.2h0a.9.9,0,0,1-.9.9h.1a1.2,1.2,0,0,0,.9-.8v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,72.1Z",
    fill: "#395c6e"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,72.1h0v.2a1.2,1.2,0,0,0,1,.7,1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,72.1h-.1a.8.8,0,0,1-.9.8.9.9,0,0,1-.9-.8h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.7v-.2Z",
    fill: "#395c6e"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,71.1Z",
    fill: "#395c6e"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,71.1Z",
    fill: "#395c6e"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,71.1h0Z",
    fill: "#395c6e"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,71.1Z",
    fill: "#395c6e"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,71.1h0a.9.9,0,0,1-1.8,0h-.1v.3a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.7v-.2h-.1Z",
    fill: "#395c6e"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.3 83.2 45.3 83.2 45.3 83.2 45.3 83.2",
    fill: "#395c6e"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,83.2a.9.9,0,0,1-.9-.9v.3a.9.9,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3,82.3Z",
    fill: "#395c6e"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4,82.3h-.1a.9.9,0,0,1-.9.9h0a1.1,1.1,0,0,0,1-.7v-.3Z",
    fill: "#395c6e"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5,82.3h-.1v.2a1.2,1.2,0,0,0,.9.8h.1A.9.9,0,0,1,42.5,82.3Z",
    fill: "#395c6e"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,83.5v-.2h0c0,.2-.1.3-.2.5h.1a.4.4,0,0,0,.1-.3Z",
    fill: "#395c6e"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,83.2h0v.5h.1l-.2-.5Z",
    fill: "#395c6e"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,83.2h0v-.1Z",
    fill: "#395c6e"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,83.3c0,.2-.1.3-.2.5h.2v-.5Z",
    fill: "#395c6e"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,83.2Z",
    fill: "#395c6e"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,83.6c0,.1.1.1.1.2h.1a.9.9,0,0,1-.1-.5C39.6,83.4,39.5,83.5,39.5,83.6Z",
    fill: "#395c6e"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,83.3h0v.2a.4.4,0,0,0,.1.3h.1c-.1-.2-.2-.3-.2-.5Z",
    fill: "#395c6e"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6,83.3h-.1c0,.2-.1.3-.2.5h.1c.1-.1.1-.1.1-.2S39.6,83.4,39.6,83.3Z",
    fill: "#395c6e"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,83.3h-.1a.9.9,0,0,1-.1.5h.1v-.5Z",
    fill: "#395c6e"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,83.2h0v.5h.1a.9.9,0,0,1-.1-.5Z",
    fill: "#395c6e"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,83.2h.1a1,1,0,0,0,.9-.7c0-.1-.1-.2-.1-.3A.9.9,0,0,1,35.6,83.2Z",
    fill: "#395c6e"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5,82.3h0a.9.9,0,0,1-.9.9h0c.5-.1.9-.4.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6,82.3h-.1c0,.1.1.2.1.3a1,1,0,0,0,.9.7h.1A1,1,0,0,1,36.6,82.3Z",
    fill: "#395c6e"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,83.2Z",
    fill: "#395c6e"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,83.3h-.1c0,.2-.1.3-.2.5h.1l.2-.3Z",
    fill: "#395c6e"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,83.3h-.1v.3a.4.4,0,0,1,.1.3h.2c-.1-.2-.2-.3-.2-.5Z",
    fill: "#395c6e"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M45,81.2h0Z",
    fill: "#395c6e"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,81.2h0Z",
    fill: "#395c6e"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1,81.2h0Z",
    fill: "#395c6e"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,81.5h0v-.3h0a1.1,1.1,0,0,1-.9.8,1.1,1.1,0,0,1-1-.8h0v.2a1,1,0,0,0,1,.7A1,1,0,0,0,45.3,81.5Z",
    fill: "#395c6e"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3,81.2h0Z",
    fill: "#395c6e"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3,81.2h0v0Z",
    fill: "#395c6e"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,81.6v-.3a.9.9,0,0,1-.9.9h0A.9.9,0,0,0,41.4,81.6Z",
    fill: "#395c6e"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,81.2Z",
    fill: "#395c6e"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6,81.3c0,.1-.1.2-.1.3a1,1,0,0,0,.9.7h.1A.9.9,0,0,1,39.6,81.3Z",
    fill: "#395c6e"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,81.3h0v.2a1.1,1.1,0,0,0,.9.8h.1A1,1,0,0,1,37.6,81.3Z",
    fill: "#395c6e"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5,81.6c0-.1.1-.2.1-.3h-.1a.9.9,0,0,1-.9.9h0A1,1,0,0,0,39.5,81.6Z",
    fill: "#395c6e"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5,81.3h-.1v.3a1.1,1.1,0,0,0,.9.7h.1A.9.9,0,0,1,41.5,81.3Z",
    fill: "#395c6e"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4,81.2h-.1a.9.9,0,0,1-.9.9h.1a1.2,1.2,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4,82.2h0a.9.9,0,0,1-1.8,0h-.1v.2a1.2,1.2,0,0,0,1,.7,1.1,1.1,0,0,0,1-.7A.4.4,0,0,1,40.4,82.2Z",
    fill: "#395c6e"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,82.2Z",
    fill: "#395c6e"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4,82.2h-.1a.8.8,0,0,1-.9.8.9.9,0,0,1-.9-.8h-.1a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.7v-.2Z",
    fill: "#395c6e"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,81.2Z",
    fill: "#395c6e"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,81.3Z",
    fill: "#395c6e"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5,81.3h0Z",
    fill: "#395c6e"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7,81.2Z",
    fill: "#395c6e"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6,81.2h-.1a.9.9,0,0,1-1.8,0h-.1v.3a1.1,1.1,0,0,0,1,.7,1,1,0,0,0,1-.7v-.2Z",
    fill: "#395c6e"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 61 35.6 61 35.6 61 35.6 61 35.6 61",
    fill: "#395c6e"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,60h0c-.1,0-.1,0-.1.1h0C34.6,60,34.6,60,34.7,60Z",
    fill: "#395c6e"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3,61h.3a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,35.3,61Z",
    fill: "#395c6e"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,61h0a.9.9,0,0,1-.9-.9h0v.2a1.2,1.2,0,0,0,.7.7Z",
    fill: "#395c6e"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,60.1h0a.9.9,0,0,1-.9.9H34a1.1,1.1,0,0,0,.7-.6v-.3h0C34.6,60,34.6,60,34.6,60.1Z",
    fill: "#395c6e"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 61 35.6 61 35.6 61 35.6 61",
    fill: "#395c6e"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,61Z",
    fill: "#395c6e"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,61Z",
    fill: "#395c6e"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61h.2a.8.8,0,0,0,.7-.7v-.2A.9.9,0,0,1,26,61Z",
    fill: "#395c6e"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,61a.9.9,0,0,1-.9-.9.1.1,0,0,0-.1-.1h0v.2a1,1,0,0,0,.7.7h.3Z",
    fill: "#395c6e"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,60.3a.3.3,0,0,1-.1-.2h0a.9.9,0,0,1-.9.9h.3A1.2,1.2,0,0,0,28.9,60.3Z",
    fill: "#395c6e"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61Z",
    fill: "#395c6e"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,61h0Z",
    fill: "#395c6e"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61Z",
    fill: "#395c6e"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,58Z",
    fill: "#395c6e"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 58.9 35.6 58.9 35.6 58.9 35.6 58.9 35.6 58.9",
    fill: "#395c6e"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,59h0a.9.9,0,0,1-.9-.8v.2A1,1,0,0,0,35.6,59Z",
    fill: "#395c6e"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,58.3a1,1,0,0,0,.9.7h.1a.9.9,0,0,1-.9-.9h0C32.8,58.1,32.7,58.2,32.7,58.3Z",
    fill: "#395c6e"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,58h0a.9.9,0,0,1-.9.8h.1a1,1,0,0,0,.9-.7v-.2h-.1Z",
    fill: "#395c6e"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 58.9 35.6 58.9 35.6 58.9 35.6 58.9",
    fill: "#395c6e"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,59h0v.3a1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7V59h0a.9.9,0,0,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,59h0v.3h0v-.4h0Z",
    fill: "#395c6e"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,59h0Z",
    fill: "#395c6e"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,59.1c0,.1,0,.2-.1.2a1.1,1.1,0,0,0,.9.7h.1A.9.9,0,0,1,29.9,59.1Z",
    fill: "#395c6e"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,59.3a.4.4,0,0,1-.1-.3,1,1,0,0,1-.9,1h0A1.1,1.1,0,0,0,31.8,59.3Z",
    fill: "#395c6e"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,60h.1a1,1,0,0,1-.9-1h-.1v.3a.9.9,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,59.3c.1,0,.1-.1.1-.2h-.1a.9.9,0,0,1-.9.9h0A.9.9,0,0,0,29.8,59.3Z",
    fill: "#395c6e"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,59h-.1a.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0A1,1,0,0,1,31.8,59Z",
    fill: "#395c6e"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,60h.1a1,1,0,0,0,.9-.7V59h-.1A1,1,0,0,1,32.7,60Z",
    fill: "#395c6e"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,60h0a.9.9,0,1,1-1.8,0h-.1a.3.3,0,0,0,.1.2,1,1,0,0,0,.9.7,1,1,0,0,0,1-.7A.4.4,0,0,0,30.7,60Z",
    fill: "#395c6e"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,60Z",
    fill: "#395c6e"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8,60h-.1a1,1,0,0,1-1.9,0h-.1a.4.4,0,0,1,.1.3,1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7v-.2Z",
    fill: "#395c6e"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,58.3V58a.9.9,0,0,1-.9.9h0A1,1,0,0,0,26.9,58.3Z",
    fill: "#395c6e"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,58.3a.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-.9.9H28A1,1,0,0,0,28.9,58.3Z",
    fill: "#395c6e"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M27,58h-.1v.3a1,1,0,0,0,.9.7h.1A.9.9,0,0,1,27,58Z",
    fill: "#395c6e"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M26,58.9Z",
    fill: "#395c6e"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,59.3V59h-.1A.9.9,0,1,1,26,59h0v.4a1,1,0,0,0,.9.7A1,1,0,0,0,27.9,59.3Z",
    fill: "#395c6e"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 56.9 35.6 56.9 35.6 56.9 35.6 56.9 35.6 56.9",
    fill: "#395c6e"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,57h0a.9.9,0,0,1-.9-.9v.3A1,1,0,0,0,35.6,57Z",
    fill: "#395c6e"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,56Z",
    fill: "#395c6e"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,57h.1a.9.9,0,0,1-.9-.9h0a.3.3,0,0,1-.1.2A.9.9,0,0,0,33.6,57Z",
    fill: "#395c6e"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,56h0a.9.9,0,0,1-.9.9.1.1,0,0,1,.1.1h0a1,1,0,0,0,.9-.7V56h-.1Z",
    fill: "#395c6e"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,57.9a.9.9,0,0,1-.9-.9h0a.1.1,0,0,0-.1-.1h0v.2a1,1,0,0,0,1,.8,1,1,0,0,0,.9-.7V57h0A.9.9,0,0,1,34.7,57.9Z",
    fill: "#395c6e"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 56.9 35.6 56.9 35.6 56.9 35.6 56.9",
    fill: "#395c6e"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,56.9h0v.3h0v-.4Z",
    fill: "#395c6e"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,57.9h0a1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,58h.1a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3A1.1,1.1,0,0,0,30.7,58Z",
    fill: "#395c6e"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,57Z",
    fill: "#395c6e"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,58h0a.1.1,0,0,1,.1-.1A.9.9,0,0,1,28,57h-.1v.2A.9.9,0,0,0,28.8,58Z",
    fill: "#395c6e"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,57h0a.9.9,0,0,1-.9.9h0a.9.9,0,0,0,.9-.7.4.4,0,0,0,.1-.3h-.1Z",
    fill: "#395c6e"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,57h0a.9.9,0,0,1-.9.9h.1a.9.9,0,0,0,.9-.8V57h-.1Z",
    fill: "#395c6e"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,57a.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0a.9.9,0,0,1-.9-.9h-.1Z",
    fill: "#395c6e"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,57.9Z",
    fill: "#395c6e"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,58h0a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7,1,1,0,0,0,1-.7.4.4,0,0,0-.1-.3h0a.9.9,0,1,1-1.8,0h0A.1.1,0,0,0,28.8,58Z",
    fill: "#395c6e"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,58h0a1,1,0,0,1-1.9,0h-.1a.4.4,0,0,1,.1.3,1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7c0-.1.1-.2.1-.3h-.1Z",
    fill: "#395c6e"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M26,56.9h0a1,1,0,0,0,.9-.7V56a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,57H28a.9.9,0,0,0,.9-.8c-.1,0-.1-.1-.1-.2h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,56v.3a1,1,0,0,0,.9.7h0a.1.1,0,0,1,.1-.1A.9.9,0,0,1,27,56Z",
    fill: "#395c6e"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M26,57Z",
    fill: "#395c6e"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,57.9A.9.9,0,0,1,26,57h0v.4a1,1,0,0,0,.9.7,1,1,0,0,0,1-.8V57h0a.1.1,0,0,0-.1.1h0A.9.9,0,0,1,26.9,57.9Z",
    fill: "#395c6e"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,53.9h0a.1.1,0,0,0-.1.1h0A.1.1,0,0,1,34.7,53.9Z",
    fill: "#395c6e"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,55h0a.9.9,0,0,1-.9-.9v.3A1,1,0,0,0,35.6,55Z",
    fill: "#395c6e"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 54.9 35.6 54.9 35.6 54.9 35.6 54.9 35.6 54.9",
    fill: "#395c6e"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,55h.1a.9.9,0,0,1-.9-.9h0c0,.1-.1.1-.1.2A1.1,1.1,0,0,0,33.6,55Z",
    fill: "#395c6e"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,54h0a.9.9,0,0,1-.9.9.1.1,0,0,1,.1.1h0a1,1,0,0,0,.9-.7V54h0A.1.1,0,0,0,34.6,54Z",
    fill: "#395c6e"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 54.9 35.6 54.9 35.6 54.9 35.6 54.9",
    fill: "#395c6e"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,55v.2a1.1,1.1,0,0,0,1,.8,1,1,0,0,0,.9-.7V55h0a.9.9,0,0,1-1.8,0h0a.1.1,0,0,0-.1-.1Z",
    fill: "#395c6e"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,55h0v.3h0v-.4h0Z",
    fill: "#395c6e"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,55.9h0a1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,55Z",
    fill: "#395c6e"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,56h0a.1.1,0,0,1,.1-.1.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3A1.1,1.1,0,0,0,30.7,56Z",
    fill: "#395c6e"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,56h0a.9.9,0,0,0,.9-.7.4.4,0,0,0,.1-.3h-.1a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,56h0c0-.1,0-.1.1-.1A.9.9,0,0,1,28,55h-.1v.2A1,1,0,0,0,28.8,56Z",
    fill: "#395c6e"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,56h0a.9.9,0,0,1-.9-.9h-.1a.4.4,0,0,0,.1.3A.9.9,0,0,0,32.7,56Z",
    fill: "#395c6e"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,55.9a.1.1,0,0,1,.1.1h0a1.1,1.1,0,0,0,.9-.8V55h-.1A.9.9,0,0,1,32.7,55.9Z",
    fill: "#395c6e"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,55.9Z",
    fill: "#395c6e"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,56h0c0,.1,0,.2.1.2a.9.9,0,0,0,.9.8,1,1,0,0,0,1-.7.4.4,0,0,0-.1-.3h0a.9.9,0,1,1-1.8,0h0C28.8,55.9,28.8,55.9,28.8,56Z",
    fill: "#395c6e"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,56h0a.4.4,0,0,1,.1.3,1,1,0,0,0,1,.7.9.9,0,0,0,.9-.8.3.3,0,0,0,.1-.2h0a.1.1,0,0,0-.1-.1h0a1,1,0,0,1-1.9,0h0A.1.1,0,0,0,30.7,56Z",
    fill: "#395c6e"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M26,54.9h0a1,1,0,0,0,.9-.7V54a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,55H28a1.1,1.1,0,0,0,.9-.8c-.1-.1-.1-.1-.1-.2h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,54v.3a1,1,0,0,0,.9.7h0a.1.1,0,0,1,.1-.1A.9.9,0,0,1,27,54h-.1Z",
    fill: "#395c6e"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M26,55Z",
    fill: "#395c6e"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,55.9A.9.9,0,0,1,26,55h0v.4a1,1,0,0,0,.9.7,1.1,1.1,0,0,0,1-.8V55h0a.1.1,0,0,0-.1.1h0A.9.9,0,0,1,26.9,55.9Z",
    fill: "#395c6e"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.4 52.9 35.4 52.9 35.4 52.9 35.4 52.9",
    fill: "#395c6e"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M34,52.9h0Z",
    fill: "#395c6e"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,52.9Z",
    fill: "#395c6e"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,53v.2a1,1,0,0,0,1,.7,1.1,1.1,0,0,0,.9-.5h-.1a.8.8,0,0,1-.8.5.8.8,0,0,1-.9-.8h-.1Z",
    fill: "#395c6e"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    points: "33.7 52.9 33.7 52.9 33.7 52.9 33.7 52.9",
    fill: "#395c6e"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,54h.1a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3A1.1,1.1,0,0,0,30.7,54Z",
    fill: "#395c6e"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,53.9h0a1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,53Z",
    fill: "#395c6e"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,54h.1A.9.9,0,0,1,28,53h-.1v.2A1,1,0,0,0,28.8,54Z",
    fill: "#395c6e"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,53h0a.9.9,0,0,1-.9.9h0a.9.9,0,0,0,.9-.7.4.4,0,0,0,.1-.3h0a.1.1,0,0,0-.1-.1h0Z",
    fill: "#395c6e"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,53h0a.9.9,0,0,1-.9.9h.1a1.1,1.1,0,0,0,.9-.8V53h-.1Z",
    fill: "#395c6e"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,53a.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0a.9.9,0,0,1-.9-.9h-.1Z",
    fill: "#395c6e"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,53.9Z",
    fill: "#395c6e"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,53.9h0c0,.1,0,.1.1.2a1.1,1.1,0,0,0,.9.8,1,1,0,0,0,1-.8.3.3,0,0,0-.1-.2h0a.9.9,0,1,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7,53.9h0a.3.3,0,0,1,.1.2,1,1,0,0,0,1,.8,1.1,1.1,0,0,0,.9-.8c0-.1.1-.1.1-.2h-.1a1,1,0,0,1-1.9,0h-.1Z",
    fill: "#395c6e"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M26,53c.1,0,.2,0,.2-.1H26Z",
    fill: "#395c6e"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,52.9h0Z",
    fill: "#395c6e"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,53h0Z",
    fill: "#395c6e"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 52.9 26 52.9 26 52.9 26 52.9",
    fill: "#395c6e"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M26,53.2a1,1,0,0,0,.9.7,1,1,0,0,0,1-.7V53h-.1A.9.9,0,0,1,26,53h0Z",
    fill: "#395c6e"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3,71.1h.3a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,35.3,71.1Z",
    fill: "#395c6e"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,70.2h0c0-.1,0-.1.1-.1h0C34.6,70.1,34.6,70.1,34.6,70.2Z",
    fill: "#395c6e"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 71.1 35.6 71.1 35.6 71.1 35.6 71.1 35.6 71.1",
    fill: "#395c6e"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,71.1a.9.9,0,0,1-.9-.9h0a.3.3,0,0,0-.1.2,1.2,1.2,0,0,0,.7.7Z",
    fill: "#395c6e"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,71.1H34a1.1,1.1,0,0,0,.7-.6v-.3h0c-.1,0-.1,0-.1.1h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 71.1 35.6 71.1 35.6 71.1 35.6 71.1",
    fill: "#395c6e"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,71.1Z",
    fill: "#395c6e"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,71.1Z",
    fill: "#395c6e"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,70.4v-.2h0a.9.9,0,0,1-.9.9h.3A1.2,1.2,0,0,0,28.9,70.4Z",
    fill: "#395c6e"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,71.1h0Z",
    fill: "#395c6e"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,71.1h0Z",
    fill: "#395c6e"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,68.1h0Z",
    fill: "#395c6e"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 69.1 35.6 69.1 35.6 69.1 35.6 69.1 35.6 69.1",
    fill: "#395c6e"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,69.1a1,1,0,0,1-.9-.9v.2a1,1,0,0,0,.9.7Z",
    fill: "#395c6e"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,69.1h0a1,1,0,0,0,.9-.7v-.2h-.1a1,1,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,69.1h0a1,1,0,0,1-.9-1h0c0,.1-.1.2-.1.3a1,1,0,0,0,.9.7Z",
    fill: "#395c6e"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,70.1a1,1,0,0,0,.9-.7v-.3h0a.9.9,0,1,1-1.8,0h-.1v.3A1,1,0,0,0,34.7,70.1Z",
    fill: "#395c6e"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 69.1 35.6 69.1 35.6 69.1 35.6 69.1",
    fill: "#395c6e"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,69.1h0v.3h0v-.3Z",
    fill: "#395c6e"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,70.1h0a1.4,1.4,0,0,0,1-.8.4.4,0,0,1-.1-.3.9.9,0,0,1-.9,1Z",
    fill: "#395c6e"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,70.1a.9.9,0,0,1-.9-.9c0,.1,0,.2-.1.2a1.4,1.4,0,0,0,.9.8h.1Z",
    fill: "#395c6e"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,69.1h0Z",
    fill: "#395c6e"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,70.1h0a1.1,1.1,0,0,0,.9-.8c.1,0,.1-.1.1-.2h-.1a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,70.1h.1a.9.9,0,0,1-.9-1h-.1v.3a.9.9,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8,70.1h0a1,1,0,0,0,.9-.7v-.3h-.1a.9.9,0,0,1-.9,1Z",
    fill: "#395c6e"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,70.2h0a.9.9,0,0,1-.9-1h-.1a.4.4,0,0,0,.1.3A1.1,1.1,0,0,0,32.7,70.2Z",
    fill: "#395c6e"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,71.1h0a1,1,0,0,0,1-.7.4.4,0,0,0-.1-.3h0a.9.9,0,0,1-1.8,0h-.1v.2A1,1,0,0,0,29.8,71.1Z",
    fill: "#395c6e"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,70.1Z",
    fill: "#395c6e"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8,70.1h-.1a1.1,1.1,0,0,1-.9.8,1.1,1.1,0,0,1-1-.8h-.1a.4.4,0,0,1,.1.3,1,1,0,0,0,1,.7h0a1,1,0,0,0,.9-.7.3.3,0,0,1,.1-.2Z",
    fill: "#395c6e"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,68.4v-.3a1,1,0,0,1-.4.8h0A.9.9,0,0,0,26.9,68.4Z",
    fill: "#395c6e"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,68.4a.4.4,0,0,1-.1-.3h0a1,1,0,0,1-.9,1H28A1,1,0,0,0,28.9,68.4Z",
    fill: "#395c6e"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M27,68.1h-.1v.3a1,1,0,0,0,.9.7h.1A1,1,0,0,1,27,68.1Z",
    fill: "#395c6e"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,69.4v-.3h-.1a.9.9,0,0,1-.8.9h0A1.1,1.1,0,0,0,27.9,69.4Z",
    fill: "#395c6e"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,66.1Z",
    fill: "#395c6e"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,67.1h0a.9.9,0,0,1-.9-.9v.3A1,1,0,0,0,35.6,67.1Z",
    fill: "#395c6e"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 67 35.6 67 35.6 67 35.6 67 35.6 67",
    fill: "#395c6e"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,67a.9.9,0,0,1-.9-.9h0a.3.3,0,0,1-.1.2.9.9,0,0,0,.9.8h.1Z",
    fill: "#395c6e"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,66.1h0a.9.9,0,0,1-.9.9h.1a1,1,0,0,0,.9-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,67.4v-.3h0a.9.9,0,1,1-1.8,0h-.1v.2a1,1,0,0,0,1,.8A1,1,0,0,0,35.6,67.4Z",
    fill: "#395c6e"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 67 35.6 67 35.6 67 35.6 67",
    fill: "#395c6e"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,67.1h0v.3h0V67h0Z",
    fill: "#395c6e"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,68a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3,1.1,1.1,0,0,0,.9.7h.1Z",
    fill: "#395c6e"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,67.4a.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9h0A1.1,1.1,0,0,0,31.8,67.4Z",
    fill: "#395c6e"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,67.1Z",
    fill: "#395c6e"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,68.1h.1a.9.9,0,0,1-.9-.9h-.1v.2a.9.9,0,0,0,.9.8Z",
    fill: "#395c6e"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,67.4a.4.4,0,0,0,.1-.3h-.1a.9.9,0,0,1-.9.9h0A.9.9,0,0,0,29.8,67.4Z",
    fill: "#395c6e"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,67.3v-.2h-.1a.9.9,0,0,1-.9.9h.1A.9.9,0,0,0,33.7,67.3Z",
    fill: "#395c6e"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,67.1h-.1a.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0A.9.9,0,0,1,31.8,67.1Z",
    fill: "#395c6e"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,69.1a1,1,0,0,0,1-.7.4.4,0,0,0-.1-.3h0a.9.9,0,0,1-1.8,0h-.1a.4.4,0,0,0,.1.3A1,1,0,0,0,29.8,69.1Z",
    fill: "#395c6e"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,68Z",
    fill: "#395c6e"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8,68.1h-.1a1,1,0,0,1-1.9,0h-.1a.4.4,0,0,1,.1.3,1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7c0-.1.1-.2.1-.3Z",
    fill: "#395c6e"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M26,67h0a1,1,0,0,0,.9-.7v-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,66.3c-.1,0-.1-.1-.1-.2h0a.9.9,0,0,1-.9.9H28A.9.9,0,0,0,28.9,66.3Z",
    fill: "#395c6e"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,67.1h.1a.9.9,0,0,1-.9-.9h-.1v.3A1,1,0,0,0,27.8,67.1Z",
    fill: "#395c6e"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M26,67Z",
    fill: "#395c6e"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,67.3v-.2h-.1a.9.9,0,1,1-1.8,0h0v.4a1,1,0,0,0,.9.7A1,1,0,0,0,27.9,67.3Z",
    fill: "#395c6e"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,65.1h0a.9.9,0,0,1-.9-.9v.3A1,1,0,0,0,35.6,65.1Z",
    fill: "#395c6e"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 65 35.6 65 35.6 65 35.6 65 35.6 65",
    fill: "#395c6e"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,64Z",
    fill: "#395c6e"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,65.1h.1a.9.9,0,0,1-.9-.9h0c0,.1-.1.1-.1.2A1.1,1.1,0,0,0,33.6,65.1Z",
    fill: "#395c6e"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,64.1h0a.9.9,0,0,1-.9.9h.1a1,1,0,0,0,.9-.7v-.3h-.1Z",
    fill: "#395c6e"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 65 35.6 65 35.6 65 35.6 65",
    fill: "#395c6e"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,65.1h0v.2a1,1,0,0,0,1,.8,1,1,0,0,0,.9-.7v-.3h0a.9.9,0,1,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,65.1h0v.3h0V65h0Z",
    fill: "#395c6e"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,66a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3,1.1,1.1,0,0,0,.9.7h.1Z",
    fill: "#395c6e"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,65.1Z",
    fill: "#395c6e"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,65.4a.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9h0A1.1,1.1,0,0,0,31.8,65.4Z",
    fill: "#395c6e"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,66.1h0a.9.9,0,0,0,.9-.7.4.4,0,0,0,.1-.3h-.1a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,66.1h.1a.9.9,0,0,1-.9-.9h-.1v.2a.9.9,0,0,0,.9.8Z",
    fill: "#395c6e"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,65.3v-.2h-.1a.9.9,0,0,1-.9.9h.1A.9.9,0,0,0,33.7,65.3Z",
    fill: "#395c6e"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,65.1h-.1a.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0A.9.9,0,0,1,31.8,65.1Z",
    fill: "#395c6e"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,67.1a1,1,0,0,0,1-.7.4.4,0,0,0-.1-.3h0a.9.9,0,0,1-1.8,0h-.1c0,.1,0,.2.1.2A.9.9,0,0,0,29.8,67.1Z",
    fill: "#395c6e"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,66Z",
    fill: "#395c6e"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,67.1a.9.9,0,0,0,.9-.8.3.3,0,0,0,.1-.2h-.1a1,1,0,0,1-1.9,0h-.1a.4.4,0,0,1,.1.3A1,1,0,0,0,31.8,67.1Z",
    fill: "#395c6e"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,64.4v-.3a.9.9,0,0,1-.9.9h0A1,1,0,0,0,26.9,64.4Z",
    fill: "#395c6e"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M27,64.1h-.1v.3a1,1,0,0,0,.9.7h.1A.9.9,0,0,1,27,64.1Z",
    fill: "#395c6e"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,64.3c-.1-.1-.1-.1-.1-.2h0a.9.9,0,0,1-.9.9H28A1.1,1.1,0,0,0,28.9,64.3Z",
    fill: "#395c6e"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M26,65Z",
    fill: "#395c6e"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,65.3v-.2h-.1a.9.9,0,1,1-1.8,0h0v.4a1,1,0,0,0,.9.7A1,1,0,0,0,27.9,65.3Z",
    fill: "#395c6e"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,62h0c-.1,0-.1,0-.1.1h0C34.6,62,34.6,62,34.7,62Z",
    fill: "#395c6e"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,63.1h0a.9.9,0,0,1-.9-.9v.3A1,1,0,0,0,35.6,63.1Z",
    fill: "#395c6e"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 63 35.6 63 35.6 63 35.6 63 35.6 63",
    fill: "#395c6e"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,62.3a1.2,1.2,0,0,0,.9.8.1.1,0,0,0,.1-.1h0a.9.9,0,0,1-.9-.9h0Z",
    fill: "#395c6e"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,63h0a1,1,0,0,0,.9-.7v-.3h0c-.1,0-.1,0-.1.1h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 63 35.6 63 35.6 63 35.6 63",
    fill: "#395c6e"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,63h0v.2a1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7v-.2h0a.9.9,0,0,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,63h0v.2h0V63Z",
    fill: "#395c6e"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,64a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3,1.1,1.1,0,0,0,.9.7h.1Z",
    fill: "#395c6e"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,64h0a1.1,1.1,0,0,0,1-.7.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,63Z",
    fill: "#395c6e"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,64h0a.9.9,0,0,0,.9-.7.4.4,0,0,0,.1-.3h0a.1.1,0,0,0-.1-.1h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,64.1h.1a.9.9,0,0,1-.9-.9h-.1v.2A1,1,0,0,0,28.8,64.1Z",
    fill: "#395c6e"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,64h.1a1.1,1.1,0,0,0,.9-.8v-.2h0a.1.1,0,0,1-.1.1h0A.9.9,0,0,1,32.7,64Z",
    fill: "#395c6e"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,64.1h0a.9.9,0,0,1-.9-.9h0a.1.1,0,0,0-.1.1.4.4,0,0,0,.1.3A.9.9,0,0,0,32.7,64.1Z",
    fill: "#395c6e"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,65.1a1,1,0,0,0,1-.8v-.2h0a.9.9,0,0,1-1.8,0h-.1c0,.1,0,.1.1.2A1.1,1.1,0,0,0,29.8,65.1Z",
    fill: "#395c6e"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,64Z",
    fill: "#395c6e"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,65.1a1.1,1.1,0,0,0,.9-.8c0-.1.1-.1.1-.2h-.1a1,1,0,0,1-1.9,0h-.1v.2A1,1,0,0,0,31.8,65.1Z",
    fill: "#395c6e"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M26,63h0a1,1,0,0,0,.9-.7v-.3a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,63.1h.1a.9.9,0,0,1-.9-.9.1.1,0,0,0-.1-.1h0v.3A1,1,0,0,0,27.8,63.1Z",
    fill: "#395c6e"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,63H28a1.2,1.2,0,0,0,.9-.8.3.3,0,0,1-.1-.2h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M26,63h0Z",
    fill: "#395c6e"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,63h0a.9.9,0,1,1-1.8,0h0v.3a1,1,0,0,0,.9.7,1,1,0,0,0,1-.7v-.2h-.1Z",
    fill: "#395c6e"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,61Z",
    fill: "#395c6e"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,61h-.1A.1.1,0,0,1,33.7,61Z",
    fill: "#395c6e"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M34,61h0Z",
    fill: "#395c6e"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,61h0a.9.9,0,0,1-1.8,0h-.1v.2a1,1,0,0,0,1,.7,1,1,0,0,0,.9-.7Z",
    fill: "#395c6e"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,61Z",
    fill: "#395c6e"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,61h0v.3h0V61Z",
    fill: "#395c6e"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,61h0Z",
    fill: "#395c6e"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,62a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3,1.3,1.3,0,0,0,.9.7h.1Z",
    fill: "#395c6e"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,62h0a1.3,1.3,0,0,0,1-.7.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,62h0c.5-.1.8-.3.9-.7a.4.4,0,0,0,.1-.3h0c0-.1,0-.1-.1-.1h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,62h.1a.9.9,0,0,1-.9-.9h-.1v.2a1.1,1.1,0,0,0,.9.8h0Z",
    fill: "#395c6e"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,62.1h0a.9.9,0,0,1-.9-.9h0c-.1,0-.1,0-.1.1a.4.4,0,0,0,.1.3C31.9,61.8,32.2,62,32.7,62.1Z",
    fill: "#395c6e"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,61h0a.1.1,0,0,0-.1.1h0a.9.9,0,0,1-.9.9h.1a1.2,1.2,0,0,0,.9-.8v-.2Z",
    fill: "#395c6e"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,63a1,1,0,0,0,1-.7.4.4,0,0,0-.1-.3h0a.9.9,0,0,1-1.8,0h-.1a.3.3,0,0,0,.1.2A1,1,0,0,0,29.8,63Z",
    fill: "#395c6e"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,62Z",
    fill: "#395c6e"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,63a1,1,0,0,0,.9-.7v-.2h-.1a.9.9,0,0,1-.9.8,1,1,0,0,1-1-.8h-.1a.4.4,0,0,1,.1.3A1,1,0,0,0,31.8,63Z",
    fill: "#395c6e"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61Z",
    fill: "#395c6e"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,61.1h0Z",
    fill: "#395c6e"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,61h0Z",
    fill: "#395c6e"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61Z",
    fill: "#395c6e"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,61h-.1a.9.9,0,0,1-1.8,0h0v.3a1,1,0,0,0,.9.7,1,1,0,0,0,1-.7v-.2Z",
    fill: "#395c6e"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,80.3Z",
    fill: "#395c6e"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,81.2a.9.9,0,0,1-.9-.9v.3a.9.9,0,0,0,.6.6Z",
    fill: "#395c6e"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 81.2 35.6 81.2 35.6 81.2 35.6 81.2 35.6 81.2",
    fill: "#395c6e"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,81.2h0a.9.9,0,0,1-.9-.9h0v.2a1.2,1.2,0,0,0,.7.7Z",
    fill: "#395c6e"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,80.6v-.3h-.1a.9.9,0,0,1-.9.9H34A1.1,1.1,0,0,0,34.7,80.6Z",
    fill: "#395c6e"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 81.2 35.6 81.2 35.6 81.2 35.6 81.2",
    fill: "#395c6e"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,81.2h0Z",
    fill: "#395c6e"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,81.2Z",
    fill: "#395c6e"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,79.2a.9.9,0,0,1-.9-.9v.2a1,1,0,0,0,.9.7Z",
    fill: "#395c6e"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,78.2h0Z",
    fill: "#395c6e"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 79.2 35.6 79.2 35.6 79.2 35.6 79.2 35.6 79.2",
    fill: "#395c6e"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,79.2h0a1,1,0,0,0,.9-.7v-.2h-.1a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,79.2h.1a1,1,0,0,1-.9-1h0v.3A1,1,0,0,0,33.6,79.2Z",
    fill: "#395c6e"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,80.2a1,1,0,0,0,.9-.7v-.3h0a.9.9,0,1,1-1.8,0h-.1v.3A1,1,0,0,0,34.7,80.2Z",
    fill: "#395c6e"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 79.2 35.6 79.2 35.6 79.2 35.6 79.2",
    fill: "#395c6e"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,79.2h0v.3h0Z",
    fill: "#395c6e"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7,79.2c0,.2,0,.3-.1.4h.1a.3.3,0,0,1,.1-.2C31.7,79.4,31.7,79.4,31.7,79.2Z",
    fill: "#395c6e"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,79.5v-.3h-.1a.9.9,0,0,1-.9,1h.1A1.2,1.2,0,0,0,33.7,79.5Z",
    fill: "#395c6e"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,79.2h-.1c0,.2,0,.2.1.3a1.1,1.1,0,0,0,.9.8h0A.9.9,0,0,1,31.8,79.2Z",
    fill: "#395c6e"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,80.5v-.2h-.1a1.3,1.3,0,0,1-.4.7h0C32.5,80.9,32.7,80.7,32.7,80.5Z",
    fill: "#395c6e"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,76.2Z",
    fill: "#395c6e"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,77.1a.9.9,0,0,1-.9-.9v.3a1,1,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 77.1 35.6 77.1 35.6 77.1 35.6 77.1 35.6 77.1",
    fill: "#395c6e"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,76.5v-.3h-.1a.9.9,0,0,1-.9.9h.1A1,1,0,0,0,34.7,76.5Z",
    fill: "#395c6e"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,77.1a.9.9,0,0,1-.9-.9h0v.2a.9.9,0,0,0,.9.8h.1Z",
    fill: "#395c6e"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,78.2a1,1,0,0,0,.9-.7v-.3h0a.9.9,0,0,1-1.8,0h-.1v.2A1,1,0,0,0,34.7,78.2Z",
    fill: "#395c6e"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 77.1 35.6 77.1 35.6 77.1 35.6 77.1",
    fill: "#395c6e"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,77.1h0v.3h0Z",
    fill: "#395c6e"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,77.5a.4.4,0,0,1-.1-.3.8.8,0,0,1-.8.9H31C31.3,78.2,31.6,77.9,31.8,77.5Z",
    fill: "#395c6e"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,77.2h-.1a.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0A.9.9,0,0,1,31.8,77.2Z",
    fill: "#395c6e"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,77.4v-.2h-.1a.9.9,0,0,1-.9.9h.1A.9.9,0,0,0,33.7,77.4Z",
    fill: "#395c6e"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,78.5v-.3h-.1a1.1,1.1,0,0,1-.9.9h0A1,1,0,0,0,32.7,78.5Z",
    fill: "#395c6e"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 75.1 35.6 75.1 35.6 75.1 35.6 75.1 35.6 75.1",
    fill: "#395c6e"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,74.2Z",
    fill: "#395c6e"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,75.1a.9.9,0,0,1-.9-.9v.3a1,1,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,75.2h0a1,1,0,0,0,.9-.7v-.3h-.1a.9.9,0,0,1-.9.9A.1.1,0,0,1,33.8,75.2Z",
    fill: "#395c6e"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6,75.2h.1a.9.9,0,0,1-.9-.9h0c0,.1-.1.1-.1.2A1.1,1.1,0,0,0,33.6,75.2Z",
    fill: "#395c6e"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,76.2a1,1,0,0,0,.9-.7v-.3h0a.9.9,0,1,1-1.8,0h0a.1.1,0,0,0-.1-.1h0v.2A1,1,0,0,0,34.7,76.2Z",
    fill: "#395c6e"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 75.1 35.6 75.1 35.6 75.1 35.6 75.1",
    fill: "#395c6e"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,75.1h0v.3h0Z",
    fill: "#395c6e"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,76.1a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3,1.1,1.1,0,0,0,.9.7h0A.1.1,0,0,1,30.8,76.1Z",
    fill: "#395c6e"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,75.5a.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9h0A1.1,1.1,0,0,0,31.8,75.5Z",
    fill: "#395c6e"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,75.2Z",
    fill: "#395c6e"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9,75.2h-.1c0,.2,0,.3-.1.4h0v-.2A.4.4,0,0,0,29.9,75.2Z",
    fill: "#395c6e"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,75.4v-.2h-.1a.9.9,0,0,1-.9.9.1.1,0,0,1,.1.1h0A.9.9,0,0,0,33.7,75.4Z",
    fill: "#395c6e"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,75.2h-.1a.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0A.9.9,0,0,1,31.8,75.2Z",
    fill: "#395c6e"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,76.5a.4.4,0,0,0-.1-.3h0a.7.7,0,0,1-.4.7h.1A1,1,0,0,0,30.8,76.5Z",
    fill: "#395c6e"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,76.1Z",
    fill: "#395c6e"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,76.4v-.2h0a.1.1,0,0,0-.1-.1h0a1,1,0,0,1-1.9,0h0a.1.1,0,0,0-.1.1h0a.4.4,0,0,1,.1.3,1,1,0,0,0,1,.7A.9.9,0,0,0,32.7,76.4Z",
    fill: "#395c6e"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,72.2h0a.1.1,0,0,1,.1-.1h0A.1.1,0,0,0,34.6,72.2Z",
    fill: "#395c6e"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,73.1a.9.9,0,0,1-.9-.9v.3a1,1,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 73.1 35.6 73.1 35.6 73.1 35.6 73.1 35.6 73.1",
    fill: "#395c6e"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,73.1a.9.9,0,0,1-.9-.9h0a.3.3,0,0,0-.1.2,1.2,1.2,0,0,0,.9.8.1.1,0,0,0,.1-.1Z",
    fill: "#395c6e"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,72.5v-.3h0a.1.1,0,0,0-.1.1h0a.9.9,0,0,1-.9.9h.1A1,1,0,0,0,34.7,72.5Z",
    fill: "#395c6e"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,74.2a1.1,1.1,0,0,0,.9-.8v-.2h0a.9.9,0,0,1-1.8,0h-.1v.2A1.1,1.1,0,0,0,34.7,74.2Z",
    fill: "#395c6e"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 73.1 35.6 73.1 35.6 73.1 35.6 73.1",
    fill: "#395c6e"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,73.1h0v.2h0Z",
    fill: "#395c6e"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,74.1a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3,1.1,1.1,0,0,0,.9.7h0A.1.1,0,0,1,30.8,74.1Z",
    fill: "#395c6e"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,73.2Z",
    fill: "#395c6e"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,73.5a.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9h0A1.1,1.1,0,0,0,31.8,73.5Z",
    fill: "#395c6e"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,73.5a.4.4,0,0,0,.1-.3h0a.1.1,0,0,0-.1-.1h0a1,1,0,0,1-.8.9h0A1,1,0,0,0,29.8,73.5Z",
    fill: "#395c6e"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,73.4v-.2h0a.1.1,0,0,1-.1.1h0a.9.9,0,0,1-.9.9.1.1,0,0,1,.1.1h0A1.1,1.1,0,0,0,33.7,73.4Z",
    fill: "#395c6e"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,73.2h0a.1.1,0,0,0-.1.1.4.4,0,0,0,.1.3.9.9,0,0,0,.9.7h0A.9.9,0,0,1,31.8,73.2Z",
    fill: "#395c6e"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,74.4a.3.3,0,0,0-.1-.2h0a.9.9,0,0,1-.9.9l-.4-.2v.2h.4A1,1,0,0,0,30.8,74.4Z",
    fill: "#395c6e"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,74.1Z",
    fill: "#395c6e"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,75.2a1.1,1.1,0,0,0,.9-.8c0-.1.1-.1.1-.2h0a.1.1,0,0,0-.1-.1h0a1,1,0,0,1-1.9,0h0a.1.1,0,0,0-.1.1h0a.3.3,0,0,1,.1.2A1,1,0,0,0,31.8,75.2Z",
    fill: "#395c6e"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9,72.4v-.2h0a.8.8,0,0,1-.4.7h0C28.7,72.9,28.8,72.7,28.9,72.4Z",
    fill: "#395c6e"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,71.1h0Z",
    fill: "#395c6e"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,71.1Z",
    fill: "#395c6e"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,71.1h-.1A.1.1,0,0,1,33.7,71.1Z",
    fill: "#395c6e"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,72.1a1,1,0,0,0,.9-.7v-.3h0a.9.9,0,0,1-1.8,0h-.1v.2A1,1,0,0,0,34.7,72.1Z",
    fill: "#395c6e"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,71.1h0v.3h0Z",
    fill: "#395c6e"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,71.2Z",
    fill: "#395c6e"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,72.1a.9.9,0,0,1-.9-.9.4.4,0,0,1-.1.3,1.1,1.1,0,0,0,.9.7h.1Z",
    fill: "#395c6e"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,71.5a.4.4,0,0,1-.1-.3.9.9,0,0,1-.9.9h0A1.3,1.3,0,0,0,31.8,71.5Z",
    fill: "#395c6e"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8,71.5a.4.4,0,0,0,.1-.3h0c0-.1,0-.1-.1-.1h0a.9.9,0,0,1-.9.9h0C29.4,72.1,29.7,71.9,29.8,71.5Z",
    fill: "#395c6e"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8,72.1h.1a.9.9,0,0,1-.9-.9h-.1v.2a1.1,1.1,0,0,0,.9.8h0Z",
    fill: "#395c6e"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,71.2h0c-.1,0-.1,0-.1.1a.4.4,0,0,0,.1.3c.1.4.4.6.9.7h0A.9.9,0,0,1,31.8,71.2Z",
    fill: "#395c6e"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,71.4v-.2h0a.1.1,0,0,0-.1.1h0a.9.9,0,0,1-.9.9h.1A1.2,1.2,0,0,0,33.7,71.4Z",
    fill: "#395c6e"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,72.4a.4.4,0,0,0-.1-.3h0a.9.9,0,0,1-1.8,0h-.1v.2a1,1,0,0,0,.9.7A1,1,0,0,0,30.8,72.4Z",
    fill: "#395c6e"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,72.1Z",
    fill: "#395c6e"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7,72.4a.3.3,0,0,1,.1-.2h-.1a.9.9,0,0,1-.9.8,1,1,0,0,1-1-.8h-.1a.4.4,0,0,1,.1.3,1,1,0,0,0,1,.7A1,1,0,0,0,32.7,72.4Z",
    fill: "#395c6e"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2,71.1h0Z",
    fill: "#395c6e"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8,71.2h0Z",
    fill: "#395c6e"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,71.2h-.1a.4.4,0,0,1-.1.3h.1v-.4Z",
    fill: "#395c6e"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,82.2Z",
    fill: "#395c6e"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,83.2a.9.9,0,0,1-.9-.9v.3a1,1,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 83.2 35.6 83.2 35.6 83.2 35.6 83.2 35.6 83.2",
    fill: "#395c6e"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7,82.3h-.1a.9.9,0,0,1-.9.9h.1a1,1,0,0,0,.9-.7v-.3Z",
    fill: "#395c6e"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,83.2Z",
    fill: "#395c6e"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,83.3h0c0,.2-.1.3-.2.5h.1a.4.4,0,0,0,.1-.3Z",
    fill: "#395c6e"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.6 83.2 35.6 83.2 35.6 83.2 35.6 83.2",
    fill: "#395c6e"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,83.2h-.1v.5h.1a.9.9,0,0,1-.1-.5Z",
    fill: "#395c6e"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,83.2h0v.2h0v-.3Z",
    fill: "#395c6e"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,83.3h-.1v.3h0c.1,0,.1-.1.1-.2Z",
    fill: "#395c6e"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3,81.2h0Z",
    fill: "#395c6e"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4,81.2h0Z",
    fill: "#395c6e"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,81.2h0Z",
    fill: "#395c6e"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,81.5v-.3h0a.9.9,0,0,1-1.8,0h-.1v.2a1,1,0,0,0,1,.7A1,1,0,0,0,35.6,81.5Z",
    fill: "#395c6e"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,81.2Z",
    fill: "#395c6e"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6,81.2h0v.3h0Z",
    fill: "#395c6e"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7,81.5v-.2h-.1a1,1,0,0,1-.7.9h0A1.1,1.1,0,0,0,33.7,81.5Z",
    fill: "#395c6e"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,60.1h0A.1.1,0,0,1,25,60h0A.1.1,0,0,0,24.9,60.1Z",
    fill: "#395c6e"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61a1.1,1.1,0,0,1-1-.9v.3a.9.9,0,0,0,.7.6H26Z",
    fill: "#395c6e"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 61 26 61 26 61 26 61 26 61",
    fill: "#395c6e"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M24,61h0a.9.9,0,0,1-.9-.9h0a.3.3,0,0,1-.1.2,1.2,1.2,0,0,0,.7.7Z",
    fill: "#395c6e"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M25,60.4v-.3h0a.1.1,0,0,0-.1.1h0a.9.9,0,0,1-.9.9h.3A1.1,1.1,0,0,0,25,60.4Z",
    fill: "#395c6e"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 61 26 61 26 61 26 61",
    fill: "#395c6e"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,61h0Z",
    fill: "#395c6e"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61Z",
    fill: "#395c6e"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,58h0Z",
    fill: "#395c6e"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M26,58.9a1.1,1.1,0,0,1-1-.8v.2a1,1,0,0,0,.9.7h0A.1.1,0,0,1,26,58.9Z",
    fill: "#395c6e"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 58.9 26 58.9 26 58.9 26 58.9 26 58.9",
    fill: "#395c6e"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,59h0a1,1,0,0,0,.9-.7v-.2h-.1a.9.9,0,0,1-.9.8A.1.1,0,0,1,24.1,59Z",
    fill: "#395c6e"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M24,59h0a.9.9,0,0,1-.9-.9h0a.4.4,0,0,1-.1.3A1,1,0,0,0,24,59Z",
    fill: "#395c6e"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M25,60a1.2,1.2,0,0,0,1-.7.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-1.8,0h0a.1.1,0,0,0-.1-.1h0v.3A1,1,0,0,0,25,60Z",
    fill: "#395c6e"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 58.9 26 58.9 26 58.9 26 58.9",
    fill: "#395c6e"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M26,58.9h0a.1.1,0,0,0-.1.1h0a.4.4,0,0,0,.1.3h0Z",
    fill: "#395c6e"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M22,59a.9.9,0,0,1-.1.5H22c0-.1.1-.2.1-.3A.4.4,0,0,1,22,59Z",
    fill: "#395c6e"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M24,59.3V59h0a1.1,1.1,0,0,1-1,1h.1A.9.9,0,0,0,24,59.3Z",
    fill: "#395c6e"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,59H22a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0A1,1,0,0,1,22.1,59Z",
    fill: "#395c6e"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M23,60.3a.3.3,0,0,0,.1-.2H23a1,1,0,0,1-.4.8h0C22.8,60.7,23,60.5,23,60.3Z",
    fill: "#395c6e"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 56.9 26 56.9 26 56.9 26 56.9 26 56.9",
    fill: "#395c6e"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M26,56.9a1.1,1.1,0,0,1-1-.9v.3a1,1,0,0,0,.9.7h0C25.9,56.9,25.9,56.9,26,56.9Z",
    fill: "#395c6e"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M25,56Z",
    fill: "#395c6e"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M24,56.9a.9.9,0,0,1-.9-.9h0c0,.1,0,.2-.1.2a1,1,0,0,0,1,.8h0Z",
    fill: "#395c6e"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,56h0a.9.9,0,0,1-.9.9c.1,0,.1,0,.1.1h0a1,1,0,0,0,.9-.7V56h-.1Z",
    fill: "#395c6e"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M25,58a1.2,1.2,0,0,0,1-.7.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-1.8,0h0c0-.1,0-.1-.1-.1h0v.2A1,1,0,0,0,25,58Z",
    fill: "#395c6e"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 56.9 26 56.9 26 56.9 26 56.9",
    fill: "#395c6e"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M26,56.9h0c-.1,0-.1,0-.1.1h0a.4.4,0,0,0,.1.3h0Z",
    fill: "#395c6e"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,57.3A.4.4,0,0,1,22,57a.8.8,0,0,1-.8.9h0A1,1,0,0,0,22.1,57.3Z",
    fill: "#395c6e"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,57H22a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0A.9.9,0,0,1,22.1,57Z",
    fill: "#395c6e"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M24,57.2V57h0a1,1,0,0,1-1,.9.1.1,0,0,1,.1.1h0A.9.9,0,0,0,24,57.2Z",
    fill: "#395c6e"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M23,58.3a.4.4,0,0,0,.1-.3h0a.1.1,0,0,0-.1-.1h0a.9.9,0,0,1-.9.9l-.5-.2v.2h.5A1,1,0,0,0,23,58.3Z",
    fill: "#395c6e"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M25,53.9Z",
    fill: "#395c6e"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,55h0c0-.1,0-.1.1-.1a1.1,1.1,0,0,1-1-.9v.3A1,1,0,0,0,25.9,55Z",
    fill: "#395c6e"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 54.9 26 54.9 26 54.9 26 54.9 26 54.9",
    fill: "#395c6e"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M24,55h0a.9.9,0,0,1-.9-.9h0c0,.1,0,.1-.1.2A1.1,1.1,0,0,0,24,55Z",
    fill: "#395c6e"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,54h0a.9.9,0,0,1-.9.9c.1,0,.1,0,.1.1h0a1,1,0,0,0,.9-.7V54h-.1Z",
    fill: "#395c6e"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 54.9 26 54.9 26 54.9 26 54.9",
    fill: "#395c6e"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M24,55v.2a1.1,1.1,0,0,0,1,.8,1.2,1.2,0,0,0,1-.7.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-1.8,0h0c0-.1,0-.1-.1-.1Z",
    fill: "#395c6e"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,55h0a.4.4,0,0,0,.1.3h0v-.4h0C25.9,54.9,25.9,54.9,25.9,55Z",
    fill: "#395c6e"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,55.9a.1.1,0,0,1,.1.1h0a1,1,0,0,0,.9-.7A.4.4,0,0,1,22,55a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1,55Z",
    fill: "#395c6e"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,55.9a.9.9,0,0,1-.9-.9v.3a.9.9,0,0,0,.9.7h0Z",
    fill: "#395c6e"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2,55h-.1a.9.9,0,0,1-.1.5h0l.2-.3Z",
    fill: "#395c6e"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M23,56h0a.9.9,0,0,1-.9-.9H22a.4.4,0,0,0,.1.3A1,1,0,0,0,23,56Z",
    fill: "#395c6e"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1,56h0a1,1,0,0,0,.9-.8V55h0a1,1,0,0,1-1,.9C23.1,55.9,23.1,55.9,23.1,56Z",
    fill: "#395c6e"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,56.3V56h0a1,1,0,0,1-.5.8h.1A1,1,0,0,0,21.1,56.3Z",
    fill: "#395c6e"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,55.9h0a.1.1,0,0,1,.1.1h0A.1.1,0,0,0,21.1,55.9Z",
    fill: "#395c6e"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M23,56.2c.1,0,.1-.1.1-.2h0c0-.1,0-.1-.1-.1h0a.9.9,0,1,1-1.8,0h0a.1.1,0,0,0-.1-.1h0v.3a1,1,0,0,0,1,.7A.9.9,0,0,0,23,56.2Z",
    fill: "#395c6e"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,52.9h-.2c0,.1.1.1.2.1Z",
    fill: "#395c6e"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3,52.9h0Z",
    fill: "#395c6e"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M24,52.9h-.2c0,.1.1.1.2.1Z",
    fill: "#395c6e"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M24,53v.2a1,1,0,0,0,1,.7,1.2,1.2,0,0,0,1-.7.4.4,0,0,1-.1-.3h0a.9.9,0,0,1-1.8,0H24Z",
    fill: "#395c6e"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    points: "24 52.9 24 52.9 24 52.9 24 52.9",
    fill: "#395c6e"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M26,53.2h0v-.3h-.1A.4.4,0,0,0,26,53.2Z",
    fill: "#395c6e"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1,53Z",
    fill: "#395c6e"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,54h0a.9.9,0,0,1-.9-.9v.3A.9.9,0,0,0,21.1,54Z",
    fill: "#395c6e"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,53.9h.1a1,1,0,0,0,.9-.7A.4.4,0,0,1,22,53a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1,53h0a.9.9,0,0,1-.9.9h.1a1.3,1.3,0,0,0,.9-.7V53h-.1Z",
    fill: "#395c6e"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M24,53h0a1,1,0,0,1-1,.9h.1a1,1,0,0,0,.9-.8V53h0Z",
    fill: "#395c6e"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M22,53a.4.4,0,0,0,.1.3,1,1,0,0,0,.9.7h0a.9.9,0,0,1-.9-.9h0A.1.1,0,0,0,22,53Z",
    fill: "#395c6e"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,54.2V54h0a1.1,1.1,0,0,1-.9.9l-.6-.2h.1l.5.2A.9.9,0,0,0,21.1,54.2Z",
    fill: "#395c6e"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,53.9Z",
    fill: "#395c6e"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1,53.9h0v.2a1,1,0,0,0,1,.8,1.1,1.1,0,0,0,.9-.8c.1-.1.1-.1.1-.2H23a.9.9,0,1,1-1.8,0h-.1Z",
    fill: "#395c6e"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,67.1h-.4v.2Z",
    fill: "#395c6e"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 67 26 67 26 67 26 67 26 67",
    fill: "#395c6e"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,67.1h0c0,.2,0,.3-.1.4h0l.2-.2A.4.4,0,0,1,25.9,67.1Z",
    fill: "#395c6e"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 67 26 67 26 67 26 67",
    fill: "#395c6e"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M26,67h-.1a.4.4,0,0,0,.1.3h0Z",
    fill: "#395c6e"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 65 26 65 26 65 26 65 26 65",
    fill: "#395c6e"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M26,65a1.1,1.1,0,0,1-1-.9v.3a1,1,0,0,0,.9.7H26Z",
    fill: "#395c6e"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9,64.1Z",
    fill: "#395c6e"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M25,64.4v-.3h-.1a.9.9,0,0,1-.4.8h.1Z",
    fill: "#395c6e"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M26,65.4a.4.4,0,0,1-.1-.3h0a1,1,0,0,1-.8.9h0A1.6,1.6,0,0,0,26,65.4Z",
    fill: "#395c6e"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 65 26 65 26 65 26 65",
    fill: "#395c6e"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M26,65h-.1a.4.4,0,0,0,.1.3h0Z",
    fill: "#395c6e"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 63 26 63 26 63 26 63 26 63",
    fill: "#395c6e"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,63.1H26a1.1,1.1,0,0,1-1-.9v.3A1,1,0,0,0,25.9,63.1Z",
    fill: "#395c6e"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M25,62h0a.1.1,0,0,0-.1.1h0A.1.1,0,0,1,25,62Z",
    fill: "#395c6e"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,63h0a1,1,0,0,0,.9-.7v-.3h0a.1.1,0,0,0-.1.1h0a.9.9,0,0,1-.9.9Z",
    fill: "#395c6e"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M24,63h0l-.5-.2V63H24Z",
    fill: "#395c6e"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M26,63.3c-.1-.1-.1-.1-.1-.2h0a.9.9,0,0,1-1.8,0H24v.2a1,1,0,0,0,1,.7A1.2,1.2,0,0,0,26,63.3Z",
    fill: "#395c6e"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    points: "26 63 26 63 26 63 26 63",
    fill: "#395c6e"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,63h0c0,.1,0,.1.1.2h0V63h-.1Z",
    fill: "#395c6e"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M24,63.1h0c0,.1-.1.3-.1.4h0a.4.4,0,0,0,.1-.3Z",
    fill: "#395c6e"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,61.1h0Z",
    fill: "#395c6e"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7,61h0Z",
    fill: "#395c6e"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1,61h0Z",
    fill: "#395c6e"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9,61h0a.9.9,0,0,1-1.8,0H24v.2a1,1,0,0,0,1,.7,1.2,1.2,0,0,0,1-.7A.4.4,0,0,1,25.9,61Z",
    fill: "#395c6e"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M24,61Z",
    fill: "#395c6e"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M26,61h-.1a.4.4,0,0,0,.1.3h0Z",
    fill: "#395c6e"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M24,61.3v-.2h0a1.1,1.1,0,0,1-.9.9h.1A1.1,1.1,0,0,0,24,61.3Z",
    fill: "#395c6e"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 51.6,
    width: 2.2,
    height: 16.65,
    fill: "#98aab6"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    points: "18.8 56.3 5.4 83.8 32.1 83.8 18.8 56.3",
    fill: "#395c6e"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,62.4H15.7c-.1,0-.1,0-.1-.1h6.3C21.9,62.4,21.9,62.4,21.8,62.4Z",
    fill: "#98aab6"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,68.2h0Z",
    fill: "#98aab6"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9,73.2H10.7a.1.1,0,0,1-.1-.1H27A.1.1,0,0,1,26.9,73.2Z",
    fill: "#98aab6"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,78.4h.1A.1.1,0,0,1,29.4,78.4Z",
    fill: "#98aab6"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2,
    y: 62.6,
    width: 5,
    height: 5.18,
    fill: "#fff"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 63.4,
    width: 3.4,
    height: 3.58,
    fill: "#98aab6"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4,65.2H18.8V63.4h-.1a.1.1,0,0,0-.1.1v1.8h0V67h.2V65.3h1.6Z",
    fill: "#fff"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,72.2V84.1h5V72.2Z",
    fill: "#fff"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 73,
    width: 3.4,
    height: 10.01,
    fill: "#fdd058"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8,
    cy: 77.9,
    r: 0.3,
    fill: "#fff"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 72.2,
    width: 3,
    height: 6.94,
    fill: "#fff"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 23.3,
    y: 73,
    width: 1.4,
    height: 5.34,
    fill: "#98aab6"
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 73,
    x2: 24,
    y2: 78.3,
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.32
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9,
    y: 72.2,
    width: 3,
    height: 6.94,
    fill: "#fff"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 73,
    width: 1.4,
    height: 5.34,
    fill: "#98aab6"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 13.4,
    y1: 73,
    x2: 13.4,
    y2: 78.3,
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.32
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 61.6,
    width: 2.3,
    height: 0.18,
    fill: "#fff"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 53.1,
    width: 2.3,
    height: 0.18,
    fill: "#fff"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    points: "32.1 83.8 33.7 83.8 18.8 53 3.8 83.8 5.4 83.8 18.8 56.3 32.1 83.8",
    fill: "#fdd058"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.1,
    cy: 97.2,
    r: 3.4,
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.87
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.1,
    cy: 97.2,
    r: 1.1,
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "78.9 93.8 79.2 96.1 79.6 96.2 80.6 94.1",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "79.4 100.6 79.1 98.3 78.7 98.2 77.7 100.3",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    points: "82.6 97 80.2 97.2 80.2 97.7 82.2 98.7",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    points: "75.7 97.4 78 97.2 78.1 96.8 76 95.8",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    points: "81.4 94.6 79.9 96.4 80.2 96.8 82.4 96",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    points: "76.9 99.8 78.4 98 78.1 97.6 75.9 98.4",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    points: "81.7 99.5 79.9 98 79.5 98.2 80.3 100.4",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    points: "76.6 95 78.4 96.4 78.7 96.2 78 94",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 97.2,
    r: 3.4,
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.87
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 97.2,
    r: 1.1,
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    points: "93.1 93.8 93.3 96.1 93.7 96.2 94.8 94.2",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    points: "93.2 100.6 93.1 98.3 92.7 98.2 91.6 100.2",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    points: "96.6 97.2 94.3 97.3 94.2 97.7 96.2 98.8",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    points: "89.8 97.3 92.1 97.1 92.2 96.7 90.2 95.6",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    points: "95.6 94.8 94 96.5 94.2 96.9 96.5 96.2",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    points: "90.8 99.7 92.4 97.9 92.1 97.6 89.9 98.2",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    points: "95.6 99.6 93.9 98 93.5 98.3 94.2 100.5",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    points: "90.7 94.8 92.5 96.4 92.8 96.2 92.2 93.9",
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M101.3,111.4a.8.8,0,0,0-1-.8.6.6,0,0,0,.1-.4H99.3v-2.6c.3-.5.6-.6.9-.5a2.1,2.1,0,0,0-1.5-1.5s-1.9-2-3.7-3.6l-.4-.4H77.4l-2.5,4.4s-6.2,0-7.3.6-.4.4-.6.6h0s.4.3.3,1.5a1.6,1.6,0,0,1-1,1.4,3.7,3.7,0,0,0-.9,1.8c-.1,1-.2,2.2-.2,2.2h36.1A24.3,24.3,0,0,0,101.3,111.4Z",
    fill: "#395c6e"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3,100.8H78.8a1.7,1.7,0,0,0-1.3.8H94.6A2.9,2.9,0,0,0,92.3,100.8Z",
    fill: "#fbe7ab"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3,107.6v2.6h1.1a8.5,8.5,0,0,0-.2-3.1C99.9,107,99.6,107.1,99.3,107.6Z",
    fill: "#bbc7d0"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3,108.8c.2-1.3-.3-1.5-.3-1.5h0a2.5,2.5,0,0,0-.7,2.9A1.6,1.6,0,0,0,67.3,108.8Z",
    fill: "#bbc7d0"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4,112H66a.4.4,0,0,1,.4.4,1.2,1.2,0,0,1-1.2,1.3Z",
    fill: "#bbc7d0"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M77,106.1l1.6-3.6h8.1v3.6Z",
    fill: "#e2e6ec"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.2 102.5 88.2 106.1 95.8 106.1 92.9 102.5 88.2 102.5",
    fill: "#e2e6ec"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 114.2,
    r: 3.4,
    fill: "#395c6e"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2,114.2s.1-4.4,4.5-4.4,4.2,4.4,4.2,4.4",
    fill: "#fbe7ab"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M90,114.2s.1-4.4,4.4-4.4,4.2,4.4,4.2,4.4",
    fill: "#fbe7ab"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.6,
    cy: 114.2,
    r: 3.4,
    fill: "#395c6e"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.6,
    cy: 114.2,
    r: 2.2,
    fill: "#e2e6ec"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 114.2,
    r: 3.4,
    fill: "#395c6e"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 114.2,
    r: 2.2,
    fill: "#e2e6ec"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9,109.1a4.7,4.7,0,0,1,3.4-1.1H99v1.1Z",
    fill: "#98aab6"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 112.7,
    r: 0.4,
    fill: "#98aab6"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 115.7,
    r: 0.4,
    fill: "#98aab6"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.4,
    cy: 113.1,
    r: 0.4,
    fill: "#98aab6"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 115.3,
    r: 0.4,
    fill: "#98aab6"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.2,
    cy: 113.1,
    r: 0.4,
    fill: "#98aab6"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.4,
    cy: 115.3,
    r: 0.4,
    fill: "#98aab6"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.8,
    cy: 114.2,
    r: 0.4,
    fill: "#98aab6"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.8,
    cy: 114.2,
    r: 0.4,
    fill: "#98aab6"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.3,
    cy: 114.2,
    r: 0.9,
    fill: "#98aab6"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.6,
    cy: 112.7,
    r: 0.4,
    fill: "#98aab6"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.6,
    cy: 115.7,
    r: 0.4,
    fill: "#98aab6"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.7,
    cy: 113.1,
    r: 0.4,
    fill: "#98aab6"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 115.3,
    r: 0.4,
    fill: "#98aab6"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 113.1,
    r: 0.4,
    fill: "#98aab6"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.7,
    cy: 115.3,
    r: 0.4,
    fill: "#98aab6"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.1,
    cy: 114.2,
    r: 0.4,
    fill: "#98aab6"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.1,
    cy: 114.2,
    r: 0.4,
    fill: "#98aab6"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.6,
    cy: 114.2,
    r: 0.9,
    fill: "#98aab6"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6,96.8l-5.1-4.9-7.1-.3.4-1.6-.4-.2h-.6c-.6,0-.7-.4-.9-.3s-.2.6.6.7h.6l-2.3,6.9c-.1.3.3.8.7.1L81,92.7l6.1,5.1h5.8a.8.8,0,0,0,.7-.2A.7.7,0,0,0,93.6,96.8Zm-6.5-.1h-.2l-5.4-4.3v-.2a.1.1,0,0,1,.1-.1h0l6.2.2h.1v.2Zm5.9.1h0c-.2,0-.2.2-.2.3h-.1l-5,.2h-.1l.9-4.4c0-.1,0-.1.1-.1h.1C93.1,96.4,93,96.7,93,96.8Z",
    fill: "#395c6e"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3,
    cy: 97.2,
    r: 1.3,
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3,90.4a3.1,3.1,0,0,1-1.6.2c-1.2-.2-1,.5-.8.5a3.5,3.5,0,0,1,1.5,0c.8.2,1.6-.7,1.6-.7S89.9,90.1,89.3,90.4Z",
    fill: "#395c6e"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.3 91 88 92.8 88.4 92.8 88.7 91 88.3 91",
    fill: "#395c6e"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    points: "75 114.7 90.9 114.7 90.9 113.1 75.2 113.1 75 114.7",
    fill: "#fbe7ab"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 79.9,
    y1: 102.4,
    x2: 79.9,
    y2: 106.8,
    fill: "none",
    stroke: "#395c6e",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M144.4,107.6l-.5-3.1s-1.1.4-1.3.9a8.8,8.8,0,0,0,.3,2.2Z",
    fill: "#395c6e"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M151.7,107l.5-2.4s-1.6-.6-2.2,1.5S151.7,107,151.7,107Z",
    fill: "#395c6e"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M116.7,114h45.8a16.9,16.9,0,0,0,4.4-1.2c2.2-1.1,1.5-2.9,1.5-2.9h-3.9c-1,.4.5,1.9.5,1.9l-.8.2s-.7-4.1-5.7-4.6a6.9,6.9,0,0,0-6.8,4.2h-20s-1-4.2-6.2-4.2a6.4,6.4,0,0,0-6.4,4.2h-4a5.2,5.2,0,0,0,.2,1.1C115.9,114,116.7,114,116.7,114Z",
    fill: "#fdd058"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 114,
    r: 4.5,
    fill: "#395c6e"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5,116.7a2.8,2.8,0,0,1-2.8-2.7,2.9,2.9,0,0,1,2.8-2.8,2.8,2.8,0,0,1,2.7,2.8A2.7,2.7,0,0,1,125.5,116.7Z",
    fill: "#e2e6ec"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5,116.3a2.3,2.3,0,0,1-2.3-2.3,2.3,2.3,0,0,1,4.6,0A2.3,2.3,0,0,1,125.5,116.3Z",
    fill: "#bbc7d0"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 114,
    r: 4.5,
    fill: "#395c6e"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M158,116.7a2.7,2.7,0,0,1-2.7-2.7,2.8,2.8,0,0,1,2.7-2.8,2.9,2.9,0,0,1,2.8,2.8A2.8,2.8,0,0,1,158,116.7Z",
    fill: "#e2e6ec"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M158,116.3a2.4,2.4,0,0,1-2.3-2.3,2.3,2.3,0,0,1,2.3-2.3,2.3,2.3,0,0,1,2.3,2.3A2.3,2.3,0,0,1,158,116.3Z",
    fill: "#bbc7d0"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M126,114.3a10.5,10.5,0,0,0,1.8.3,2.9,2.9,0,0,0,0-1.3l-1.8.3-.2-.2a9.9,9.9,0,0,0,.3-1.7,1.5,1.5,0,0,0-1.3,0,6.1,6.1,0,0,0,.4,1.7l-.2.2-1.8-.3a2.9,2.9,0,0,0,0,1.3l1.8-.3c0,.1.1.1.2.2a6.5,6.5,0,0,0-.4,1.8,2.8,2.8,0,0,0,1.3,0,10.5,10.5,0,0,0-.3-1.8Z",
    fill: "#e2e6ec"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M158.5,114.3l1.8.3a2.9,2.9,0,0,0,0-1.3l-1.8.3-.2-.2a6.1,6.1,0,0,0,.4-1.7,1.5,1.5,0,0,0-1.3,0,9.9,9.9,0,0,0,.3,1.7l-.2.2-1.8-.3a2.9,2.9,0,0,0,0,1.3,10.5,10.5,0,0,0,1.8-.3l.2.2a10.5,10.5,0,0,0-.3,1.8,2.8,2.8,0,0,0,1.3,0,6.5,6.5,0,0,0-.4-1.8C158.4,114.4,158.5,114.4,158.5,114.3Z",
    fill: "#e2e6ec"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M166.8,110.9s.3-.9.9-.9v-.3h-1l-.4-2.9h.7c-.4-.9-1-1-1-1l-6.5-.5a2.8,2.8,0,0,1-1,.8H134.9a1.9,1.9,0,0,0-.2.8l-1.2-1.5s-2.2-.5-1.5-1.2c-12.3.4-16.3,4-16.3,4l.3,1.9c-.7,0-.9.6-.9,1.5h4a6.4,6.4,0,0,1,6.4-4.2c5.2,0,6.2,4.2,6.2,4.2h20a6.9,6.9,0,0,1,6.8-4.2c5,.5,5.7,4.6,5.7,4.6l1.5-.2A1.7,1.7,0,0,0,166.8,110.9Z",
    fill: "#fbde8b"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M166.7,109.7h1a7.6,7.6,0,0,0-.7-2.9h-.7Z",
    fill: "#e2e6ec"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M146.4,112h-.3l.9-3.9c.4-1.6.1-2,.1-2l.2-.2c0,.1.5.5,0,2.3Z",
    fill: "#fdd058"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M147.8,110.9H130.9v-.3h16.9c2.1,0,3.1-2.9,3.1-3l.7-1.7h.2l-.6,1.7C151.1,107.9,150.1,110.9,147.8,110.9Z",
    fill: "#fdd058"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 137.7,
    y1: 105.2,
    x2: 137.7,
    y2: 106.1,
    fill: "#e2e6ec"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M137.6,100.9h-.8l-.7.4h.8l-2.8,3.6a11.9,11.9,0,0,1-2.5-.1,6.6,6.6,0,0,0,2.4.9h1c.8-2.2,3.5-4.8,3.5-4.8Z",
    fill: "#fbde8b"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5,105.8H134l-.2.3h1.1c0-.1.1-.2.1-.4Z",
    fill: "#395c6e"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M154,104.3c-1.1.1-2.1,1.5-2.1,1.5H135c0,.2-.1.3-.1.4h23.6a2.8,2.8,0,0,0,1-.8h-.7A38.4,38.4,0,0,0,154,104.3Z",
    fill: "#395c6e"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M133.2,107.4h3.9a.7.7,0,0,0,.6-.5v-1.7c0-.5-.4-.2-.9-.2h-5.5l2.5,1.3A1.6,1.6,0,0,0,133.2,107.4Z",
    fill: "#fbde8b"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M132.9,111.9c0-.1-1.2-3.1-1.5-4.5s2.2-3.2,2.3-3.3l.2.2c-.1,0-2.5,1.9-2.2,3.1s1.5,4.4,1.5,4.4Z",
    fill: "#fdd058"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M116.9,108.5l-.2-.2c.2-.1,4-2.6,15.4-3.7v.3C120.8,105.9,116.9,108.5,116.9,108.5Z",
    fill: "#fdd058"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M134.1,105l2.8-3.6h-.8a22.1,22.1,0,0,0-4.8,3.4A10.9,10.9,0,0,0,134.1,105Z",
    fill: "#e2e6ec"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M116,108.2h1a1.4,1.4,0,0,1,1.1.5l.6,1.5h-2.3Z",
    fill: "#e2e6ec"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M134.2,104.8h1.1a.7.7,0,0,1,.6-.5h1.6s.4,0,.5.3a7.8,7.8,0,0,1,.1,1.3s0,.5-.2.5h-5Z",
    fill: "#fbde8b"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M133.9,105.2h-1.3s-1.5-.2-1.3-.5l.5-.5a3.1,3.1,0,0,0,1.3.6h1.1Z",
    fill: "#fbde8b"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5,106.7s.9-1.7,1.8-1.7l3.3-.2s1.4,1.2-1.2,1.5Z",
    fill: "#fbde8b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousesAndCars);
export default __webpack_public_path__ + "static/media/houses-and-cars.080dd833.svg";
export { ForwardRef as ReactComponent };